/**
@license

DHTMLX Richtext v.2.0.1 

This software is covered by DHTMLX Evaluation License and purposed only for evaluation.
Contact sales@dhtmlx.com to get Commercial or Enterprise license.
Usage without proper license is prohibited.

(c) XB Software.

**/
var Yn = Array.isArray, Wn = Array.from, Ko = Object.defineProperty, qe = Object.getOwnPropertyDescriptor, _r = Object.getOwnPropertyDescriptors, Go = Object.prototype, jo = Array.prototype, Gt = Object.getPrototypeOf;
function rt(n) {
  return typeof n == "function";
}
const se = () => {
};
function Vo(n) {
  for (var e = 0; e < n.length; e++)
    n[e]();
}
const Pe = 2, vr = 4, St = 8, tn = 16, Ce = 32, Et = 64, $e = 128, jt = 256, me = 512, Qe = 1024, nn = 2048, Ee = 4096, Tt = 8192, xr = 16384, ut = 32768, Yo = 65536, yr = 1 << 18, mr = 1 << 19, st = Symbol("$state"), Wo = Symbol("");
function br(n) {
  return n === this.v;
}
function rn(n, e) {
  return n != n ? e == e : n !== e || n !== null && typeof n == "object" || typeof n == "function";
}
function Jn(n) {
  return !rn(n, this.v);
}
function Jo(n) {
  throw new Error("effect_in_teardown");
}
function Xo() {
  throw new Error("effect_in_unowned_derived");
}
function Zo(n) {
  throw new Error("effect_orphan");
}
function Qo() {
  throw new Error("effect_update_depth_exceeded");
}
function $o(n) {
  throw new Error("props_invalid_value");
}
function es() {
  throw new Error("state_descriptors_fixed");
}
function ts() {
  throw new Error("state_prototype_fixed");
}
function ns() {
  throw new Error("state_unsafe_local_read");
}
function is() {
  throw new Error("state_unsafe_mutation");
}
function ye(n) {
  return {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: n,
    reactions: null,
    equals: br,
    version: 0
  };
}
function z(n) {
  return /* @__PURE__ */ rs(ye(n));
}
// @__NO_SIDE_EFFECTS__
function Xn(n, e = !1) {
  const t = ye(n);
  return e || (t.equals = Jn), re !== null && re.l !== null && (re.l.s ??= []).push(t), t;
}
// @__NO_SIDE_EFFECTS__
function rs(n) {
  return ne !== null && ne.f & Pe && (Te === null ? ks([n]) : Te.push(n)), n;
}
function T(n, e) {
  return ne !== null && an() && ne.f & (Pe | tn) && // If the source was created locally within the current derived, then
  // we allow the mutation.
  (Te === null || !Te.includes(n)) && is(), An(n, e);
}
function An(n, e) {
  return n.equals(e) || (n.v = e, n.version = Br(), wr(n, Qe), an() && $ !== null && $.f & me && !($.f & Ce) && (pe !== null && pe.includes(n) ? (De($, Qe), cn($)) : Ke === null ? Cs([n]) : Ke.push(n))), e;
}
function wr(n, e) {
  var t = n.reactions;
  if (t !== null)
    for (var i = an(), r = t.length, o = 0; o < r; o++) {
      var s = t[o], a = s.f;
      a & Qe || !i && s === $ || (De(s, e), a & (me | $e) && (a & Pe ? wr(
        /** @type {Derived} */
        s,
        nn
      ) : cn(
        /** @type {Effect} */
        s
      )));
    }
}
const Zn = 1, Qn = 2, kr = 4, os = 8, ss = 16, as = 1, ls = 2, cs = 4, us = 8, ds = 16, fs = 4, hs = 1, ps = 2, ve = Symbol();
let Cr = !1;
function M(n, e = null, t) {
  if (typeof n != "object" || n === null || st in n)
    return n;
  const i = Gt(n);
  if (i !== Go && i !== jo)
    return n;
  var r = /* @__PURE__ */ new Map(), o = Yn(n), s = ye(0);
  o && r.set("length", ye(
    /** @type {any[]} */
    n.length
  ));
  var a;
  return new Proxy(
    /** @type {any} */
    n,
    {
      defineProperty(u, l, c) {
        (!("value" in c) || c.configurable === !1 || c.enumerable === !1 || c.writable === !1) && es();
        var d = r.get(l);
        return d === void 0 ? (d = ye(c.value), r.set(l, d)) : T(d, M(c.value, a)), !0;
      },
      deleteProperty(u, l) {
        var c = r.get(l);
        if (c === void 0)
          l in u && r.set(l, ye(ve));
        else {
          if (o && typeof l == "string") {
            var d = (
              /** @type {Source<number>} */
              r.get("length")
            ), f = Number(l);
            Number.isInteger(f) && f < d.v && T(d, f);
          }
          T(c, ve), Fi(s);
        }
        return !0;
      },
      get(u, l, c) {
        if (l === st)
          return n;
        var d = r.get(l), f = l in u;
        if (d === void 0 && (!f || qe(u, l)?.writable) && (d = ye(M(f ? u[l] : ve, a)), r.set(l, d)), d !== void 0) {
          var h = p(d);
          return h === ve ? void 0 : h;
        }
        return Reflect.get(u, l, c);
      },
      getOwnPropertyDescriptor(u, l) {
        var c = Reflect.getOwnPropertyDescriptor(u, l);
        if (c && "value" in c) {
          var d = r.get(l);
          d && (c.value = p(d));
        } else if (c === void 0) {
          var f = r.get(l), h = f?.v;
          if (f !== void 0 && h !== ve)
            return {
              enumerable: !0,
              configurable: !0,
              value: h,
              writable: !0
            };
        }
        return c;
      },
      has(u, l) {
        if (l === st)
          return !0;
        var c = r.get(l), d = c !== void 0 && c.v !== ve || Reflect.has(u, l);
        if (c !== void 0 || $ !== null && (!d || qe(u, l)?.writable)) {
          c === void 0 && (c = ye(d ? M(u[l], a) : ve), r.set(l, c));
          var f = p(c);
          if (f === ve)
            return !1;
        }
        return d;
      },
      set(u, l, c, d) {
        var f = r.get(l), h = l in u;
        if (o && l === "length")
          for (var g = c; g < /** @type {Source<number>} */
          f.v; g += 1) {
            var _ = r.get(g + "");
            _ !== void 0 ? T(_, ve) : g in u && (_ = ye(ve), r.set(g + "", _));
          }
        f === void 0 ? (!h || qe(u, l)?.writable) && (f = ye(void 0), T(f, M(c, a)), r.set(l, f)) : (h = f.v !== ve, T(f, M(c, a)));
        var v = Reflect.getOwnPropertyDescriptor(u, l);
        if (v?.set && v.set.call(d, c), !h) {
          if (o && typeof l == "string") {
            var k = (
              /** @type {Source<number>} */
              r.get("length")
            ), x = Number(l);
            Number.isInteger(x) && x >= k.v && T(k, x + 1);
          }
          Fi(s);
        }
        return !0;
      },
      ownKeys(u) {
        p(s);
        var l = Reflect.ownKeys(u).filter((f) => {
          var h = r.get(f);
          return h === void 0 || h.v !== ve;
        });
        for (var [c, d] of r)
          d.v !== ve && !(c in u) && l.push(c);
        return l;
      },
      setPrototypeOf() {
        ts();
      }
    }
  );
}
function Fi(n, e = 1) {
  T(n, n.v + e);
}
var at, Sr, Er;
function gs() {
  if (at === void 0) {
    at = window;
    var n = Element.prototype, e = Node.prototype;
    Sr = qe(e, "firstChild").get, Er = qe(e, "nextSibling").get, n.__click = void 0, n.__className = "", n.__attributes = null, n.__styles = null, n.__e = void 0, Text.prototype.__t = void 0;
  }
}
function At(n = "") {
  return document.createTextNode(n);
}
// @__NO_SIDE_EFFECTS__
function mt(n) {
  return Sr.call(n);
}
// @__NO_SIDE_EFFECTS__
function on(n) {
  return Er.call(n);
}
function P(n, e) {
  return /* @__PURE__ */ mt(n);
}
function U(n, e) {
  {
    var t = (
      /** @type {DocumentFragment} */
      /* @__PURE__ */ mt(
        /** @type {Node} */
        n
      )
    );
    return t instanceof Comment && t.data === "" ? /* @__PURE__ */ on(t) : t;
  }
}
function K(n, e = 1, t = !1) {
  let i = n;
  for (; e--; )
    i = /** @type {TemplateNode} */
    /* @__PURE__ */ on(i);
  return i;
}
function _s(n) {
  n.textContent = "";
}
// @__NO_SIDE_EFFECTS__
function j(n) {
  var e = Pe | Qe;
  $ === null ? e |= $e : $.f |= mr;
  const t = {
    children: null,
    ctx: re,
    deps: null,
    equals: br,
    f: e,
    fn: n,
    reactions: null,
    v: (
      /** @type {V} */
      null
    ),
    version: 0,
    parent: $
  };
  if (ne !== null && ne.f & Pe) {
    var i = (
      /** @type {Derived} */
      ne
    );
    (i.children ??= []).push(t);
  }
  return t;
}
// @__NO_SIDE_EFFECTS__
function vs(n) {
  const e = /* @__PURE__ */ j(n);
  return e.equals = Jn, e;
}
function Tr(n) {
  var e = n.children;
  if (e !== null) {
    n.children = null;
    for (var t = 0; t < e.length; t += 1) {
      var i = e[t];
      i.f & Pe ? $n(
        /** @type {Derived} */
        i
      ) : Be(
        /** @type {Effect} */
        i
      );
    }
  }
}
function Ar(n) {
  var e, t = $;
  ke(n.parent);
  try {
    Tr(n), e = Hr(n);
  } finally {
    ke(t);
  }
  return e;
}
function Ir(n) {
  var e = Ar(n), t = (ot || n.f & $e) && n.deps !== null ? nn : me;
  De(n, t), n.equals(e) || (n.v = e, n.version = Br());
}
function $n(n) {
  Tr(n), wt(n, 0), De(n, Tt), n.v = n.children = n.deps = n.ctx = n.reactions = null;
}
function xs(n) {
  $ === null && ne === null && Zo(), ne !== null && ne.f & $e && Xo(), ii && Jo();
}
function ys(n, e) {
  var t = e.last;
  t === null ? e.last = e.first = n : (t.next = n, n.prev = t, e.last = n);
}
function dt(n, e, t, i = !0) {
  var r = (n & Et) !== 0, o = $, s = {
    ctx: re,
    deps: null,
    deriveds: null,
    nodes_start: null,
    nodes_end: null,
    f: n | Qe,
    first: null,
    fn: e,
    last: null,
    next: null,
    parent: r ? null : o,
    prev: null,
    teardown: null,
    transitions: null,
    version: 0
  };
  if (t) {
    var a = lt;
    try {
      Pi(!0), ln(s), s.f |= xr;
    } catch (c) {
      throw Be(s), c;
    } finally {
      Pi(a);
    }
  } else e !== null && cn(s);
  var u = t && s.deps === null && s.first === null && s.nodes_start === null && s.teardown === null && (s.f & mr) === 0;
  if (!u && !r && i && (o !== null && ys(s, o), ne !== null && ne.f & Pe)) {
    var l = (
      /** @type {Derived} */
      ne
    );
    (l.children ??= []).push(s);
  }
  return s;
}
function Dr(n) {
  const e = dt(St, null, !1);
  return De(e, me), e.teardown = n, e;
}
function Ie(n) {
  xs();
  var e = $ !== null && ($.f & Ce) !== 0 && re !== null && !re.m;
  if (e) {
    var t = (
      /** @type {ComponentContext} */
      re
    );
    (t.e ??= []).push({
      fn: n,
      effect: $,
      reaction: ne
    });
  } else {
    var i = It(n);
    return i;
  }
}
function ms(n) {
  const e = dt(Et, n, !0);
  return () => {
    Be(e);
  };
}
function It(n) {
  return dt(vr, n, !1);
}
function ei(n) {
  return dt(St, n, !0);
}
function q(n) {
  return Ve(n);
}
function Ve(n, e = 0) {
  return dt(St | tn | e, n, !0);
}
function Oe(n, e = !0) {
  return dt(St | Ce, n, !0, e);
}
function Lr(n) {
  var e = n.teardown;
  if (e !== null) {
    const t = ii, i = ne;
    Oi(!0), Ae(null);
    try {
      e.call(null);
    } finally {
      Oi(t), Ae(i);
    }
  }
}
function Nr(n) {
  var e = n.deriveds;
  if (e !== null) {
    n.deriveds = null;
    for (var t = 0; t < e.length; t += 1)
      $n(e[t]);
  }
}
function Fr(n, e = !1) {
  var t = n.first;
  for (n.first = n.last = null; t !== null; ) {
    var i = t.next;
    Be(t, e), t = i;
  }
}
function bs(n) {
  for (var e = n.first; e !== null; ) {
    var t = e.next;
    e.f & Ce || Be(e), e = t;
  }
}
function Be(n, e = !0) {
  var t = !1;
  if ((e || n.f & yr) && n.nodes_start !== null) {
    for (var i = n.nodes_start, r = n.nodes_end; i !== null; ) {
      var o = i === r ? null : (
        /** @type {TemplateNode} */
        /* @__PURE__ */ on(i)
      );
      i.remove(), i = o;
    }
    t = !0;
  }
  Fr(n, e && !t), Nr(n), wt(n, 0), De(n, Tt);
  var s = n.transitions;
  if (s !== null)
    for (const u of s)
      u.stop();
  Lr(n);
  var a = n.parent;
  a !== null && a.first !== null && Pr(n), n.next = n.prev = n.teardown = n.ctx = n.deps = n.parent = n.fn = n.nodes_start = n.nodes_end = null;
}
function Pr(n) {
  var e = n.parent, t = n.prev, i = n.next;
  t !== null && (t.next = i), i !== null && (i.prev = t), e !== null && (e.first === n && (e.first = i), e.last === n && (e.last = t));
}
function bt(n, e) {
  var t = [];
  ti(n, t, !0), Or(t, () => {
    Be(n), e && e();
  });
}
function Or(n, e) {
  var t = n.length;
  if (t > 0) {
    var i = () => --t || e();
    for (var r of n)
      r.out(i);
  } else
    e();
}
function ti(n, e, t) {
  if (!(n.f & Ee)) {
    if (n.f ^= Ee, n.transitions !== null)
      for (const s of n.transitions)
        (s.is_global || t) && e.push(s);
    for (var i = n.first; i !== null; ) {
      var r = i.next, o = (i.f & ut) !== 0 || (i.f & Ce) !== 0;
      ti(i, e, o ? t : !1), i = r;
    }
  }
}
function Vt(n) {
  Mr(n, !0);
}
function Mr(n, e) {
  if (n.f & Ee) {
    Dt(n) && ln(n), n.f ^= Ee;
    for (var t = n.first; t !== null; ) {
      var i = t.next, r = (t.f & ut) !== 0 || (t.f & Ce) !== 0;
      Mr(t, r ? e : !1), t = i;
    }
    if (n.transitions !== null)
      for (const o of n.transitions)
        (o.is_global || e) && o.in();
  }
}
let In = !1, Dn = [];
function ws() {
  In = !1;
  const n = Dn.slice();
  Dn = [], Vo(n);
}
function sn(n) {
  In || (In = !0, queueMicrotask(ws)), Dn.push(n);
}
function ni(n) {
  throw new Error("lifecycle_outside_component");
}
let Yt = !1, lt = !1, ii = !1;
function Pi(n) {
  lt = n;
}
function Oi(n) {
  ii = n;
}
let Ln = [], xt = 0;
let ne = null;
function Ae(n) {
  ne = n;
}
let $ = null;
function ke(n) {
  $ = n;
}
let Te = null;
function ks(n) {
  Te = n;
}
let pe = null, xe = 0, Ke = null;
function Cs(n) {
  Ke = n;
}
let Rr = 0, ot = !1, re = null;
function Br() {
  return ++Rr;
}
function an() {
  return re !== null && re.l === null;
}
function Dt(n) {
  var e = n.f;
  if (e & Qe)
    return !0;
  if (e & nn) {
    var t = n.deps, i = (e & $e) !== 0;
    if (t !== null) {
      var r;
      if (e & jt) {
        for (r = 0; r < t.length; r++)
          (t[r].reactions ??= []).push(n);
        n.f ^= jt;
      }
      for (r = 0; r < t.length; r++) {
        var o = t[r];
        if (Dt(
          /** @type {Derived} */
          o
        ) && Ir(
          /** @type {Derived} */
          o
        ), i && $ !== null && !ot && !o?.reactions?.includes(n) && (o.reactions ??= []).push(n), o.version > n.version)
          return !0;
      }
    }
    i || De(n, me);
  }
  return !1;
}
function Ss(n, e, t) {
  throw n;
}
function Hr(n) {
  var e = pe, t = xe, i = Ke, r = ne, o = ot, s = Te, a = re, u = n.f;
  pe = /** @type {null | Value[]} */
  null, xe = 0, Ke = null, ne = u & (Ce | Et) ? null : n, ot = !lt && (u & $e) !== 0, Te = null, re = n.ctx;
  try {
    var l = (
      /** @type {Function} */
      (0, n.fn)()
    ), c = n.deps;
    if (pe !== null) {
      var d;
      if (wt(n, xe), c !== null && xe > 0)
        for (c.length = xe + pe.length, d = 0; d < pe.length; d++)
          c[xe + d] = pe[d];
      else
        n.deps = c = pe;
      if (!ot)
        for (d = xe; d < c.length; d++)
          (c[d].reactions ??= []).push(n);
    } else c !== null && xe < c.length && (wt(n, xe), c.length = xe);
    return l;
  } finally {
    pe = e, xe = t, Ke = i, ne = r, ot = o, Te = s, re = a;
  }
}
function Es(n, e) {
  let t = e.reactions;
  if (t !== null) {
    var i = t.indexOf(n);
    if (i !== -1) {
      var r = t.length - 1;
      r === 0 ? t = e.reactions = null : (t[i] = t[r], t.pop());
    }
  }
  t === null && e.f & Pe && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (pe === null || !pe.includes(e)) && (De(e, nn), e.f & ($e | jt) || (e.f ^= jt), wt(
    /** @type {Derived} **/
    e,
    0
  ));
}
function wt(n, e) {
  var t = n.deps;
  if (t !== null)
    for (var i = e; i < t.length; i++)
      Es(n, t[i]);
}
function ln(n) {
  var e = n.f;
  if (!(e & Tt)) {
    De(n, me);
    var t = $;
    $ = n;
    try {
      e & tn ? bs(n) : Fr(n), Nr(n), Lr(n);
      var i = Hr(n);
      n.teardown = typeof i == "function" ? i : null, n.version = Rr;
    } catch (r) {
      Ss(
        /** @type {Error} */
        r
      );
    } finally {
      $ = t;
    }
  }
}
function Ts() {
  xt > 1e3 && (xt = 0, Qo()), xt++;
}
function As(n) {
  var e = n.length;
  if (e !== 0) {
    Ts();
    var t = lt;
    lt = !0;
    try {
      for (var i = 0; i < e; i++) {
        var r = n[i];
        r.f & me || (r.f ^= me);
        var o = [];
        zr(r, o), Is(o);
      }
    } finally {
      lt = t;
    }
  }
}
function Is(n) {
  var e = n.length;
  if (e !== 0)
    for (var t = 0; t < e; t++) {
      var i = n[t];
      !(i.f & (Tt | Ee)) && Dt(i) && (ln(i), i.deps === null && i.first === null && i.nodes_start === null && (i.teardown === null ? Pr(i) : i.fn = null));
    }
}
function Ds() {
  if (Yt = !1, xt > 1001)
    return;
  const n = Ln;
  Ln = [], As(n), Yt || (xt = 0);
}
function cn(n) {
  Yt || (Yt = !0, queueMicrotask(Ds));
  for (var e = n; e.parent !== null; ) {
    e = e.parent;
    var t = e.f;
    if (t & (Et | Ce)) {
      if (!(t & me)) return;
      e.f ^= me;
    }
  }
  Ln.push(e);
}
function zr(n, e) {
  var t = n.first, i = [];
  e: for (; t !== null; ) {
    var r = t.f, o = (r & Ce) !== 0, s = o && (r & me) !== 0;
    if (!s && !(r & Ee))
      if (r & St) {
        o ? t.f ^= me : Dt(t) && ln(t);
        var a = t.first;
        if (a !== null) {
          t = a;
          continue;
        }
      } else r & vr && i.push(t);
    var u = t.next;
    if (u === null) {
      let d = t.parent;
      for (; d !== null; ) {
        if (n === d)
          break e;
        var l = d.next;
        if (l !== null) {
          t = l;
          continue e;
        }
        d = d.parent;
      }
    }
    t = u;
  }
  for (var c = 0; c < i.length; c++)
    a = i[c], e.push(a), zr(a, e);
}
function p(n) {
  var e = n.f, t = (e & Pe) !== 0;
  if (t && e & Tt) {
    var i = Ar(
      /** @type {Derived} */
      n
    );
    return $n(
      /** @type {Derived} */
      n
    ), i;
  }
  if (ne !== null) {
    Te !== null && Te.includes(n) && ns();
    var r = ne.deps;
    pe === null && r !== null && r[xe] === n ? xe++ : pe === null ? pe = [n] : pe.push(n), Ke !== null && $ !== null && $.f & me && !($.f & Ce) && Ke.includes(n) && (De($, Qe), cn($));
  } else if (t && /** @type {Derived} */
  n.deps === null) {
    var o = (
      /** @type {Derived} */
      n
    ), s = o.parent;
    s !== null && !s.deriveds?.includes(o) && (s.deriveds ??= []).push(o);
  }
  return t && (o = /** @type {Derived} */
  n, Dt(o) && Ir(o)), n.v;
}
function Ne(n) {
  return n && p(n);
}
function je(n) {
  const e = ne;
  try {
    return ne = null, n();
  } finally {
    ne = e;
  }
}
const Ls = -3585;
function De(n, e) {
  n.f = n.f & Ls | e;
}
function fe(n) {
  return (
    /** @type {T} */
    Ur().get(n)
  );
}
function Lt(n, e) {
  return Ur().set(n, e), e;
}
function Ur(n) {
  return re === null && ni(), re.c ??= new Map(Ns(re) || void 0);
}
function Ns(n) {
  let e = n.p;
  for (; e !== null; ) {
    const t = e.c;
    if (t !== null)
      return t;
    e = e.p;
  }
  return null;
}
function X(n, e = !1, t) {
  re = {
    p: re,
    c: null,
    e: null,
    m: !1,
    s: n,
    x: null,
    l: null
  }, e || (re.l = {
    s: null,
    u: null,
    r1: [],
    r2: ye(!1)
  });
}
function Z(n) {
  const e = re;
  if (e !== null) {
    n !== void 0 && (e.x = n);
    const s = e.e;
    if (s !== null) {
      var t = $, i = ne;
      e.e = null;
      try {
        for (var r = 0; r < s.length; r++) {
          var o = s[r];
          ke(o.effect), Ae(o.reaction), It(o.fn);
        }
      } finally {
        ke(t), Ae(i);
      }
    }
    re = e.p, e.m = !0;
  }
  return n || /** @type {T} */
  {};
}
function Fs(n) {
  if (!(typeof n != "object" || !n || n instanceof EventTarget)) {
    if (st in n)
      Nn(n);
    else if (!Array.isArray(n))
      for (let e in n) {
        const t = n[e];
        typeof t == "object" && t && st in t && Nn(t);
      }
  }
}
function Nn(n, e = /* @__PURE__ */ new Set()) {
  if (typeof n == "object" && n !== null && // We don't want to traverse DOM elements
  !(n instanceof EventTarget) && !e.has(n)) {
    e.add(n), n instanceof Date && n.getTime();
    for (let i in n)
      try {
        Nn(n[i], e);
      } catch {
      }
    const t = Gt(n);
    if (t !== Object.prototype && t !== Array.prototype && t !== Map.prototype && t !== Set.prototype && t !== Date.prototype) {
      const i = _r(t);
      for (let r in i) {
        const o = i[r].get;
        if (o)
          try {
            o.call(n);
          } catch {
          }
      }
    }
  }
}
const qr = /* @__PURE__ */ new Set(), Fn = /* @__PURE__ */ new Set();
function Ps(n, e, t, i) {
  function r(o) {
    if (i.capture || _t.call(e, o), !o.cancelBubble) {
      var s = ne, a = $;
      Ae(null), ke(null);
      try {
        return t.call(this, o);
      } finally {
        Ae(s), ke(a);
      }
    }
  }
  return n.startsWith("pointer") || n.startsWith("touch") || n === "wheel" ? sn(() => {
    e.addEventListener(n, r, i);
  }) : e.addEventListener(n, r, i), r;
}
function Ge(n, e, t, i, r) {
  var o = { capture: i, passive: r }, s = Ps(n, e, t, o);
  (e === document.body || e === window || e === document) && Dr(() => {
    e.removeEventListener(n, s, o);
  });
}
function V(n) {
  for (var e = 0; e < n.length; e++)
    qr.add(n[e]);
  for (var t of Fn)
    t(n);
}
function _t(n) {
  var e = this, t = (
    /** @type {Node} */
    e.ownerDocument
  ), i = n.type, r = n.composedPath?.() || [], o = (
    /** @type {null | Element} */
    r[0] || n.target
  ), s = 0, a = n.__root;
  if (a) {
    var u = r.indexOf(a);
    if (u !== -1 && (e === document || e === /** @type {any} */
    window)) {
      n.__root = e;
      return;
    }
    var l = r.indexOf(e);
    if (l === -1)
      return;
    u <= l && (s = u);
  }
  if (o = /** @type {Element} */
  r[s] || n.target, o !== e) {
    Ko(n, "currentTarget", {
      configurable: !0,
      get() {
        return o || t;
      }
    });
    var c = ne, d = $;
    Ae(null), ke(null);
    try {
      for (var f, h = []; o !== null; ) {
        var g = o.assignedSlot || o.parentNode || /** @type {any} */
        o.host || null;
        try {
          var _ = o["__" + i];
          if (_ !== void 0 && !/** @type {any} */
          o.disabled)
            if (Yn(_)) {
              var [v, ...k] = _;
              v.apply(o, [n, ...k]);
            } else
              _.call(o, n);
        } catch (x) {
          f ? h.push(x) : f = x;
        }
        if (n.cancelBubble || g === e || g === null)
          break;
        o = g;
      }
      if (f) {
        for (let x of h)
          queueMicrotask(() => {
            throw x;
          });
        throw f;
      }
    } finally {
      n.__root = e, delete n.currentTarget, Ae(c), ke(d);
    }
  }
}
function ri(n) {
  var e;
  e = document.head.appendChild(At());
  try {
    Ve(() => n(e), yr);
  } finally {
  }
}
function Kr(n) {
  var e = document.createElement("template");
  return e.innerHTML = n, e.content;
}
function kt(n, e) {
  var t = (
    /** @type {Effect} */
    $
  );
  t.nodes_start === null && (t.nodes_start = n, t.nodes_end = e);
}
// @__NO_SIDE_EFFECTS__
function L(n, e) {
  var t = (e & hs) !== 0, i = (e & ps) !== 0, r, o = !n.startsWith("<!>");
  return () => {
    r === void 0 && (r = Kr(o ? n : "<!>" + n), t || (r = /** @type {Node} */
    /* @__PURE__ */ mt(r)));
    var s = (
      /** @type {TemplateNode} */
      i ? document.importNode(r, !0) : r.cloneNode(!0)
    );
    if (t) {
      var a = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ mt(s)
      ), u = (
        /** @type {TemplateNode} */
        s.lastChild
      );
      kt(a, u);
    } else
      kt(s, s);
    return s;
  };
}
function ct(n = "") {
  {
    var e = At(n + "");
    return kt(e, e), e;
  }
}
function Q() {
  var n = document.createDocumentFragment(), e = document.createComment(""), t = At();
  return n.append(e, t), kt(e, t), n;
}
function m(n, e) {
  n !== null && n.before(
    /** @type {Node} */
    e
  );
}
const Os = ["touchstart", "touchmove"];
function Ms(n) {
  return Os.includes(n);
}
let Pn = !0;
function le(n, e) {
  var t = e == null ? "" : typeof e == "object" ? e + "" : e;
  t !== (n.__t ??= n.nodeValue) && (n.__t = t, n.nodeValue = t == null ? "" : t + "");
}
function Mi(n, e) {
  return Rs(n, e);
}
const tt = /* @__PURE__ */ new Map();
function Rs(n, { target: e, anchor: t, props: i = {}, events: r, context: o, intro: s = !0 }) {
  gs();
  var a = /* @__PURE__ */ new Set(), u = (d) => {
    for (var f = 0; f < d.length; f++) {
      var h = d[f];
      if (!a.has(h)) {
        a.add(h);
        var g = Ms(h);
        e.addEventListener(h, _t, { passive: g });
        var _ = tt.get(h);
        _ === void 0 ? (document.addEventListener(h, _t, { passive: g }), tt.set(h, 1)) : tt.set(h, _ + 1);
      }
    }
  };
  u(Wn(qr)), Fn.add(u);
  var l = void 0, c = ms(() => {
    var d = t ?? e.appendChild(At());
    return Oe(() => {
      if (o) {
        X({});
        var f = (
          /** @type {ComponentContext} */
          re
        );
        f.c = o;
      }
      r && (i.$$events = r), Pn = s, l = n(d, i) || {}, Pn = !0, o && Z();
    }), () => {
      for (var f of a) {
        e.removeEventListener(f, _t);
        var h = (
          /** @type {number} */
          tt.get(f)
        );
        --h === 0 ? (document.removeEventListener(f, _t), tt.delete(f)) : tt.set(f, h);
      }
      Fn.delete(u), On.delete(l), d !== t && d.parentNode?.removeChild(d);
    };
  });
  return On.set(l, c), l;
}
let On = /* @__PURE__ */ new WeakMap();
function Bs(n) {
  const e = On.get(n);
  e && e();
}
function B(n, e, t, i = null, r = !1) {
  var o = n, s = null, a = null, u = null, l = r ? ut : 0;
  Ve(() => {
    u !== (u = !!e()) && (u ? (s ? Vt(s) : s = Oe(() => t(o)), a && bt(a, () => {
      a = null;
    })) : (a ? Vt(a) : i && (a = Oe(() => i(o))), s && bt(s, () => {
      s = null;
    })));
  }, l);
}
function Gr(n, e, t) {
  var i = n, r = ve, o;
  Ve(() => {
    rn(r, r = e()) && (o && bt(o), o = Oe(() => t(i)));
  });
}
let vn = null;
function Ct(n, e) {
  return e;
}
function Hs(n, e, t, i) {
  for (var r = [], o = e.length, s = 0; s < o; s++)
    ti(e[s].e, r, !0);
  var a = o > 0 && r.length === 0 && t !== null;
  if (a) {
    var u = (
      /** @type {Element} */
      /** @type {Element} */
      t.parentNode
    );
    _s(u), u.append(
      /** @type {Element} */
      t
    ), i.clear(), ze(n, e[0].prev, e[o - 1].next);
  }
  Or(r, () => {
    for (var l = 0; l < o; l++) {
      var c = e[l];
      a || (i.delete(c.k), ze(n, c.prev, c.next)), Be(c.e, !a);
    }
  });
}
function Me(n, e, t, i, r, o = null) {
  var s = n, a = { flags: e, items: /* @__PURE__ */ new Map(), first: null }, u = (e & kr) !== 0;
  if (u) {
    var l = (
      /** @type {Element} */
      n
    );
    s = l.appendChild(At());
  }
  var c = null, d = !1;
  Ve(() => {
    var f = t(), h = Yn(f) ? f : f == null ? [] : Wn(f), g = h.length;
    if (!(d && g === 0)) {
      d = g === 0;
      {
        var _ = (
          /** @type {Effect} */
          ne
        );
        zs(h, a, s, r, e, (_.f & Ee) !== 0, i);
      }
      o !== null && (g === 0 ? c ? Vt(c) : c = Oe(() => o(s)) : c !== null && bt(c, () => {
        c = null;
      })), t();
    }
  });
}
function zs(n, e, t, i, r, o, s) {
  var a = (r & os) !== 0, u = (r & (Zn | Qn)) !== 0, l = n.length, c = e.items, d = e.first, f = d, h, g = null, _, v = [], k = [], x, A, E, w;
  if (a)
    for (w = 0; w < l; w += 1)
      x = n[w], A = s(x, w), E = c.get(A), E !== void 0 && (E.a?.measure(), (_ ??= /* @__PURE__ */ new Set()).add(E));
  for (w = 0; w < l; w += 1) {
    if (x = n[w], A = s(x, w), E = c.get(A), E === void 0) {
      var S = f ? (
        /** @type {TemplateNode} */
        f.e.nodes_start
      ) : t;
      g = qs(
        S,
        e,
        g,
        g === null ? e.first : g.next,
        x,
        A,
        w,
        i,
        r
      ), c.set(A, g), v = [], k = [], f = g.next;
      continue;
    }
    if (u && Us(E, x, w, r), E.e.f & Ee && (Vt(E.e), a && (E.a?.unfix(), (_ ??= /* @__PURE__ */ new Set()).delete(E))), E !== f) {
      if (h !== void 0 && h.has(E)) {
        if (v.length < k.length) {
          var O = k[0], D;
          g = O.prev;
          var N = v[0], H = v[v.length - 1];
          for (D = 0; D < v.length; D += 1)
            Ri(v[D], O, t);
          for (D = 0; D < k.length; D += 1)
            h.delete(k[D]);
          ze(e, N.prev, H.next), ze(e, g, N), ze(e, H, O), f = O, g = H, w -= 1, v = [], k = [];
        } else
          h.delete(E), Ri(E, f, t), ze(e, E.prev, E.next), ze(e, E, g === null ? e.first : g.next), ze(e, g, E), g = E;
        continue;
      }
      for (v = [], k = []; f !== null && f.k !== A; )
        (o || !(f.e.f & Ee)) && (h ??= /* @__PURE__ */ new Set()).add(f), k.push(f), f = f.next;
      if (f === null)
        continue;
      E = f;
    }
    v.push(E), g = E, f = E.next;
  }
  if (f !== null || h !== void 0) {
    for (var b = h === void 0 ? [] : Wn(h); f !== null; )
      (o || !(f.e.f & Ee)) && b.push(f), f = f.next;
    var y = b.length;
    if (y > 0) {
      var C = r & kr && l === 0 ? t : null;
      if (a) {
        for (w = 0; w < y; w += 1)
          b[w].a?.measure();
        for (w = 0; w < y; w += 1)
          b[w].a?.fix();
      }
      Hs(e, b, C, c);
    }
  }
  a && sn(() => {
    if (_ !== void 0)
      for (E of _)
        E.a?.apply();
  }), $.first = e.first && e.first.e, $.last = g && g.e;
}
function Us(n, e, t, i) {
  i & Zn && An(n.v, e), i & Qn ? An(
    /** @type {Value<number>} */
    n.i,
    t
  ) : n.i = t;
}
function qs(n, e, t, i, r, o, s, a, u) {
  var l = vn;
  try {
    var c = (u & Zn) !== 0, d = (u & ss) === 0, f = c ? d ? /* @__PURE__ */ Xn(r) : ye(r) : r, h = u & Qn ? ye(s) : s, g = {
      i: h,
      v: f,
      k: o,
      a: null,
      // @ts-expect-error
      e: null,
      prev: t,
      next: i
    };
    return vn = g, g.e = Oe(() => a(n, f, h), Cr), g.e.prev = t && t.e, g.e.next = i && i.e, t === null ? e.first = g : (t.next = g, t.e.next = g.e), i !== null && (i.prev = g, i.e.prev = g.e), g;
  } finally {
    vn = l;
  }
}
function Ri(n, e, t) {
  for (var i = n.next ? (
    /** @type {TemplateNode} */
    n.next.e.nodes_start
  ) : t, r = e ? (
    /** @type {TemplateNode} */
    e.e.nodes_start
  ) : t, o = (
    /** @type {TemplateNode} */
    n.e.nodes_start
  ); o !== i; ) {
    var s = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ on(o)
    );
    r.before(o), o = s;
  }
}
function ze(n, e, t) {
  e === null ? n.first = t : (e.next = t, e.e.next = t && t.e), t !== null && (t.prev = e, t.e.prev = e && e.e);
}
function Ks(n, e, t, i, r) {
  var o = n, s = "", a;
  Ve(() => {
    s !== (s = e() ?? "") && (a !== void 0 && (Be(a), a = void 0), s !== "" && (a = Oe(() => {
      var u = s + "", l = Kr(u);
      kt(
        /** @type {TemplateNode} */
        /* @__PURE__ */ mt(l),
        /** @type {TemplateNode} */
        l.lastChild
      ), o.before(l);
    })));
  });
}
function ue(n, e, ...t) {
  var i = n, r = se, o;
  Ve(() => {
    r !== (r = e()) && (o && (Be(o), o = null), o = Oe(() => (
      /** @type {SnippetFn} */
      r(i, ...t)
    )));
  }, ut);
}
function Gs(n, e, t) {
  var i = n, r, o;
  Ve(() => {
    r !== (r = e()) && (o && (bt(o), o = null), r && (o = Oe(() => t(i, r))));
  }, ut);
}
function Re(n, e, t) {
  It(() => {
    var i = je(() => e(n, t?.()) || {});
    if (t && i?.update) {
      var r = !1, o = (
        /** @type {any} */
        {}
      );
      ei(() => {
        var s = t();
        Fs(s), r && rn(o, s) && (o = s, i.update(s));
      }), r = !0;
    }
    if (i?.destroy)
      return () => (
        /** @type {Function} */
        i.destroy()
      );
  });
}
let Bi = !1;
function js() {
  Bi || (Bi = !0, document.addEventListener(
    "reset",
    (n) => {
      Promise.resolve().then(() => {
        if (!n.defaultPrevented)
          for (
            const e of
            /**@type {HTMLFormElement} */
            n.target.elements
          )
            e.__on_r?.();
      });
    },
    // In the capture phase to guarantee we get noticed of it (no possiblity of stopPropagation)
    { capture: !0 }
  ));
}
function te(n, e, t, i) {
  var r = n.__attributes ??= {};
  r[e] !== (r[e] = t) && (e === "style" && "__styles" in n && (n.__styles = {}), e === "loading" && (n[Wo] = t), t == null ? n.removeAttribute(e) : typeof t != "string" && Vs(n).includes(e) ? n[e] = t : n.setAttribute(e, t));
}
var Hi = /* @__PURE__ */ new Map();
function Vs(n) {
  var e = Hi.get(n.nodeName);
  if (e) return e;
  Hi.set(n.nodeName, e = []);
  for (var t, i = Gt(n), r = Element.prototype; r !== i; ) {
    t = _r(i);
    for (var o in t)
      t[o].set && e.push(o);
    i = Gt(i);
  }
  return e;
}
function he(n, e) {
  var t = n.__className, i = Ys(e);
  (t !== i || Cr) && (e == null ? n.removeAttribute("class") : n.className = i, n.__className = i);
}
function Ys(n) {
  return n ?? "";
}
function de(n, e, t) {
  if (t) {
    if (n.classList.contains(e)) return;
    n.classList.add(e);
  } else {
    if (!n.classList.contains(e)) return;
    n.classList.remove(e);
  }
}
const Ws = () => performance.now(), Ue = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (n) => requestAnimationFrame(n)
  ),
  now: () => Ws(),
  tasks: /* @__PURE__ */ new Set()
};
function jr(n) {
  Ue.tasks.forEach((e) => {
    e.c(n) || (Ue.tasks.delete(e), e.f());
  }), Ue.tasks.size !== 0 && Ue.tick(jr);
}
function Js(n) {
  let e;
  return Ue.tasks.size === 0 && Ue.tick(jr), {
    promise: new Promise((t) => {
      Ue.tasks.add(e = { c: n, f: t });
    }),
    abort() {
      Ue.tasks.delete(e);
    }
  };
}
function Rt(n, e) {
  n.dispatchEvent(new CustomEvent(e));
}
function Xs(n) {
  if (n === "float") return "cssFloat";
  if (n === "offset") return "cssOffset";
  if (n.startsWith("--")) return n;
  const e = n.split("-");
  return e.length === 1 ? e[0] : e[0] + e.slice(1).map(
    /** @param {any} word */
    (t) => t[0].toUpperCase() + t.slice(1)
  ).join("");
}
function zi(n) {
  const e = {}, t = n.split(";");
  for (const i of t) {
    const [r, o] = i.split(":");
    if (!r || o === void 0) break;
    const s = Xs(r.trim());
    e[s] = o.trim();
  }
  return e;
}
const Zs = (n) => n;
function Vr(n, e, t, i) {
  var r = (n & fs) !== 0, o = "both", s, a = e.inert, u, l;
  function c() {
    var _ = ne, v = $;
    Ae(null), ke(null);
    try {
      return s ??= t()(e, i?.() ?? /** @type {P} */
      {}, {
        direction: o
      });
    } finally {
      Ae(_), ke(v);
    }
  }
  var d = {
    is_global: r,
    in() {
      e.inert = a, Rt(e, "introstart"), u = Mn(e, c(), l, 1, () => {
        Rt(e, "introend"), u?.abort(), u = s = void 0;
      });
    },
    out(_) {
      e.inert = !0, Rt(e, "outrostart"), l = Mn(e, c(), u, 0, () => {
        Rt(e, "outroend"), _?.();
      });
    },
    stop: () => {
      u?.abort(), l?.abort();
    }
  }, f = (
    /** @type {Effect} */
    $
  );
  if ((f.transitions ??= []).push(d), Pn) {
    var h = r;
    if (!h) {
      for (var g = (
        /** @type {Effect | null} */
        f.parent
      ); g && g.f & ut; )
        for (; (g = g.parent) && !(g.f & tn); )
          ;
      h = !g || (g.f & xr) !== 0;
    }
    h && It(() => {
      je(() => d.in());
    });
  }
}
function Mn(n, e, t, i, r) {
  var o = i === 1;
  if (rt(e)) {
    var s, a = !1;
    return sn(() => {
      if (!a) {
        var v = e({ direction: o ? "in" : "out" });
        s = Mn(n, v, t, i, r);
      }
    }), {
      abort: () => {
        a = !0, s?.abort();
      },
      deactivate: () => s.deactivate(),
      reset: () => s.reset(),
      t: () => s.t()
    };
  }
  if (t?.deactivate(), !e?.duration)
    return r(), {
      abort: se,
      deactivate: se,
      reset: se,
      t: () => i
    };
  const { delay: u = 0, css: l, tick: c, easing: d = Zs } = e;
  var f = [];
  if (o && t === void 0 && (c && c(0, 1), l)) {
    var h = zi(l(0, 1));
    f.push(h, h);
  }
  var g = () => 1 - i, _ = n.animate(f, { duration: u });
  return _.onfinish = () => {
    var v = t?.t() ?? 1 - i;
    t?.abort();
    var k = i - v, x = (
      /** @type {number} */
      e.duration * Math.abs(k)
    ), A = [];
    if (x > 0) {
      if (l)
        for (var E = Math.ceil(x / 16.666666666666668), w = 0; w <= E; w += 1) {
          var S = v + k * d(w / E), O = l(S, 1 - S);
          A.push(zi(O));
        }
      g = () => {
        var D = (
          /** @type {number} */
          /** @type {globalThis.Animation} */
          _.currentTime
        );
        return v + k * d(D / x);
      }, c && Js(() => {
        if (_.playState !== "running") return !1;
        var D = g();
        return c(D, 1 - D), !0;
      });
    }
    _ = n.animate(A, { duration: x, fill: "forwards" }), _.onfinish = () => {
      g = () => i, c?.(i, 1 - i), r();
    };
  }, {
    abort: () => {
      _ && (_.cancel(), _.effect = null, _.onfinish = se);
    },
    deactivate: () => {
      r = se;
    },
    reset: () => {
      i === 0 && c?.(1, 0);
    },
    t: () => g()
  };
}
function Qs(n, e, t, i = t) {
  n.addEventListener(e, t);
  const r = n.__on_r;
  r ? n.__on_r = () => {
    r(), i();
  } : n.__on_r = i, js();
}
function xn(n, e, t = e) {
  var i = an();
  Qs(n, "input", () => {
    var r = Ui(n) ? qi(n.value) : n.value;
    t(r), i && r !== (r = e()) && (n.value = r ?? "");
  }), ei(() => {
    var r = e();
    Ui(n) && r === qi(n.value) || n.type === "date" && !r && !n.value || r !== n.value && (n.value = r ?? "");
  });
}
function Ui(n) {
  var e = n.type;
  return e === "number" || e === "range";
}
function qi(n) {
  return n === "" ? null : +n;
}
function Ki(n, e) {
  return n === e || n?.[st] === e;
}
function oe(n = {}, e, t, i) {
  return It(() => {
    var r, o;
    return ei(() => {
      r = o, o = [], je(() => {
        n !== t(...o) && (e(n, ...o), r && Ki(t(...r), n) && e(null, ...r));
      });
    }), () => {
      sn(() => {
        o && Ki(t(...o), n) && e(null, ...o);
      });
    };
  }), n;
}
function $s(n, e, t) {
  if (n == null)
    return e(void 0), se;
  const i = je(
    () => n.subscribe(
      e,
      // @ts-expect-error
      t
    )
  );
  return i.unsubscribe ? () => i.unsubscribe() : i;
}
let Bt = !1;
function ae(n, e, t) {
  const i = t[e] ??= {
    store: null,
    source: /* @__PURE__ */ Xn(void 0),
    unsubscribe: se
  };
  if (i.store !== n)
    if (i.unsubscribe(), i.store = n ?? null, n == null)
      i.source.v = void 0, i.unsubscribe = se;
    else {
      var r = !0;
      i.unsubscribe = $s(n, (o) => {
        r ? i.source.v = o : T(i.source, o);
      }), r = !1;
    }
  return p(i.source);
}
function et() {
  const n = {};
  return Dr(() => {
    for (var e in n)
      n[e].unsubscribe();
  }), n;
}
function ea(n) {
  var e = Bt;
  try {
    return Bt = !1, [n(), Bt];
  } finally {
    Bt = e;
  }
}
const ta = {
  get(n, e) {
    if (!n.exclude.includes(e))
      return n.props[e];
  },
  set(n, e) {
    return !1;
  },
  getOwnPropertyDescriptor(n, e) {
    if (!n.exclude.includes(e) && e in n.props)
      return {
        enumerable: !0,
        configurable: !0,
        value: n.props[e]
      };
  },
  has(n, e) {
    return n.exclude.includes(e) ? !1 : e in n.props;
  },
  ownKeys(n) {
    return Reflect.ownKeys(n.props).filter((e) => !n.exclude.includes(e));
  }
};
// @__NO_SIDE_EFFECTS__
function na(n, e, t) {
  return new Proxy(
    { props: n, exclude: e },
    ta
  );
}
const ia = {
  get(n, e) {
    let t = n.props.length;
    for (; t--; ) {
      let i = n.props[t];
      if (rt(i) && (i = i()), typeof i == "object" && i !== null && e in i) return i[e];
    }
  },
  set(n, e, t) {
    let i = n.props.length;
    for (; i--; ) {
      let r = n.props[i];
      rt(r) && (r = r());
      const o = qe(r, e);
      if (o && o.set)
        return o.set(t), !0;
    }
    return !1;
  },
  getOwnPropertyDescriptor(n, e) {
    let t = n.props.length;
    for (; t--; ) {
      let i = n.props[t];
      if (rt(i) && (i = i()), typeof i == "object" && i !== null && e in i) {
        const r = qe(i, e);
        return r && !r.configurable && (r.configurable = !0), r;
      }
    }
  },
  has(n, e) {
    for (let t of n.props)
      if (rt(t) && (t = t()), t != null && e in t) return !0;
    return !1;
  },
  ownKeys(n) {
    const e = [];
    for (let t of n.props) {
      rt(t) && (t = t());
      for (const i in t)
        e.includes(i) || e.push(i);
    }
    return e;
  }
};
function ra(...n) {
  return new Proxy({ props: n }, ia);
}
function Gi(n) {
  for (var e = $, t = $; e !== null && !(e.f & (Ce | Et)); )
    e = e.parent;
  try {
    return ke(e), n();
  } finally {
    ke(t);
  }
}
function I(n, e, t, i) {
  var r = (t & as) !== 0, o = (t & ls) !== 0, s = (t & us) !== 0, a = (t & ds) !== 0, u = !1, l;
  s ? [l, u] = ea(() => (
    /** @type {V} */
    n[e]
  )) : l = /** @type {V} */
  n[e];
  var c = qe(n, e)?.set, d = (
    /** @type {V} */
    i
  ), f = !0, h = !1, g = () => (h = !0, f && (f = !1, a ? d = je(
    /** @type {() => V} */
    i
  ) : d = /** @type {V} */
  i), d);
  l === void 0 && i !== void 0 && (c && o && $o(), l = g(), c && c(l));
  var _;
  if (o)
    _ = () => {
      var S = (
        /** @type {V} */
        n[e]
      );
      return S === void 0 ? g() : (f = !0, h = !1, S);
    };
  else {
    var v = Gi(
      () => (r ? j : vs)(() => (
        /** @type {V} */
        n[e]
      ))
    );
    v.f |= Yo, _ = () => {
      var S = p(v);
      return S !== void 0 && (d = /** @type {V} */
      void 0), S === void 0 ? d : S;
    };
  }
  if (!(t & cs))
    return _;
  if (c) {
    var k = n.$$legacy;
    return function(S, O) {
      return arguments.length > 0 ? ((!o || !O || k || u) && c(O ? _() : S), S) : _();
    };
  }
  var x = !1, A = !1, E = /* @__PURE__ */ Xn(l), w = Gi(
    () => /* @__PURE__ */ j(() => {
      var S = _(), O = p(E);
      return x ? (x = !1, A = !0, O) : (A = !1, E.v = S);
    })
  );
  return r || (w.equals = Jn), function(S, O) {
    if (arguments.length > 0) {
      const D = O ? p(w) : o && s ? M(S) : S;
      return w.equals(D) || (x = !0, T(E, D), h && d !== void 0 && (d = D), je(() => p(w))), S;
    }
    return p(w);
  };
}
function be(n) {
  re === null && ni(), re.l !== null ? sa(re).m.push(n) : Ie(() => {
    const e = je(n);
    if (typeof e == "function") return (
      /** @type {() => void} */
      e
    );
  });
}
function oa(n) {
  re === null && ni(), be(() => () => je(n));
}
function sa(n) {
  var e = (
    /** @type {ComponentContextLegacy} */
    n.l
  );
  return e.u ??= { a: [], b: [], m: [] };
}
const aa = "5";
typeof window < "u" && (window.__svelte ||= { v: /* @__PURE__ */ new Set() }).v.add(aa);
const nt = [];
function la(n, e = se) {
  let t = null;
  const i = /* @__PURE__ */ new Set();
  function r(a) {
    if (rn(n, a) && (n = a, t)) {
      const u = !nt.length;
      for (const l of i)
        l[1](), nt.push(l, n);
      if (u) {
        for (let l = 0; l < nt.length; l += 2)
          nt[l][0](nt[l + 1]);
        nt.length = 0;
      }
    }
  }
  function o(a) {
    r(a(
      /** @type {T} */
      n
    ));
  }
  function s(a, u = se) {
    const l = [a, u];
    return i.add(l), i.size === 1 && (t = e(r, o) || se), a(
      /** @type {T} */
      n
    ), () => {
      i.delete(l), i.size === 0 && t && (t(), t = null);
    };
  }
  return { set: r, update: o, subscribe: s };
}
const ca = /* @__PURE__ */ new Map([
  [24584, [24586]],
  [24585, [24586]]
]), Yr = /* @__PURE__ */ new Map([
  [24586, [24585, 24584]],
  [24585, [24585, 24584]],
  [24584, [24585, 24584]]
]), Rn = /* @__PURE__ */ new Map([
  [40966, /* @__PURE__ */ new Set([40966])],
  [40974, /* @__PURE__ */ new Set([40973, 40974])],
  [40973, /* @__PURE__ */ new Set([40973, 40974])]
]), Fe = 8388608, Wr = 1, oi = 2, si = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  OTHER: 0,
  INLINE: 32768,
  TEXT: 32771,
  FORMAT: 40964,
  PARAGRAPH: 24578,
  IMAGE: 32773,
  RULER: 16396,
  LINK: 40966,
  SUBSCRIPT: 40973,
  SUPERSCRIPT: 40974,
  NEWLINE: 32775,
  END: 8191,
  SPAN: 40968,
  OL: 24585,
  UL: 24584,
  LI: 24586,
  BREAK: 16395,
  BLOCK: 16384,
  CONTAINS: 8192,
  CHUNK_END_CURSOR: Fe,
  blockKids: ca,
  blockParents: Yr,
  nestingLogic: Rn,
  BLOCK_STYLES: Wr,
  INLINE_STYLES: oi
}, Symbol.toStringTag, { value: "Module" })), ai = 1, li = 2, ci = 3, un = 6, Jr = 7, Wt = 8, ui = 10, di = 11, Xr = 12, fi = 13, hi = 14, Jt = 15;
let ua = 1e3;
function pi() {
  return ua++;
}
const da = 1001, fa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addAction: pi,
  ACTION_TYPE: ai,
  ACTION_BACKSPACE: li,
  ACTION_DELETE: ci,
  ACTION_INSERT: un,
  ACTION_WRAP: Jr,
  FOCUS_MOVE: da,
  ACTION_RESET: Wt,
  ACTION_SET_PROPERTY: ui,
  ACTION_PATCH: di,
  ACTION_UNWRAP: Xr,
  ACTION_COPY: fi,
  ACTION_CUT: hi,
  ACTION_PASTE: Jt
}, Symbol.toStringTag, { value: "Module" })), ha = 0, We = 1, ji = 2, pa = 1, ga = 2, Vi = 1, Zr = 2, _a = 4;
class va {
  _node;
  _handler;
  constructor(e, t) {
    this._node = e, this._handler = t, document.addEventListener("selectionchange", () => {
      const i = this.read();
      i && this._handler(i[0], i[1]);
    }), document.addEventListener(
      "click",
      (i) => {
        const r = i.target;
        if (r.tagName === "IMG") {
          const o = parseInt(r.dataset.id), s = { id: o, pos: 0 }, a = { id: o, pos: Fe };
          this.paint(s, a);
        }
      },
      !0
    );
  }
  getBox(e) {
    return this._node.querySelector(`[data-id="${e}"]`).getBoundingClientRect();
  }
  paint(e, t) {
    if (!e)
      return;
    const i = window.getSelection();
    i.removeAllRanges();
    const r = document.createRange(), o = this._node.querySelector(`[data-id="${e.id}"]`);
    let s = o;
    t = t || e, t.id != e.id && (s = this._node.querySelector(`[data-id="${t.id}"]`)), e.pos === Fe ? r.setStart(o.parentNode, Yi(o) + 1) : r.setStart(o.firstChild || o, e.pos), t.pos === Fe ? r.setEnd(s.parentNode, Yi(s) + 1) : r.setEnd(s.firstChild || s, t.pos), i.addRange(r);
  }
  read() {
    const e = window.getSelection();
    if (!e.anchorNode || !this._node.contains(e.anchorNode))
      return null;
    const t = e.type === "Range", i = e.anchorNode, r = e.focusNode;
    let o = this._toInline(i, e.anchorOffset, !1), s = null;
    return t && typeof e.focusOffset == "number" && (s = this._toInline(r, e.focusOffset, !0)), i ? (s && (o.id === s.id ? s.pos < o.pos && ([o, s] = [s, o]) : o.target.compareDocumentPosition(s.target) & 10 && ([o, s] = [s, o])), [o, s]) : null;
  }
  _toInline(e, t, i) {
    if (!e.getAttribute || !e.getAttribute("data-id")) {
      const s = e.parentElement;
      s.getAttribute && s.getAttribute("data-id") ? e = s : e = e.firstChild;
    }
    let r = parseInt(e.getAttribute("data-id")), o = e;
    if (e.tagName !== "SPAN") {
      const s = e.childNodes;
      s.length ? (o = s[t], o && (t === 0 || !i) ? t = 0 : (o = s[t - 1], t = Fe), r = parseInt(o.dataset.id)) : t = 0;
    } else
      e.firstChild.nodeValue === "​" && (t = 0);
    return { id: r, pos: t, target: o };
  }
}
function Yi(n) {
  return Array.from(n.parentNode.childNodes).indexOf(n);
}
const gi = typeof navigator < "u" && navigator.platform.indexOf("Mac") > -1, Qr = 8, xa = 45, Bn = 13, ya = 9, ma = 27, ba = 32, wa = 37, ka = 38, Ca = 39, Sa = 40, Ea = 35, Ta = 36, Aa = 33, Ia = 34, $r = 46, Da = 65, eo = 66, La = 67, to = 73, Na = 75, Fa = 80, no = 85, io = 88, Pa = 89, Oa = 90, vt = gi ? 1024 : 512, Hn = 2048, Ma = gi ? 512 : 1024, Ra = 4096, Ba = gi ? "⌘" : "Ctrl", Ha = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BACKSPACE: Qr,
  INSERT: xa,
  ENTER: Bn,
  TAB: ya,
  ESC: ma,
  SPACE: ba,
  LEFT: wa,
  UP: ka,
  RIGHT: Ca,
  DOWN: Sa,
  END: Ea,
  HOME: Ta,
  PAGEUP: Aa,
  PAGEDOWN: Ia,
  DEL: $r,
  A: Da,
  B: eo,
  C: La,
  I: to,
  K: Na,
  P: Fa,
  U: no,
  X: io,
  Y: Pa,
  Z: Oa,
  CTRL: vt,
  SHIFT: Hn,
  META: Ma,
  ALT: Ra,
  ctrlName: Ba
}, Symbol.toStringTag, { value: "Module" }));
class za {
  _keys;
  _doc;
  constructor(e) {
    this._doc = e, this._keys = /* @__PURE__ */ new Map([
      [Qr, Wi(li)],
      [$r, Wi(ci)],
      [Bn, Ji({ tag: 16395, props: {} })],
      [Bn + Hn, Ji({ tag: 32775 })],
      [vt + eo, Ht({ mode: We, props: { bold: !0 } })],
      [vt + to, Ht({ mode: We, props: { italic: !0 } })],
      [vt + no, Ht({ mode: We, props: { underline: !0 } })],
      [
        vt + Hn + io,
        Ht({ mode: We, props: { strike: !0 } })
      ]
    ]);
  }
  add(e, t) {
    t ? this._keys.set(e, t) : this._keys.delete(e);
  }
  handler(e) {
    const t = e.which + (e.ctrlKey ? 512 : 0) + (e.metaKey ? 1024 : 0) + (e.shiftKey ? 2048 : 0) + (e.altKey ? 4096 : 0), i = this._keys.get(t);
    if (i && i(this._doc, e) !== !1) {
      e.preventDefault();
      return;
    }
    if (e.ctrlKey || e.metaKey)
      return;
    const r = e.key;
    r.length > 1 || e.altKey || (this._doc.exec(ai, r), e.preventDefault());
  }
}
function Ht(n) {
  return (e) => (e.getCursor()[1] ? e.exec(ui, n) : e.exec(un, { ...n, tag: 32771 }), !0);
}
function Wi(n) {
  return (e) => (e.exec(n, null), !0);
}
function Ji(n) {
  return (e) => (e.exec(un, n), !0);
}
function ro(n, e, t) {
  const i = [], r = [];
  return e.forEach((o) => {
    i.push(n(o, r, t));
  }), i.join("");
}
function oo(n, e, t) {
  switch (n.type) {
    case 32773: {
      const i = lo(n.props);
      return `<img src="${n.props.url}"${i ? ` style="${i}"` : ""}>`;
    }
    case 32775:
      return "<br>";
    case 40966:
      return e.push("</a>"), `<a href="${n.props.url || "#"}">`;
    case 40974:
      return e.push("</sup>"), "<sup>";
    case 40973:
      return e.push("</sub>"), "<sub>";
    case 24578: {
      const i = n.props.tag || "p";
      e.push(`</${i}>`);
      const r = Zt(n.props);
      return `<${i}${r ? ` style="${r}"` : ""}>`;
    }
    case 24586: {
      e.push("</li>");
      const i = Zt(n.props);
      return `<li${i ? ` style="${i}"` : ""}>`;
    }
    case 40968: {
      const i = Xt(n.props);
      return e.push("</span>"), `<span${i ? ` style="${i}"` : ""}>`;
    }
    case 24585:
      return e.push("</ol>"), "<ol>";
    case 24584:
      return e.push("</ul>"), "<ul>";
    case 8191:
      return e.pop();
    case 32771: {
      const i = Xt(n.props);
      return i ? `<span style="${i}">${n.text}</span>` : so(n.text);
    }
    case 16396:
      return "<hr>";
    default:
      return console.log("Not supported node:", n), "";
  }
}
const Ua = new RegExp("[ ]{2,}|>[ ]{1,}", "g");
function so(n) {
  return n.replace(Ua, (e) => e[0] === ">" ? ">" + "&nbsp;".repeat(e.length - 1) : "&nbsp;".repeat(e.length));
}
function ao(n) {
  return so(ro(oo, n, null));
}
function Xt(n) {
  let e = "";
  return n && (n.bold && (e += "font-weight:bold;"), n.italic && (e += "font-style:italic;"), (n.underline || n.strike) && (e += `text-decoration:${n.underline ? "underline" : ""}${n.underline && n.strike ? " " : ""}${n.strike ? "line-through" : ""};`), n.color && (e += `color:${n.color};`), n.background && (e += `background:${n.background};`), n.fontSize && (e += `font-size:${n.fontSize};`), n.fontFamily && (e += `font-family:${n.fontFamily};`)), e;
}
function Zt(n) {
  let e = "";
  return n && n.align && (e += `text-align:${n.align};`), n && n.indent && (e += `margin-left:${n.indent}px;`), n && n.lineHeight && (e += `line-height:${n.lineHeight};`), e;
}
function lo(n) {
  let e = "";
  return n && n.width && (e += `width:${n.width}px;`), n && n.height && (e += `height:${n.height}px;`), e;
}
let ft;
function _i(n, e, t) {
  if (e == "paste") {
    const i = (t.clipboardData?.getData("text/plain") || "").replace(
      /\r/g,
      ""
    );
    if (i) {
      if (i != ft) {
        const r = [];
        if (i) {
          const o = i.split(`

`);
          o.forEach((s) => {
            o.length > 1 && r.push({ type: 24578, props: {} });
            const a = s.split(`
`);
            a.forEach((u, l) => {
              r.push({ type: 32771, props: {}, text: u }), l != a.length - 1 && r.push({ type: 32775, props: {} });
            }), o.length > 1 && r.push({ type: 8191, props: {} });
          });
        }
        n.getTape().copyArr = r;
      }
    } else {
      const r = t.clipboardData?.files;
      if (r) {
        const o = [...r].filter(
          (s) => s.type.indexOf("image") != -1
        );
        if (o.length) {
          const s = o.map((a) => {
            let u, l;
            const c = new Promise((f, h) => {
              u = f, l = h;
            }), d = new FileReader();
            return d.onloadend = () => u(d.result), d.onerror = () => l(), d.readAsDataURL(a), c;
          });
          return Promise.all(s).then(
            (a) => n.getTape().copyArr = a.map((u) => ({
              type: 32773,
              props: { url: u }
            }))
          ).finally(() => n.exec(Jt)), t.preventDefault();
        }
      }
    }
    n.exec(Jt);
  } else {
    e == "copy" ? n.exec(fi) : n.exec(hi);
    const i = [], r = [];
    n.getTape().copyArr.forEach((s) => r.push(oo(s, i))), t.clipboardData?.setData("text/html", r.join(""));
    const o = document.getSelection();
    ft = o ? o.toString() : "", t.clipboardData?.setData("text/plain", ft), ft = ft.replace(/\r/g, "");
  }
  t.preventDefault();
}
const qa = {
  Roboto: !0,
  Arial: !0,
  Georgia: !0,
  Tahoma: !0,
  "Times New Roman": !0,
  Verdana: !0
}, Ka = {
  "12px": !0,
  "14px": !0,
  "16px": !0,
  "18px": !0,
  "20px": !0,
  "24px": !0,
  "28px": !0,
  "32px": !0,
  "36px": !0
};
let vi = 1;
function Ga() {
  return vi;
}
function ja(n) {
  vi = n;
}
function Y() {
  return vi++;
}
function Va(n, e) {
  if (n) {
    debugger;
    throw e;
  }
}
class Ya {
  _pool;
  _order;
  _isDirty = -1;
  constructor(e) {
    this._pool = /* @__PURE__ */ new Map(), this._order = e;
  }
  getIndex(e) {
    let t = this._pool.get(e);
    return this.ensure(t) && (t = this._pool.get(e)), typeof t > "u" ? -1 : t;
  }
  setIndex(e, t) {
    this._pool.set(e, t);
  }
  deleteIndex(e) {
    for (let t = e.length - 1; t >= 0; t--)
      this._pool.delete(e[t]);
  }
  deleteIndexRange(e, t) {
    for (let i = e + t - 1; i >= e; i--)
      this._pool.delete(i);
  }
  ensure(e) {
    if (this._isDirty === -1 || e !== -1 && typeof e < "u" && this._isDirty > e)
      return !1;
    const t = this._order(), i = t.length;
    for (let r = this._isDirty; r < i; r++)
      this._pool.set(t[r].id, r);
    return this._isDirty = -1, !0;
  }
  setDirty(e) {
    (this._isDirty === -1 || e < this._isDirty) && (this._isDirty = e);
  }
}
const Ut = (n) => n.type & 32768 && !(n.type & 8192), Ye = (n) => (n.type & 16384) > 0, qt = {}, we = () => ({
  id: Y(),
  type: 8191,
  props: qt
});
class xi {
  _order;
  _pool;
  copyArr;
  constructor() {
    this.reset();
  }
  isEmpty() {
    return !this._order.length;
  }
  setDefault() {
    this.reset(), this.addBlock();
  }
  addBlock() {
    const e = { id: Y(), type: 32771, props: {}, text: "" };
    return this.addChunk(-1, { id: Y(), type: 24578, props: {} }), this.addChunk(-1, e), this.addChunk(-1, we()), e;
  }
  reset() {
    this._order = [], this._pool = new Ya(() => this._order);
  }
  parse(e) {
    this.reset(), this._order = [...e], this._pool.setDirty(0);
  }
  copy(e, t) {
    if (this.copyArr = [], t) {
      let i = 0;
      const r = this._getCursorSet(e).map((l) => {
        const c = structuredClone(this._order[l.pos]);
        return !i && Ye(c) && (i = l.id), delete c.id, c;
      }), o = this._getCursorSet(t).find(
        (l) => Ye(this._order[l.pos])
      )?.id;
      this.copyArr = r.reverse(), i == o && (this.copyArr = this.copyArr.filter((l) => !Ye(l)));
      const s = this._order.findIndex((l) => l.id == e.id), a = this._order.findIndex((l) => l.id == t.id);
      for (let l = s; l <= a; l++) {
        const c = this._order[l], d = structuredClone(c);
        delete d.id, c.text && (l == s ? d.text = d.text.substring(
          e.pos,
          s == a ? t.pos : d.text.length
        ) : l == a && (d.text = d.text.substring(0, t.pos))), this.copyArr.push(d);
      }
      let u = 0;
      this.copyArr.forEach((l) => {
        l.type == 8191 ? u-- : Ut(l) || u++;
      });
      for (let l = 0; l < u; l++)
        this.copyArr.push({ type: 8191, props: {} });
      if (this.copyArr[0].type == 24585 || this.copyArr[0].type == 24584) {
        const l = this.copyArr.length;
        for (let c = 0; c < l; c++) {
          const d = this.copyArr[c];
          if (!((d.type == 24584 || d.type == 24585) && this._getEndIndex(c, this.copyArr) == l - 1 - c)) {
            c > 1 && (this.copyArr = this.copyArr.slice(c - 1, l - (c - 1)));
            break;
          }
        }
      }
    }
  }
  paste(e) {
    if (!this.copyArr || !this.copyArr.length)
      return;
    const t = this._order.findIndex((a) => a.id == e.id), i = this._order[t];
    let r = this._getCursorSet(e).map((a) => this._order[a.pos]);
    const o = r.filter((a) => Ye(a));
    let s = [...this.copyArr].map((a) => ({ ...a, id: Y() }));
    return o[0].type == 24586 && (s[0].type == 24585 || s[0].type == 24584) && this._getEndIndex(0, s) == s.length - 1 && (s = s.slice(1, s.length - 1), r = r.splice(0, r.indexOf(o[0]) + 1)), s[0].type & 32768 && (r = r.filter((a) => !Ye(a))), this._paste(i, s, e, r, t);
  }
  _getPastePos(e, t, i, r) {
    let o = null;
    const s = t.pos == (i.text !== void 0 ? i.text.length : Fe);
    if (s || t.pos == 0) {
      for (let a = 0; a < e.length; a++)
        if (o = r + (a + 1) * (s ? 1 : -1), this._order[o].type != (s ? 8191 : e[a].type)) {
          o = null;
          break;
        }
      s && o && o++;
    }
    return o;
  }
  _paste(e, t, i, r, o) {
    const s = this._getPastePos(r, i, e, o);
    let a;
    s !== null ? (this._order.splice(s, 0, ...t), a = this._order.indexOf(t[t.length - 1])) : (t = [
      ...new Array(r.length).fill(void 0).map(() => ({ type: 8191, id: Y(), props: {} })),
      ...t,
      ...r.reverse().map((l) => {
        const c = structuredClone(l);
        return c.id = Y(), c;
      })
    ], (e.text && i.pos != 0 || e.type == 32773 && i.pos == Fe) && t.unshift({
      ...structuredClone(e),
      text: (e.text || "").substring(0, i.pos)
    }), a = o + t.length - 1, (e.text && i.pos != e.text.length || e.type == 32773 && i.pos == 0) && t.push({
      ...structuredClone(e),
      id: e.type == 32773 ? e.id : Y(),
      text: (e.text || "").substring(i.pos)
    }), this._order.indexOf(t[t.length - 1]), this._order.splice(o, 1, ...t));
    const u = this._order[this.getPrevIndex(
      a + 1,
      (l) => l.text !== void 0 || l.type == 32773
    )];
    return this._pool.setDirty(0), {
      id: u.id,
      pos: u.type == 32773 ? Fe : (u.text || "").length
    };
  }
  addChunkText(e, t, i) {
    const r = this._pool.getIndex(e), { index: o, pos: s } = this._ensureTextNode(r, t);
    return this._addChunkText(o, s, i);
  }
  ensureTextNode(e) {
    const t = this._pool.getIndex(e.id), { index: i, pos: r } = this._ensureTextNode(t, e.pos);
    return { id: this._order[i].id, pos: r };
  }
  _ensureTextNode(e, t) {
    let i = this._order[e];
    if (i.type !== 32771) {
      if (t === 0) {
        const r = this._order[e - 1];
        r.type !== 32771 ? this.addLeafChunk(e, 32771, "") : (t = r.text.length, e = e - 1);
      } else
        e = e + 1, this._order[e].type !== 32771 && this.addLeafChunk(e, 32771, ""), t = 0;
      i = this._order[e];
    }
    return { index: e, pos: t };
  }
  _addChunkText(e, t, i) {
    const r = this._order[e];
    return t < 0 && (t = r.text.length + 1 - t), Va(t > r.text.length, "invalid text position"), this._order[e] = {
      ...r,
      text: r.text.substring(0, t) + i + r.text.substring(t)
    }, { id: r.id, pos: t + i.length };
  }
  deleteChunkText(e, t, i) {
    const r = this._pool.getIndex(e), { index: o, pos: s } = this._ensureTextNode(r, t);
    return this._deleteChunkText(o, s, i);
  }
  _mergeAfterDelete(e, t, i) {
    if (t > 0) {
      const r = this._order[t], o = this._order[t + 1];
      this._canBeMerged(r, o) && (e.id == o.id && (e = { id: r.id, pos: r.text.length + e.pos }), this._order[t] = {
        ...r,
        text: r.text + o.text
      }, this._deleteChunk(t + 1, 1, 0), i && i.forEach((s) => {
        s.id === o.id && (s.id = r.id, s.pos = r.text.length + s.pos);
      }));
    }
    return e;
  }
  _canBeMerged(e, t) {
    if (e.type !== 32771 || t.type !== 32771)
      return !1;
    const i = Object.keys(e.props), r = Object.keys(t.props);
    return !(i.find((o) => t.props[o] !== e.props[o]) || r.find((o) => t.props[o] !== e.props[o]));
  }
  _deleteChunkText(e, t, i) {
    const r = this._order[e];
    t < 0 && r.type === 32771 && (t = r.text.length + 1 + t);
    let o = !1;
    const s = (u) => (!(u.type & 32768) && u.type !== 8191 && (o = !0), u.type & 32768 && !(u.type & 8192));
    let a = -1;
    if (i)
      if (t === 0) {
        const u = this.getPrevIndex(e, s);
        if (u >= 0) {
          const l = this._order[u];
          if (o) {
            const c = this.deleteRange(
              { id: l.id, pos: l.text ? l.text.length : 0 },
              { id: r.id, pos: 0 }
            );
            return r.text === "" && l.id !== r.id && (this.deleteChunk(r.id), a = u), this._mergeAfterDelete(c, u);
          }
          if (l.type === 32771)
            return r.text === "" && this._deleteChunk(e, 1, 0), this.deleteChunkText(l.id, -1, i);
          this._deleteChunk(u, 1, 0), a = u - 1;
        }
      } else {
        let u = r.text.substring(0, t);
        const l = [...new Intl.Segmenter().segment(u)].map(
          (c) => c.segment
        );
        return l.pop(), u = l.join(""), this._order[e] = {
          ...r,
          text: u + r.text.substring(t)
        }, { id: r.id, pos: u.length };
      }
    else if (t === r.text.length) {
      const u = this.getNextIndex(e, s);
      if (u >= 0) {
        const l = this._order[u];
        if (o)
          return this.deleteRange(
            { id: r.id, pos: r.text.length },
            { id: l.id, pos: 0 }
          );
        if (l.type === 32771)
          return r.text === "" && this._deleteChunk(e, 1, 0), this._mergeAfterDelete(
            this.deleteChunkText(l.id, 0, i),
            e - 1
          );
        this._deleteChunk(u, 1, 0), a = e;
      }
    } else {
      const u = r.text.substring(t), l = [...new Intl.Segmenter().segment(u)].map(
        (c) => c.segment
      );
      return l.shift(), this._order[e] = {
        ...r,
        text: r.text.substring(0, t) + l.join("")
      }, { id: r.id, pos: t };
    }
    return this._mergeAfterDelete({ id: r.id, pos: t }, a);
  }
  _tryToMerge(e, t) {
    const i = this._pool.getIndex(e);
    let r, o;
    if (t < 0 ? (r = i, o = this.getNextIndex(i, Ut)) : (o = i, r = this.getPrevIndex(i, Ut)), !r || !o)
      return;
    const s = this._order[r], a = this._order[o];
    if (s.type !== 32771 || a.type !== 32771)
      return;
    const u = this._getChunkSet(r), l = this._getChunkSet(o);
    if (u.length === l.length) {
      e:
        for (let c = 0; c < u.length; c++)
          if (u[c] !== l[c]) {
            for (let d = c; d < u.length; d++)
              if (u[c].type !== l[c].type || u[c].type & 16384)
                return;
            break e;
          }
      return this._order[r] = {
        ...s,
        text: s.text + a.text
      }, this._order.splice(r + 1, o - r), this._pool.setDirty(r + 1), { id: s.id, pos: s.text.length };
    }
  }
  _getChunk(e) {
    return this._order[this._pool.getIndex(e)];
  }
  _getEndIndex(e, t) {
    let i = e, r = 1;
    for (; r > 0; ) {
      i++;
      const o = (t || this._order)[i];
      o.type === 8191 && r--, o.type & 8192 && r++;
    }
    return i;
  }
  deleteChunk(e) {
    const t = this._pool.getIndex(e);
    if (t >= 0) {
      const i = (this._order[t].type & 8192 ? this._getEndIndex(t) - t : 0) + 1;
      this._deleteChunk(t, i, 0);
    }
  }
  _deleteChunk(e, t, i) {
    const r = this._order[e + t], o = this._order[e - 1];
    if (this._pool.deleteIndex(this._order.slice(e, e + t).map((s) => s.id)), this._order.splice(e, t), this._pool.setDirty(e), o && r && r.type === 8191 && o.type & 8192) {
      if (Vi & i) {
        const s = Y();
        return this._order.splice(e, 0, { id: s, type: 32771, text: "", props: {} }), { id: s, ind: e };
      } else if (this._order.length > 2)
        return this._deleteChunk(e - 1, 2, 0);
    }
    return { id: r.id, ind: e };
  }
  addLeafChunk(e, t, i) {
    const r = { id: Y(), text: i, type: t, props: qt };
    return this._order.splice(e, 0, r), this._pool.setDirty(e), r;
  }
  addBlockChunk(e, t, i) {
    const r = { id: Y(), type: t, props: i }, o = we();
    return this._order.splice(e, 0, r, o), this._pool.setDirty(e), r;
  }
  addChunk(e, t) {
    e === -1 ? (this._order.push(t), this._pool.setIndex(t.id, this._order.length - 1)) : (this._order.splice(e, 0, t), this._pool.setIndex(t.id, e), this._pool.setDirty(e));
  }
  nextIndex(e) {
    const t = this._pool.getIndex(e);
    return t >= 0 ? t + 1 : t;
  }
  prevIndex(e) {
    const t = this._pool.getIndex(e);
    return t >= 0 ? t - 1 : t;
  }
  forEach(e) {
    this._order.forEach(e);
  }
  getPrev(e, t) {
    return this._order[this.getNextIndex(e, t)];
  }
  getNext(e, t) {
    return this._order[this.getNextIndex(e, t)];
  }
  getPrevIndex(e, t) {
    for (; --e >= 0; ) {
      const i = this._order[e];
      if (t(i))
        return e;
    }
    return -1;
  }
  getNextIndex(e, t) {
    const i = this._order.length;
    for (; ++e < i; ) {
      const r = this._order[e];
      if (t(r))
        return e;
    }
    return -1;
  }
  _ensureCursor(e) {
    const t = this._order[e];
    let i = t.type;
    if (i & 32768 && !(i & 8192))
      return { id: t.id, pos: 0 };
    const r = this._order[e - 1];
    return i = r.type, i & 32768 && !(i & 8192) ? {
      id: r.id,
      pos: r.type === 32771 ? r.text.length : Fe
    } : { id: this.addLeafChunk(e, 32771, "").id, pos: 0 };
  }
  getIndex(e) {
    return this._pool.getIndex(e);
  }
  deleteRange(e, t) {
    if (e.id === t.id) {
      const i = this._pool.getIndex(e.id), r = this._order[i];
      if (r.type === 32771)
        return this._order[i] = {
          ...r,
          text: r.text.substring(0, e.pos) + r.text.substring(t.pos)
        }, e;
      {
        const o = this._deleteChunk(i, 1, Vi);
        return this._ensureCursor(o.ind);
      }
    } else {
      const i = this._getCursorSet(e), r = this._getCursorSet(t);
      return this._normalizeBaseLevel(i, r), e = this.ensureTextNode(e), t = this.ensureTextNode(t), this._extractAndMergePart(i, r, e, t);
    }
  }
  getChunk(e) {
    return this._order[this._pool.getIndex(e)];
  }
  getChunkAt(e) {
    return this._order[e];
  }
  _getBlockCursor(e) {
    let t = this._pool.getIndex(e), i = 0;
    for (; t >= 0; ) {
      const r = this._order[t];
      if (r.type & 16384 && i <= 0)
        return { id: r.id, pos: t };
      r.type & 8192 ? i-- : r.type === 8191 && i++, t--;
    }
    throw "block not find";
  }
  _collectChunkCursors(e, t) {
    const i = [];
    let r = 1;
    for (; r > 0; ) {
      e++;
      const o = this._order[e];
      o.type === 8191 && r--, o.type & 8192 && r++, o.type === t && i.push({ id: o.id, pos: e });
    }
    return i;
  }
  _getParentCursor(e) {
    let t = this._pool.getIndex(e), i = 0;
    for (; t >= 0; ) {
      t--;
      const r = this._order[t];
      if (r.type & 8192 ? i-- : r.type === 8191 && i++, i < 0)
        return { id: r.id, pos: t };
    }
    throw "parent not find";
  }
  _getCursorSet(e) {
    const t = [];
    let i = this._pool.getIndex(e.id), r = 0;
    for (; i >= 0; i--) {
      const o = this._order[i];
      o.type === 8191 ? r -= 1 : o.type & 8192 && (r += 1, r > 0 && (t.push({ id: o.id, pos: i }), r = 0));
    }
    return t;
  }
  getParent(e, t) {
    let i = this._pool.getIndex(e.id), r = 0;
    for (; i >= 0; i--) {
      const o = this._order[i];
      if (o.type === 8191)
        r -= 1;
      else if (o.type & 8192 && (r += 1, r > 0)) {
        if (t(o))
          return { id: o.id, pos: i };
        r = 0;
      }
    }
    return null;
  }
  _getChunkSet(e) {
    const t = [];
    let i = 0;
    for (; e >= 0; e--) {
      const r = this._order[e];
      r.type === 8191 ? i -= 1 : r.type & 8192 && (i += 1, i > 0 && (t.push(r), i = 0));
    }
    return t;
  }
  _normalizeBaseLevel(e, t) {
    for (; e.length && t.length && e[e.length - 1].id === t[t.length - 1].id; )
      t.pop(), e.pop();
  }
  _extractAndMergePart(e, t, i, r) {
    const o = this._pool.getIndex(i.id), s = this._pool.getIndex(r.id), a = this._order[o], u = this._order[s];
    let l = e.map((v) => this._order[v.pos]), c = t.map((v) => this._order[v.pos]);
    a.type === 32771 && i.pos !== a.text.length && (this._order[o] = {
      ...a,
      text: a.text.substring(0, i.pos)
    }), u.type === 32771 && r.pos !== 0 && (this._order[s] = {
      ...u,
      text: u.text.substring(r.pos)
    });
    let d = s - o - 1, f = o + 1, h = -1;
    for (let v = 0; v < c.length; v++)
      if (c[v].type & 16384) {
        h = v;
        break;
      }
    let g = -1;
    for (let v = 0; v < l.length; v++)
      if (l[v].type & 16384) {
        g = v;
        break;
      }
    if (h != -1) {
      const v = t[h].pos, k = this._getEndIndex(v);
      let x = [];
      for (let w = 0; w < g; w++)
        x.push(we());
      for (let w = h - 1; w >= 0; w--)
        x.push(c[w]);
      const A = this._order.splice(s, k - s);
      x = x.concat(A), this._order.splice(o + 1, 0, ...x);
      const E = this._deleteEmptyBlocks(
        t[h].pos + x.length,
        s - v - 1
      );
      d -= E, c = c.slice(h + E), t = t.slice(h + E), l = l.slice(g), e = e.slice(g), this._pool.setDirty(o + 1), f += x.length;
    }
    const _ = [];
    for (let v = 0; v < l.length; v++)
      _.push(we());
    for (let v = c.length - 1; v >= 0; v--)
      _.push(c[v]);
    return this._deleteSegment(f, d, _), this._mergeAfterDelete(i, o);
  }
  _deleteEmptyBlocks(e, t, i = 0) {
    const r = this._order[e], o = this._order[e + 1 + i * 2 + t];
    return o && o.type === 8191 && r && r.type & 16384 ? this._deleteEmptyBlocks(e - 1, t, i + 1) : (i && this._deleteSegment(e + 1, i * 2 + t), i + t);
  }
  _deleteSegment(e, t, i = []) {
    if (!t)
      return;
    const r = [];
    for (let o = 0; o < t; o++)
      r.push(this._order[o + e].id);
    this._pool.deleteIndex(r), this._order.splice(e, t, ...i), this._pool.setDirty(e);
  }
  getLength() {
    return this._order.length;
  }
  getProps(e, t, i, r) {
    let o = this._pool.getIndex(e.id);
    const s = this._order[o], a = {}, u = Object.assign({}, s.props);
    let l = i && i[s.type];
    l && (i = null, l(e, s));
    const c = this._getCursorSet(e);
    for (let d = 0; d < c.length; d++) {
      const f = this._order[c[d].pos];
      f.props && Object.keys(f.props).length && (f.type & 16384 ? Object.assign(a, f.props) : Object.assign(u, f.props));
      const h = i && i[f.type];
      h && (i = null, h(c[d], f));
    }
    if (t) {
      o++;
      const d = this._pool.getIndex(t.id);
      for (; o <= d; ) {
        const f = this._order[o];
        f.type !== 8191 && (f.type & 16384 ? Xi(a, f.props) : Xi(u, f.props)), o++;
      }
    }
    if (l = i && i[0], l && l(e, s), r) {
      if (r & Wr)
        return a;
      if (r & oi)
        return u;
    }
    return { ...a, ...u };
  }
  insertChunk(e, t, i, r) {
    const { index: o, pos: s } = this._ensureTextNode(
      this._pool.getIndex(e.id),
      e.pos
    );
    if (t & 16384)
      return this._insertBlockChunk(
        {
          id: this._order[o].id,
          pos: s
        },
        t,
        i
      );
    const a = [], u = this._newTag(t, i, a), l = a.length > 1 || r & Zr, c = this._splitText(o, s, !l, a);
    this._order.splice(o + 1, 0, ...a), this._pool.setDirty(o + 1);
    const d = l ? u : c;
    return Rn.has(t) && this._cleanFromNested(o, o + a.length), { id: d, pos: 0 };
  }
  insertChunkNext(e, t, i) {
    const r = this._pool.getIndex(e.id), o = this._getEndIndex(r), s = [], a = this._newTag(t, i, s);
    return this._order.splice(o + 1, 0, ...s), this._pool.setDirty(o + 1), { id: a, pos: 0 };
  }
  _isEndOfBlock(e, t) {
    let i = this._order[e];
    if (i.type === 32771) {
      if (t !== i.text.length)
        return 0;
      e++;
    }
    for (; i = this._order[e], i; ) {
      if (i.type & 16384)
        return e;
      if (i.type !== 8191)
        return 0;
      e++;
    }
    return -1;
  }
  _insertBlockChunk(e, t, i) {
    const r = this._pool.getIndex(e.id), o = this._isEndOfBlock(r, e.pos), s = this._getCursorSet(e);
    let a = [], u = null, l = !0;
    const c = Yr.get(t);
    let d = s.length, f = null;
    for (let v = 0; v < d; v++) {
      const k = this._order[s[v].pos];
      if (k.type & 16384) {
        if (c && c.includes(k.type)) {
          d = v, l = f != t;
          break;
        }
        l = k.type !== t;
      }
      a.push(we()), f = k.type;
    }
    l && (i || (i = {}), u = this._newTag(t, i, a));
    const h = r + 1 + a.length;
    for (let v = d - 1; v >= 0; v--) {
      const k = this._order[s[v].pos];
      a.push({ id: Y(), type: k.type, props: o ? qt : k.props });
    }
    let g, _ = 0;
    return o ? (_ = d - 1, a = a.slice(0, a.length - _), g = Y(), a.push({ id: g, type: 32771, text: "", props: qt })) : g = this._splitText(r, e.pos, !l, a), this._order.splice(r + 1, _, ...a), this._pool.setDirty(r + 1), o || this._deleteEmptyBlocks(h, 0), { id: u || g, pos: 0 };
  }
  _splitText(e, t, i, r) {
    const o = this._order[e], s = o.text.length !== t || t === 0;
    let a = 0;
    return s && (this._order[e] = {
      ...o,
      text: o.text.substring(0, t)
    }), (s || i) && (a = Y(), r.push({
      id: a,
      type: o.type,
      text: o.text.substring(t),
      props: { ...o.props }
    })), a;
  }
  _splitTextAt(e, t, i) {
    const r = [], o = this._splitText(e, t, i, r);
    return r.length && (this._order.splice(e + 1, 0, ...r), this._pool.setDirty(e + 1)), o;
  }
  _newTag(e, t, i) {
    if (e & 8192) {
      const o = Y();
      return i.push(
        { id: Y(), type: e, props: t },
        { id: o, type: 32771, text: "", props: {} },
        we()
      ), o;
    }
    const r = { id: Y(), type: e, props: t };
    return e === 32771 && (r.text = ""), i.push(r), r.id;
  }
  unwrapRange(e, t, i) {
    const r = this._getCursorSet(e);
    for (let o = 0; o < r.length; o++) {
      const s = r[o].pos;
      if (this._order[s].type === i) {
        const a = this._getEndTag(s), u = t ? [t] : [];
        this._order.splice(a, 1), this._mergeAfterDelete(e, a - 1, u), this._order.splice(s, 1), e = this._mergeAfterDelete(e, s - 1, u), this._pool.setDirty(s);
        break;
      }
    }
    return [e, t];
  }
  _getEndTag(e) {
    let t = 0;
    for (let i = e + 1; i < this._order.length; i++) {
      const r = this._order[i];
      if (r.type === 8191 && !t)
        return i;
      r.type === 8191 ? t-- : r.type & 8192 && t++;
    }
    return -1;
  }
  wrapNode(e, t, i) {
    const r = this._pool.getIndex(e.id);
    return this._order.splice(r + 1, 0, we()), this._order.splice(r, 0, { id: Y(), type: t, props: i }), this._pool.setDirty(r), e;
  }
  wrapRange(e, t, i, r) {
    const o = this._ensureTextNode(
      this._pool.getIndex(e.id),
      e.pos
    );
    let s = o.index;
    e = { id: this._order[s].id, pos: o.pos };
    const a = this._ensureTextNode(
      this._pool.getIndex(t.id),
      t.pos
    );
    let u = a.index;
    t = { id: this._order[u].id, pos: a.pos }, this._splitTextAt(u, t.pos, !1);
    const l = this._splitTextAt(s, e.pos, !1);
    s += l ? 1 : 0, u += (l ? 1 : 0) + 1;
    const c = this._order[s], d = this._order[u - 1];
    if (e.id === t.id)
      this._wrapRange(s, u, i, r);
    else {
      let f = this._getCursorSet(e), h = this._getCursorSet(t);
      if (this._normalizeBaseLevel(f, h), !f.length && !h.length)
        this._wrapRange(s, u, i, r);
      else {
        f = this._topInlineLevel(f), h = this._topInlineLevel(h);
        const g = this._formSplit(f, f), _ = this._formSplit(h, h);
        this._injectBlock(u, _), this._injectBlock(s, g), s += f.length, u += f.length * 2 + h.length, this._wrapOneByOne(s, u, i, r);
      }
    }
    return [
      { id: c.id, pos: 0 },
      { id: d.id, pos: d.text.length }
    ];
  }
  toArray() {
    return [...this._order];
  }
  _wrapRange(e, t, i, r) {
    this._order.splice(e, 0, {
      id: Y(),
      type: i,
      props: r
    }), this._order.splice(t + 1, 0, we()), this._cleanFromNested(e, t + 2), this._pool.setDirty(e);
  }
  _formSplit(e, t) {
    const i = [];
    for (let r = e.length - 1; r >= 0; r--)
      i.push(we());
    for (let r = t.length - 1; r >= 0; r--) {
      const o = this._order[t[r].pos];
      i.push({ id: o.id, type: o.type, props: { ...o.props } });
    }
    return i;
  }
  _injectBlock(e, t) {
    this._order.splice(e, 0, ...t), this._pool.setDirty(e);
  }
  _wrapOneByOne(e, t, i, r) {
    let o = 0, s = 2;
    for (this._order.splice(t, 0, we()), t -= 1; t > e; ) {
      const a = this._order[t];
      a.type === 8191 ? (o++, o === 0 && (this._order.splice(t, 0, we()), s++)) : a.type & 8192 && (o--, o === -1 && (this._order.splice(t + 1, 0, { id: Y(), type: i, props: r }), s++)), t--;
    }
    this._order.splice(e, 0, { id: Y(), type: i, props: r }), this._cleanFromNested(e, t + s);
  }
  _cleanFromNested(e, t) {
    const i = this._getChunkSet(e - 1).reverse(), r = i.map((o) => o.type);
    for (let o = e; o < t; o++) {
      const s = this._order[o], a = Rn.get(s.type);
      if (a) {
        const u = r.findIndex((l) => a.has(l));
        if (u !== -1) {
          const l = i.length - u, c = this._getEndIndex(o) + l;
          for (let d = i.length - 1; d >= u; d--)
            this._order.splice(o, 0, we());
          for (let d = u; d < i.length; d++)
            this._order.splice(c + l, 0, { ...i[d], id: Y() });
          o -= 1, t += l * 2;
          continue;
        }
      }
      s.type & 8192 && (i.push(s), r.push(s.type)), s.type === 8191 && (i.pop(), r.pop());
    }
    return !0;
  }
  _topInlineLevel(e) {
    const t = e.length;
    for (let i = 0; i < t; i++)
      if (this._order[e[i].pos].type & 16384)
        return e.slice(0, i);
    return e;
  }
  _setChunkProperty(e, t, i) {
    const r = this._pool.getIndex(e.id);
    this._setPropertyRange(r, r, () => !0, t, i);
  }
  _setBlockProperty(e, t, i, r) {
    const o = this.getPrevIndex(this._pool.getIndex(e.id), Ye);
    let s = o;
    t && t.id !== e.id && (s = this.getPrevIndex(this._pool.getIndex(t.id), Ye)), this._setPropertyRange(o, s, (a) => (a.type & 16384) > 0, i, r);
  }
  findChunk(e) {
    for (let t = 0; t < this._order.length; t++) {
      const i = this._order[t];
      if (e(i))
        return { id: i.id, pos: t };
    }
    return null;
  }
  patchChunk(e, t) {
    const i = this._pool.getIndex(e), r = this._order[i];
    if (r)
      for (const o in t)
        t[o] === null ? delete r.props[o] : r.props[o] = t[o];
    this._order[i] = { ...r }, this._pool.setDirty(i);
  }
  _setPropertyRange(e, t, i, r, o) {
    const s = o === ji ? [] : Object.keys(r);
    for (let a = e; a <= t; a++) {
      const u = this._order[a];
      if (i(u)) {
        let l;
        if (o === ji)
          l = { ...r };
        else {
          l = u.props ? { ...u.props } : {};
          for (let c = 0; c < s.length; c++) {
            const d = s[c];
            r[d] === null ? delete l[d] : l[d] = r[d];
          }
        }
        this._order[a] = { ...u, props: l };
      }
    }
  }
  _setProperty(e, t, i, r) {
    let o = e.id, s = e.pos, a, u = 0, l = this._pool.getIndex(e.id), c;
    if (!t)
      c = l;
    else {
      a = t.id, u = t.pos, c = this._pool.getIndex(t.id);
      const f = this._order[c];
      f.type === 32771 && t.pos < f.text.length && (t.pos === 0 ? c-- : (this._breakNode(f, c, t.pos), u = t.pos));
      const h = this._order[l];
      if (h.type === 32771 && e.pos > 0)
        if (e.pos === h.text.length)
          l++;
        else {
          const g = this._breakNode(h, l, e.pos);
          o = g.id, s = 0, h.id === f.id && (a = g.id, u -= e.pos), l++, c++;
        }
    }
    this._setPropertyRange(l, c, (f) => f.type === 32771, i, r);
    const d = a ? this._mergeAfterDelete({ id: a, pos: u }, c) : null;
    return d || this._mergeAfterDelete({ id: o, pos: s }, l), [this._mergeAfterDelete(
      { id: o, pos: s },
      l - 1,
      d ? [d] : void 0
    ), d];
  }
  _breakNode(e, t, i) {
    this._order[t] = {
      ...e,
      text: e.text.slice(0, i)
    };
    const r = Y(), o = {
      ...e,
      id: r,
      type: e.type,
      props: { ...e.props },
      text: e.text.slice(i)
    };
    return this._order.splice(t + 1, 0, o), this._pool.setIndex(r, t + 1), this._pool.setDirty(t + 1), o;
  }
  _isEmptyBlock(e) {
    const t = this._pool.getIndex(e.id), i = this._getEndIndex(t);
    for (let r = t; r < i; r++) {
      const o = this._order[r];
      if (o.type === 32771 && o.text.length > 0)
        return !1;
    }
    return !0;
  }
}
function Xi(n, e) {
  Object.keys(n).forEach((t) => {
    e[t] !== n[t] && (n[t] = "");
  });
}
function co(n, e) {
  n = n.replace(/[\n\t ]+/g, " ");
  const t = (e ? e.document : document).createElement("div");
  t.innerHTML = n;
  const i = new xi();
  return uo(t, i, {}, {}, 0, !0), i;
}
const Wa = 1, yn = 2;
function uo(n, e, t, i, r, o) {
  const s = n.childNodes;
  for (let a = 0; a < s.length; a++)
    Ja(
      s[a],
      e,
      t,
      i,
      r,
      a,
      s.length - 1,
      o
    );
}
const mn = {};
function Ja(n, e, t, i, r, o, s, a) {
  if (n.nodeType === n.TEXT_NODE) {
    const h = Xa(n, r === 0 || r === yn && o === 0, r === 0 || r === yn && o === s);
    r === 0 ? h && h != " " && (e.addChunk(-1, { id: Y(), type: 24578, props: { ...t } }), e.addChunk(-1, { type: 32771, id: Y(), text: h, props: { ...i } }), e.addChunk(-1, { id: Y(), type: 8191, props: mn })) : a || e.addChunk(-1, { type: 32771, id: Y(), text: h, props: { ...i } });
    return;
  }
  const u = n.nodeName;
  if (u === "BR") {
    e.addChunk(-1, { type: 32775, id: Y(), props: {} });
    return;
  }
  let l = -1;
  const c = { ...i }, d = { ...t }, f = {};
  switch (Za(n, c, d), u) {
    case "H1":
      l = 24578, d.tag = "h1";
      break;
    case "H2":
      l = 24578, d.tag = "h2";
      break;
    case "H3":
      l = 24578, d.tag = "h3";
      break;
    case "H4":
      l = 24578, d.tag = "h4";
      break;
    case "H5":
      l = 24578, d.tag = "h5";
      break;
    case "H6":
      l = 24578, d.tag = "h6";
      break;
    case "BLOCKQUOTE":
      l = 24578, d.tag = "blockquote";
      break;
    case "B":
    case "STRONG":
      c.bold = !0;
      break;
    case "I":
    case "EM":
      c.italic = !0;
      break;
    case "U":
      c.underline = !0;
      break;
    case "STRIKE":
    case "S":
      c.strike = !0;
      break;
    case "A":
      f.url = n.getAttribute("href"), l = 40966;
      break;
    case "SUB":
      l = 40973;
      break;
    case "SUP":
      l = 40974;
      break;
    case "IMG":
      f.url = n.getAttribute("src"), l = 32773;
      break;
    case "HR":
      l = 16396;
      break;
    case "P":
      l = 24578, d.tag = "p";
      break;
    case "UL":
      l = 24584;
      break;
    case "OL":
      l = 24585;
      break;
    case "LI":
      l = 24586;
      break;
  }
  if (l != -1 && e.addChunk(-1, {
    id: Y(),
    type: l,
    props: { ...f, ...d }
  }), l === -1 || l & 8192) {
    if (d.tag && delete d.tag, n.childNodes.length === 0 && l & 16384)
      e.addChunk(-1, {
        type: 32771,
        id: Y(),
        props: mn,
        text: ""
      });
    else {
      const h = l == 24585 || l == 24584, g = l !== -1 && l & 16384 ? yn : Wa;
      uo(n, e, d, c, g, h);
    }
    l !== -1 && e.addChunk(-1, { id: Y(), type: 8191, props: mn });
  }
}
function Xa(n, e, t) {
  let i = n.textContent.replace(/[\n\t ]{2,}/, " ");
  return e && i[0] === " " && (i = i.substring(1)), t && i[i.length - 1] === " " && (i = i.substring(0, i.length - 1)), i.replace(/\xA0/g, " ");
}
function Za(n, e, t) {
  const {
    fontSize: i,
    fontWeight: r,
    textAlign: o,
    fontFamily: s,
    color: a,
    background: u,
    textDecoration: l,
    fontStyle: c,
    width: d,
    height: f
  } = n.style;
  let h = !1;
  return i && (e.fontSize = Ka[i] ? i : "14px", h = !0), r && (e.bold = r === "bold" || parseInt(r, 10) >= 600, h = !0), s && (e.fontFamily = qa[s] ? s : "Roboto", h = !0), a && (e.color = a, h = !0), u && (e.background = u, h = !0), l && (e.strike = l.indexOf("line-through") !== -1, e.underline = l.indexOf("underline") !== -1, h = !0), c && (e.italic = c === "italic", h = !0), o && (t.align = o, h = !0), d && (t.width = parseInt(d), h = !0), f && (t.height = parseInt(f), h = !0), h;
}
function Zi(n, e, t) {
  return e.wrapNode(t, 24586, {});
}
function Qa(n, e, t) {
  const i = e.getIndex(t.id);
  let r = e.getNext(i, Ut);
  return r || (r = e.addBlock()), { id: r.id, pos: 0 };
}
const $a = /* @__PURE__ */ new Map([
  [24584, Zi],
  [24585, Zi],
  [16396, Qa]
]);
class Qi {
  _handlers;
  constructor() {
    this._handlers = [];
  }
  add(e) {
    this._handlers.push(e);
  }
  call(e, t, i) {
    let r = !0;
    for (let o = 0; o < this._handlers.length; o++)
      this._handlers[o](e, t, i) === !1 && (r = !1);
    return r;
  }
}
class el {
  plugins;
  _start;
  _end;
  _tape;
  constructor(e) {
    e ? e === !0 ? this.reset(!0) : (this._tape = e, this.resetCursor()) : this.reset(), this.plugins = {
      action: new Qi(),
      change: new Qi()
    };
  }
  reset(e) {
    this._tape = new xi(), e || (this._tape.addBlockChunk(0, 24578, {}), this._tape.addLeafChunk(1, 32771, "")), this.resetCursor();
  }
  resetCursor() {
    const e = this._tape.getNext(-1, (t) => t.type === 32771);
    e && (this._start = { id: e.id, pos: 0 }, this._end = null);
  }
  getTape() {
    return this._tape;
  }
  setCursor(e, t) {
    this._start = e, this._end = t && (t.id !== e.id || t.pos !== e.pos) ? t : null;
  }
  getCursor() {
    return [this._start, this._end];
  }
  exec(e, t) {
    if (this.plugins.action.call(this, e, t)) {
      switch (e) {
        case ai: {
          this._deleteSelection(), this.doInsert(this._start, t);
          break;
        }
        case li: {
          if (!this._deleteSelection()) {
            const { id: i, pos: r } = this._start, o = this._tape.deleteChunkText(i, r, !0);
            this.setCursor(o);
          }
          break;
        }
        case ci: {
          if (!this._deleteSelection()) {
            const { id: i, pos: r } = this._start, o = this._tape.deleteChunkText(i, r, !1);
            this.setCursor(o);
          }
          break;
        }
        case fi: {
          this._tape.copy(this._start, this._end);
          break;
        }
        case hi: {
          this._tape.copy(this._start, this._end), this._deleteSelection();
          break;
        }
        case Jt: {
          this._deleteSelection();
          const i = this._tape.paste(this._start);
          i && this.setCursor(i);
          break;
        }
        case un: {
          this._deleteSelection();
          let { tag: i, props: r } = t;
          r = r || {};
          const { mode: o } = t;
          let s = this._start, a = 0;
          if (i === 16395) {
            const u = this._tape._getBlockCursor(s.id), l = this._tape.getChunkAt(u.pos);
            if (l.type === 24586 && this._tape._isEmptyBlock(l)) {
              const c = this._tape._getParentCursor(l.id), d = this._tape._collectChunkCursors(c.pos, 24586);
              i = 0, d.length === 1 ? (s = this._tape.insertChunkNext(c, 24578, {}), this._tape.deleteChunk(c.id)) : d[d.length - 1].id === l.id ? (s = this._tape.insertChunkNext(c, 24578, {}), this._tape.deleteChunk(l.id)) : i = l.type;
            } else
              i = l.type;
          } else if (i === 32771) {
            if (o === We || o === ha) {
              const u = this._tape.getChunk(s.id);
              if (u.type === 32771 && u.text === "") {
                this.doSetProperty(this._start, null, { props: r, mode: o });
                return;
              }
              const l = this._tape.getProps(
                s,
                null,
                null,
                oi
              );
              if (o === We)
                for (const h in r)
                  l[h] ? delete l[h] : l[h] = r[h];
              else
                Object.assign(l, r);
              r = l;
              const c = this._tape.getIndex(s.id), d = this._tape.getChunkAt(c + 1);
              if (u.type === 32771 && u.text.length === s.pos && d.type & 32768 && this._tape._canBeMerged({ id: 1, type: 32771, props: r }, d)) {
                this.setCursor({ id: d.id, pos: 0 });
                return;
              }
              const f = this._tape.getChunkAt(c - 1);
              if (s.pos === 0 && f.type & 32768 && this._tape._canBeMerged({ id: 1, type: 32771, props: r }, f)) {
                this.setCursor({
                  id: f.id,
                  pos: f.text.length
                });
                return;
              }
            }
            a = a | Zr;
          }
          if (i) {
            s = this._tape.insertChunk(s, i, r, a);
            const u = $a.get(i);
            u && (s = u(this, this._tape, s));
          }
          this.setCursor(s);
          break;
        }
        case Jr: {
          const { tag: i, props: r = {}, mode: o = 0 } = t;
          if (!this._end)
            throw "no end cursor";
          const [s, a] = this._tape.wrapRange(
            this._start,
            this._end,
            i,
            r
          ), u = o & _a;
          this.setCursor(u ? a : s, u ? null : a);
          break;
        }
        case Xr: {
          const { tag: i } = t, [r, o] = this._tape.unwrapRange(
            this._start,
            this._end,
            i
          );
          this.setCursor(r, o);
          break;
        }
        case di: {
          const { id: i, props: r } = t;
          this.getTape().patchChunk(i, r);
          break;
        }
        case ui: {
          this.doSetProperty(this._start, this._end, t);
          break;
        }
        case Wt: {
          const { data: i, reset: r } = t;
          this.getTape().parse(i), r && this.resetCursor();
          break;
        }
      }
      this.plugins.change.call(this);
    }
  }
  doSetProperty(e, t, i) {
    const { target: r, mode: o, cursor: s } = i;
    let a = i.props;
    if (o === We) {
      const u = this.getTape().getProps(e, null);
      a = { ...a };
      for (const l in a)
        u[l] && (a[l] = null);
    }
    r === pa ? this.getTape()._setBlockProperty(e, t, a, o) : r === ga || !t ? this.getTape()._setChunkProperty(s || e, a, o) : ([e, t] = this.getTape()._setProperty(e, t, a, o), this.setCursor(e, t));
  }
  doInsert(e, t) {
    const { id: i, pos: r } = e;
    e = this._tape.addChunkText(i, r, t), this.setCursor(e);
  }
  setValue(e, t) {
    t = t || co;
    const i = t(e);
    i.isEmpty() && i.setDefault(), this.exec(Wt, { data: i.toArray(), reset: !0 });
  }
  getValue(e) {
    return e = e || ao, e(this.getTape());
  }
  _deleteSelection() {
    if (this._end) {
      const e = this._tape.deleteRange(this._start, this._end);
      return this.setCursor(e), !0;
    }
    return !1;
  }
}
function tl(n, e, t) {
  switch (n.type) {
    case 40968:
    case 40966:
    case 32773:
      return "";
    case 32775:
      return `
`;
    case 24586:
      return t.secondLi ? `
- ` : (t.secondLi = !0, "- ");
    case 32771:
      return n.text;
    default:
      if (n.type & 16384)
        if (t.secondLi = !1, t.firstBlock)
          t.firstBlock = !1;
        else
          return `

`;
      return "";
  }
}
function nl(n) {
  return ro(tl, n, { firstBlock: !0 });
}
function il(n) {
  const e = new xi();
  return ol(e, n.split(`
`)), e;
}
const rl = {}, it = () => ({ id: Y(), type: 8191, props: rl });
function ol(n, e) {
  e.length || n.addChunk(-1, { type: 32771, id: Y(), text: "", props: {} });
  let t = 0, i = !1;
  e.forEach((r) => {
    if (!r.trim()) {
      t === 1 && (n.addChunk(-1, it()), i && (n.addChunk(-1, it()), i = !1), t = 0);
      return;
    }
    t === 0 ? (r.startsWith("- ") ? (n.addChunk(-1, { id: Y(), type: 24584, props: {} }), n.addChunk(-1, { id: Y(), type: 24586, props: {} }), r = r.substring(2), i = !0) : n.addChunk(-1, { id: Y(), type: 24578, props: {} }), t = 1) : t === 1 && (i && r.startsWith("- ") ? (n.addChunk(-1, it()), n.addChunk(-1, { id: Y(), type: 24586, props: {} }), r = r.substring(2)) : n.addChunk(-1, { type: 32775, id: Y(), props: {} })), n.addChunk(-1, { type: 32771, id: Y(), text: r, props: {} });
  }), t && (n.addChunk(-1, it()), i && n.addChunk(-1, it())), n.isEmpty() && (n.addChunk(-1, { id: Y(), type: 24578, props: {} }), n.addChunk(-1, { type: 32771, id: Y(), text: "", props: {} }), n.addChunk(-1, it()));
}
class sl {
  _state;
  _create;
  _update;
  constructor(e, t) {
    this._state = [], this._create = e, this._update = t;
  }
  render(e, t) {
    const i = this._state, r = i.length - 1, o = t.toArray(), s = o.length - 1;
    let a = e;
    e = e.firstChild;
    for (let u = 0, l = 0; u < r || l < s; ) {
      const c = i[u], d = o[l];
      if (!d || d.type === 8191 && c && c.type !== 8191)
        u = this._removeTillEnd(a, e, i, u);
      else if (!c || c.type === 8191 && d && d.type !== 8191)
        l = this._addTillEnd(a, e, o, l);
      else {
        if (c.type === 8191)
          e = a.nextSibling, a = a.parentNode;
        else if (d !== c && (e = this._updateDom(a, e, d, c)), d.type & 8192)
          c.type & 8192 ? (a = e, e = e.firstChild) : (l = this._addTillEnd(e, e.firstChild, o, l + 1), e = e.nextSibling);
        else {
          if (c.type & 8192) {
            let f = 1;
            for (; f > 0; ) {
              const h = i[u + 1].type;
              h & 8192 ? f++ : h === 8191 && f--, u++;
            }
          }
          e = e.nextSibling;
        }
        l++, u++;
      }
    }
    this._state = o;
  }
  _removeTillEnd(e, t, i, r) {
    let o = 1;
    for (; o; ) {
      const s = i[r];
      if (!s)
        return NaN;
      if (s.type === 8191)
        o--;
      else {
        if (o === 1 && t) {
          const a = t.nextSibling;
          e.removeChild(t), t = a;
        }
        s.type & 8192 && o++;
      }
      r++;
    }
    return r - 1;
  }
  _addTillEnd(e, t, i, r) {
    let o = 1;
    for (; o; ) {
      const s = i[r];
      if (!s)
        break;
      if (s.type === 8191)
        e = e.parentNode, o--;
      else {
        const a = this._addToDom(e, s, -1);
        s.type & 8192 && (o++, e = a);
      }
      r++;
    }
    return r - 1;
  }
  _addToDom(e, t, i) {
    const r = e.childNodes[i], o = this._create(t);
    return r ? e.insertBefore(o, r) : e.appendChild(o), o;
  }
  _removeFromDom(e, t) {
    e.removeChild(e.childNodes[t]);
  }
  _updateDom(e, t, i, r) {
    if (!this._update(t, i, r)) {
      const o = this._create(i);
      return this._replaceNode(
        e,
        t,
        o,
        (i.type & 8192) > 0 && (r.type & 8192) > 0
      ), o;
    }
    return t;
  }
  _replaceNode(e, t, i, r) {
    if (t) {
      if (e.insertBefore(i, t), r) {
        const o = t.childNodes.length;
        for (let s = 0; s < o; s++)
          i.appendChild(t.childNodes[0]);
      }
      e.removeChild(t);
    } else
      e.appendChild(i);
  }
}
function al(n, e) {
  const t = (e || window).document, { type: i, props: r, id: o, text: s } = n;
  let a;
  switch (i) {
    case 24578:
      a = t.createElement(r.tag || "p");
      break;
    case 24585:
      a = t.createElement("ol");
      break;
    case 24584:
      a = t.createElement("ul");
      break;
    case 16396:
      a = t.createElement("hr");
      break;
    case 24586:
      a = t.createElement("li");
      break;
    case 32775:
      a = t.createElement("br");
      break;
    case 32773: {
      a = t.createElement("img"), a.setAttribute("src", ho(n));
      const u = lo(r);
      u && a.setAttribute("style", u);
      break;
    }
    case 40966:
      a = t.createElement("a"), a.setAttribute("href", fo(n));
      break;
    case 40974:
      a = t.createElement("sup");
      break;
    case 40973:
      a = t.createElement("sub");
      break;
    default:
      a = t.createElement("span");
  }
  if (a.setAttribute("data-id", o.toString()), i === 32771) {
    a.appendChild(t.createTextNode(s || "​"));
    const u = Xt(r);
    u && a.setAttribute("style", u);
  } else if (i & 16384) {
    const u = Zt(r);
    u && a.setAttribute("style", u);
  }
  return a;
}
function ll(n, e, t) {
  if (e.type != t.type)
    return !1;
  if (e.id !== t.id && n.setAttribute("data-id", e.id.toString()), e.type === 32771) {
    if (e.text !== t.text && (n.firstChild.nodeValue = e.text || "​"), e.props !== t.props) {
      const i = Xt(e.props);
      i ? n.setAttribute("style", i) : n.hasAttribute("style") && n.removeAttribute("style");
    }
  } else {
    if (e.props !== t.props) {
      if (e.props.tag && t.props.tag && e.props.tag != t.props.tag)
        return !1;
      const i = Zt(e.props);
      i ? n.setAttribute("style", i) : n.hasAttribute("style") && n.removeAttribute("style");
    }
    if (e.type === 40966 && n.setAttribute("href", fo(e)), e.type === 32773) {
      n.setAttribute("src", ho(e));
      let i = "";
      e.props.width && (i += `width:${e.props.width}px;`), e.props.height && (i += `height:${e.props.height}px;`), i ? n.setAttribute("style", i) : n.removeAttribute("style");
    }
  }
  return !0;
}
function fo(n) {
  return n.props.url || "#";
}
function ho(n) {
  return n.props.url || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
}
const po = pi(), go = pi();
class cl {
  _history;
  _pointer;
  _skip;
  constructor() {
    this._skip = !1, this.reset();
  }
  undo(e) {
    if (this._pointer > 0) {
      const { order: t, left: i, right: r, seed: o } = this._history[this._pointer - 1];
      this.skip(() => {
        e.setCursor(i, r), ja(o), e.exec(Wt, { data: t }), this._pointer--;
      });
    }
  }
  redo(e) {
    if (this._pointer < this._history.length) {
      const { action: t, value: i, left: r, right: o } = this._history[this._pointer];
      this.skip(() => {
        e.setCursor(r, o), e.exec(t, i), this._pointer++;
      });
    }
  }
  skip(e) {
    const t = this._skip;
    this._skip = !0;
    try {
      e();
    } finally {
      this._skip = t;
    }
  }
  getState() {
    return [this._pointer > 0, this._pointer < this._history.length];
  }
  getHistory() {
    return this._history.slice(0, this._pointer);
  }
  reset() {
    this._pointer = 0, this._history = [];
  }
  call(e, t, i) {
    if (t === po)
      this.undo(e);
    else if (t === go)
      this.redo(e);
    else {
      if (this._skip || t === di)
        return;
      this._pointer < this._history.length && this._history.splice(this._pointer);
      const [r, o] = e.getCursor(), s = Ga();
      this._history.push({
        seed: s,
        action: t,
        value: i,
        order: e.getTape().toArray(),
        left: r,
        right: o
      }), this._pointer++;
    }
  }
}
const ul = {
  ...fa,
  ACTION_UNDO: po,
  ACTION_REDO: go
};
function dl(n, e = "data-id") {
  let t = n;
  for (!t.tagName && n.target && (t = n.target); t; ) {
    if (t.getAttribute && t.getAttribute(e))
      return t;
    t = t.parentNode;
  }
  return null;
}
function fl(n, e = "data-id") {
  const t = dl(n, e);
  return t ? _o(t.getAttribute(e)) : null;
}
function _o(n) {
  if (typeof n == "string") {
    const e = n * 1;
    if (!isNaN(e)) return e;
  }
  return n;
}
function hl() {
  return {
    addEvent: function(n, e, t) {
      return n.addEventListener(e, t), () => n.removeEventListener(e, t);
    },
    addGlobalEvent: function(n, e) {
      return document.addEventListener(n, e), () => document.removeEventListener(n, e);
    },
    getTopNode: function() {
      return window.document.body;
    }
  };
}
const Je = hl();
function pl(n) {
  Object.assign(Je, n);
}
function gl(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    if (n[t] === e) {
      n.splice(t, 1);
      break;
    }
}
let vo = /* @__PURE__ */ new Date(), Qt = !1, zt = [];
const Xe = [], $i = (n) => {
  if (Qt) {
    Qt = !1;
    return;
  }
  for (let e = Xe.length - 1; e >= 0; e--) {
    const { node: t, date: i, props: r } = Xe[e];
    if (!(i > vo) && !t.contains(n.target) && t !== n.target && (r.callback && r.callback(n), r.modal || n.defaultPrevented))
      break;
  }
}, _l = (n) => {
  vo = /* @__PURE__ */ new Date(), Qt = !0;
  for (let e = Xe.length - 1; e >= 0; e--) {
    const { node: t } = Xe[e];
    if (!t.contains(n.target) && t !== n.target) {
      Qt = !1;
      break;
    }
  }
};
function Nt(n, e) {
  zt.length || (zt = [
    Je.addGlobalEvent("click", $i),
    Je.addGlobalEvent("contextmenu", $i),
    Je.addGlobalEvent("mousedown", _l)
  ]), typeof e != "object" && (e = { callback: e });
  const t = { node: n, date: /* @__PURE__ */ new Date(), props: e };
  return Xe.push(t), {
    destroy() {
      gl(Xe, t), Xe.length || (zt.forEach((i) => i()), zt = []);
    }
  };
}
const vl = (n) => n.indexOf("bottom") !== -1, xl = (n) => n.indexOf("left") !== -1, er = (n) => n.indexOf("right") !== -1, yl = (n) => n.indexOf("top") !== -1, tr = (n) => n.indexOf("fit") !== -1, nr = (n) => n.indexOf("overlap") !== -1, ml = (n) => n.indexOf("center") !== -1;
function bl(n, e) {
  let t = 0;
  const i = Je.getTopNode();
  for (; n && n !== i; ) {
    const r = getComputedStyle(n).position;
    if ((r === "absolute" || r === "relative" || r === "fixed") && (t = parseInt(getComputedStyle(n).zIndex) || 0), n = n.parentNode, n === e) break;
  }
  return t;
}
let _e, He, ht, Se;
function xo(n, e, t = "bottom", i = 0, r = 0) {
  if (!n) return null;
  _e = i, He = r, ht = "auto";
  let o = 0, s = 0;
  const a = wl(n), u = nr(t) ? Je.getTopNode() : a;
  if (!a) return null;
  const l = a.getBoundingClientRect(), c = n.getBoundingClientRect(), d = u.getBoundingClientRect();
  if (e) {
    const g = bl(e, a);
    o = Math.max(g + 1, 20);
  }
  if (e) {
    if (Se = e.getBoundingClientRect(), tr(t) && (ht = Se.width + "px"), t !== "point")
      if (ml(t))
        tr(t) ? _e = 0 : (_e = d.width / 2, s = 1), He = (d.height - c.height) / 2;
      else {
        const g = nr(t) ? 0 : 1;
        _e = er(t) ? Se.right + g : Se.left - g, He = vl(t) ? Se.bottom + 1 : Se.top;
      }
  } else Se = { left: i, right: i, top: r, bottom: r };
  xl(t) && (_e = Se.left, s = 2), yl(t) && (He = Se.top - c.height);
  const f = He + c.height - d.bottom;
  return f > 0 && (He -= f), _e + c.width - d.right > 0 && (er(t) ? s = 2 : _e = d.right - c.width), s && (_e = Math.round(_e - c.width * s / 2)), _e < 0 && (t !== "left" ? _e = 0 : _e = Se.right), _e += u.scrollLeft - l.left, He += u.scrollTop - l.top, ht = ht || "auto", { x: _e, y: He, z: o, width: ht };
}
function wl(n) {
  const e = Je.getTopNode();
  for (; n; ) {
    n = n.parentNode;
    const t = getComputedStyle(n).position;
    if (n === e || t === "relative" || t === "absolute" || t === "fixed")
      return n;
  }
  return null;
}
let ir = (/* @__PURE__ */ new Date()).valueOf();
function yi() {
  return ir += 1, ir;
}
function rr(n) {
  return n && typeof n == "object" && !Array.isArray(n);
}
function zn(n, e) {
  for (const t in e) {
    const i = e[t];
    rr(n[t]) && rr(i) ? n[t] = zn(
      { ...n[t] },
      e[t]
    ) : n[t] = e[t];
  }
  return n;
}
function mi(n) {
  return {
    getGroup(e) {
      const t = n[e];
      return (i) => t && t[i] || i;
    },
    getRaw() {
      return n;
    },
    extend(e, t) {
      if (!e) return this;
      let i;
      return t ? i = zn({ ...e }, n) : i = zn({ ...n }, e), mi(i);
    }
  };
}
V(["input", "change"]);
const kl = (n, e) => {
  e.onclick && e.onclick(n);
};
var Cl = /* @__PURE__ */ L("<i></i>"), Sl = /* @__PURE__ */ L("<button><!> <!></button>");
function yo(n, e) {
  X(e, !0);
  let t = I(e, "type", 3, ""), i = I(e, "css", 3, ""), r = I(e, "icon", 3, ""), o = I(e, "disabled", 3, !1), s = I(e, "title", 3, ""), a = I(e, "text", 3, ""), u = /* @__PURE__ */ j(() => {
    let f = t() ? t().split(" ").filter((h) => h !== "").map((h) => "wx-" + h).join(" ") : "";
    return i() + (i() ? " " : "") + f;
  });
  var l = Sl();
  l.__click = [kl, e];
  var c = P(l);
  B(c, r, (f) => {
    var h = Cl();
    q(() => he(h, `${r() ?? ""} svelte-locm57`)), m(f, h);
  });
  var d = K(c, 2);
  B(
    d,
    () => e.children,
    (f) => {
      var h = Q(), g = U(h);
      ue(g, () => e.children), m(f, h);
    },
    (f) => {
      var h = ct();
      q(() => le(h, a())), m(f, h);
    }
  ), q(() => {
    te(l, "title", s()), he(l, `${`wx-button ${p(u)}` ?? ""} svelte-locm57`), l.disabled = o(), de(l, "wx-icon", r() && !e.children);
  }), m(n, l), Z();
}
V(["click"]);
V(["change"]);
var El = /* @__PURE__ */ L("<div><!></div>");
function Tl(n, e) {
  X(e, !0);
  let t = I(e, "position", 7, "bottom"), i = I(e, "align", 7, "start"), r = I(e, "autoFit", 3, !0), o = I(e, "oncancel", 3, null), s = I(e, "width", 3, "100%"), a;
  Ie(() => {
    if (r()) {
      const d = a.getBoundingClientRect(), f = document.body.getBoundingClientRect();
      return d.right >= f.right && i("end"), d.bottom >= f.bottom && t("top"), `${t()}-${i()}`;
    }
  });
  function u(d) {
    o() && o()(d);
  }
  var l = El(), c = P(l);
  ue(c, () => e.children ?? se), Re(l, (d, f) => Nt(d, f), () => u), oe(l, (d) => a = d, () => a), q(() => {
    he(l, `wx-dropdown ${`wx-${t()}-${i()}` ?? ""} svelte-1jzzq2v`), te(l, "style", `width:${s() ?? ""}`);
  }), m(n, l), Z();
}
V(["click"]);
V(["keydown", "change"]);
V(["click"]);
function Al() {
  let n = null, e = !1, t, i, r, o;
  const s = (f, h, g, _) => {
    t = f, i = h, r = g, o = _;
  }, a = (f) => {
    n = f, e = n !== null, r(n);
  }, u = (f, h) => {
    const g = f === null ? null : Math.max(0, Math.min(n + f, i.length - 1));
    g !== n && (a(g), t ? l(g, h) : requestAnimationFrame(() => l(g, h)));
  }, l = (f, h) => {
    if (f !== null && t) {
      const g = t.querySelectorAll(".wx-list > .wx-item")[f];
      g && (g.scrollIntoView({ block: "nearest" }), h && h.preventDefault());
    }
  };
  return { move: (f) => {
    const h = fl(f), g = i.findIndex((_) => _.id == h);
    g !== n && a(g);
  }, keydown: (f, h) => {
    switch (f.code) {
      case "Enter":
        e ? o() : a(0);
        break;
      case "Space":
        e || a(0);
        break;
      case "Escape":
        r(n = null);
        break;
      case "Tab":
        r(n = null);
        break;
      case "ArrowDown":
        u(e ? 1 : h || 0, f);
        break;
      case "ArrowUp":
        u(e ? -1 : h || 0, f);
        break;
    }
  }, init: s, navigate: u };
}
var Il = /* @__PURE__ */ L('<div class="wx-item svelte-fl05h9"><!></div>'), Dl = /* @__PURE__ */ L('<div class="wx-no-data svelte-fl05h9"> </div>'), Ll = /* @__PURE__ */ L('<div class="wx-list svelte-fl05h9"><!></div>');
function mo(n, e) {
  X(e, !0);
  let t = I(e, "items", 19, () => []), i = z(void 0), r = z(null);
  const o = fe("wx-i18n").getGroup("core"), { move: s, keydown: a, init: u, navigate: l } = Al(), c = (h) => {
    h && h.stopPropagation(), e.onselect && e.onselect({ id: t()[p(r)]?.id });
  };
  Ie(() => {
    u(p(i), t(), (h) => T(r, M(h)), c);
  }), be(() => {
    e.onready && e.onready({ navigate: l, keydown: a, move: s });
  });
  var d = Q(), f = U(d);
  B(f, () => p(r) !== null, (h) => {
    Tl(h, {
      oncancel: () => l(null),
      children: (g, _) => {
        var v = Ll();
        v.__click = c, v.__mousemove = s;
        var k = P(v);
        B(
          k,
          () => t().length,
          (x) => {
            var A = Q(), E = U(A);
            Me(E, 19, t, (w) => w.id, (w, S, O) => {
              var D = Il(), N = P(D);
              B(
                N,
                () => e.children,
                (H) => {
                  var b = Q(), y = U(b);
                  ue(y, () => e.children, () => ({ option: p(S) })), m(H, b);
                },
                (H) => {
                  var b = ct();
                  q(() => le(b, p(S).label)), m(H, b);
                }
              ), q(() => {
                te(D, "data-id", p(S).id), de(D, "wx-focus", p(O) === p(r));
              }), m(w, D);
            }), m(x, A);
          },
          (x) => {
            var A = Dl(), E = P(A);
            q(() => le(E, o("No data"))), m(x, A);
          }
        ), oe(v, (x) => T(i, x), () => p(i)), m(g, v);
      },
      $$slots: { default: !0 }
    });
  }), m(n, d), Z();
}
V(["click", "mousemove"]);
V(["click", "keydown", "input"]);
const bn = (n, e, t) => e.onchange && e.onchange({ value: t(), input: !0 }), wn = (n, e, t) => e.onchange && e.onchange({ value: t() });
function Nl(n, e, t) {
  n.stopPropagation(), e(""), t.onchange && t.onchange({ value: e() });
}
var Fl = /* @__PURE__ */ L('<input type="password" class="svelte-9z0rem">'), Pl = /* @__PURE__ */ L('<input type="number" class="svelte-9z0rem">'), Ol = /* @__PURE__ */ L('<input class="svelte-9z0rem">'), Ml = /* @__PURE__ */ L("<i></i>"), Rl = /* @__PURE__ */ L('<i class="wx-icon wxi-close svelte-9z0rem"></i> <!>', 1), Bl = /* @__PURE__ */ L("<i></i>"), Hl = /* @__PURE__ */ L("<div><!> <!></div>");
function Un(n, e) {
  X(e, !0);
  let t = I(e, "value", 15, ""), i = I(e, "id", 19, yi), r = I(e, "readonly", 3, !1), o = I(e, "focus", 3, !1), s = I(e, "select", 3, !1), a = I(e, "type", 3, "text"), u = I(e, "placeholder", 3, ""), l = I(e, "disabled", 3, !1), c = I(e, "error", 3, !1), d = I(e, "inputStyle", 3, ""), f = I(e, "title", 3, ""), h = I(e, "css", 3, ""), g = I(e, "clear", 3, !1), _ = /* @__PURE__ */ j(() => e.icon && h().indexOf("wx-icon-left") === -1 ? "wx-icon-right " + h() : h()), v = /* @__PURE__ */ j(() => e.icon && h().indexOf("wx-icon-left") !== -1), k;
  be(() => {
    setTimeout(
      () => {
        o() && k && k.focus(), s() && k && k.select();
      },
      1
    );
  });
  var x = Hl(), A = P(x);
  B(
    A,
    () => a() == "password",
    (w) => {
      var S = Fl();
      S.__input = [bn, e, t], S.__change = [wn, e, t], oe(S, (O) => k = O, () => k), q(() => {
        te(S, "id", i()), S.readOnly = r(), S.disabled = l(), te(S, "placeholder", u()), te(S, "style", d()), te(S, "title", f());
      }), xn(S, t), m(w, S);
    },
    (w) => {
      var S = Q(), O = U(S);
      B(
        O,
        () => a() == "number",
        (D) => {
          var N = Pl();
          N.__input = [bn, e, t], N.__change = [wn, e, t], oe(N, (H) => k = H, () => k), q(() => {
            te(N, "id", i()), N.readOnly = r(), N.disabled = l(), te(N, "placeholder", u()), te(N, "style", d()), te(N, "title", f());
          }), xn(N, t), m(D, N);
        },
        (D) => {
          var N = Ol();
          N.__input = [bn, e, t], N.__change = [wn, e, t], oe(N, (H) => k = H, () => k), q(() => {
            te(N, "id", i()), N.readOnly = r(), N.disabled = l(), te(N, "placeholder", u()), te(N, "title", f()), te(N, "style", d());
          }), xn(N, t), m(D, N);
        },
        !0
      ), m(w, S);
    }
  );
  var E = K(A, 2);
  B(
    E,
    () => g() && !l() && t(),
    (w) => {
      var S = Rl(), O = U(S);
      O.__click = [Nl, t, e];
      var D = K(O, 2);
      B(D, () => p(v), (N) => {
        var H = Ml();
        q(() => he(H, `wx-icon ${e.icon ?? ""} svelte-9z0rem`)), m(N, H);
      }), m(w, S);
    },
    (w) => {
      var S = Q(), O = U(S);
      B(
        O,
        () => e.icon,
        (D) => {
          var N = Bl();
          q(() => he(N, `wx-icon ${e.icon ?? ""} svelte-9z0rem`)), m(D, N);
        },
        null,
        !0
      ), m(w, S);
    }
  ), q(() => {
    he(x, `wx-text ${p(_) ?? ""} svelte-9z0rem`), de(x, "wx-error", c()), de(x, "wx-disabled", l()), de(x, "wx-clear", g());
  }), m(n, x), Z();
}
V(["input", "change", "click"]);
V(["click"]);
V(["click"]);
V(["click"]);
V(["click"]);
V(["click"]);
V(["click", "keydown", "input"]);
var zl = /* @__PURE__ */ L('<div class="wx-popup svelte-1e189n0"><!></div>');
function bi(n, e) {
  X(e, !0);
  let t = I(e, "left", 3, 0), i = I(e, "top", 3, 0), r = I(e, "at", 3, "bottom"), o = I(e, "parent", 3, null), s = null, a = z(0), u = z(0), l = z("auto");
  function c() {
    if (!s) return;
    const g = xo(s, o(), r(), t(), i());
    g && (T(a, M(g.x)), T(u, M(g.y)), T(l, M(g.width)));
  }
  e.mount && e.mount(c), be(c), Ie(() => {
    c(o());
  });
  function d(g) {
    e.oncancel && e.oncancel(g);
  }
  var f = zl(), h = P(f);
  ue(h, () => e.children ?? se), Re(f, (g, _) => Nt(g, _), () => d), oe(f, (g) => s = g, () => s), q(() => te(f, "style", `position:fixed;top:${p(u) ?? ""}px;left:${p(a) ?? ""}px;width:${p(l) ?? ""};`)), m(n, f), Z();
}
V(["click"]);
V(["change"]);
V(["click", "keydown"]);
V(["click"]);
V(["change", "click"]);
V(["input", "change"]);
V(["change"]);
V(["click"]);
V(["click", "input"]);
const Ul = (n) => n;
function bo(n, { delay: e = 0, duration: t = 400, easing: i = Ul } = {}) {
  const r = +getComputedStyle(n).opacity;
  return {
    delay: e,
    duration: t,
    easing: i,
    css: (o) => `opacity: ${o * r}`
  };
}
function ql(n, e) {
  e().remove && e().remove();
}
var Kl = /* @__PURE__ */ L('<div role="status" aria-live="polite"><div class="wx-text svelte-764ko7"> </div> <div class="wx-button svelte-764ko7"><i class="wxi-close svelte-764ko7"></i></div></div>');
function Gl(n, e) {
  X(e, !0);
  let t = I(e, "notice", 19, () => ({}));
  var i = Kl(), r = P(i), o = P(r), s = K(r, 2), a = P(s);
  a.__click = [ql, t], q(() => {
    he(i, `wx-notice wx-${(t().type ? t().type : "") ?? ""} svelte-764ko7`), le(o, t().text);
  }), Vr(3, i, () => bo), m(n, i), Z();
}
V(["click"]);
var jl = /* @__PURE__ */ L('<div class="wx-notices svelte-ervf1h"></div>');
function Vl(n, e) {
  let t = I(e, "data", 19, () => []);
  var i = jl();
  Me(i, 21, t, (r) => r.id, (r, o) => {
    Gl(r, {
      get notice() {
        return p(o);
      }
    });
  }), m(n, i);
}
function Yl(n, e) {
  switch (n.code) {
    case "Enter": {
      const t = n.target.tagName;
      if (t === "TEXTAREA" || t === "BUTTON") return;
      e.onconfirm && e.onconfirm({ ev: n });
      break;
    }
    case "Escape":
      e.oncancel && e.oncancel({ ev: n });
      break;
  }
}
var Wl = /* @__PURE__ */ L('<div class="wx-header svelte-at32q2"> </div>'), Jl = /* @__PURE__ */ L('<div class="wx-button svelte-at32q2"><!></div>'), Xl = /* @__PURE__ */ L('<div class="wx-buttons svelte-at32q2"></div>'), Zl = /* @__PURE__ */ L('<div class="wx-modal svelte-at32q2" tabindex="0"><div class="wx-window svelte-at32q2"><!> <div><!></div> <!></div></div>');
function Ql(n, e) {
  X(e, !0);
  const t = fe("wx-i18n").getGroup("core"), i = I(e, "title", 3, ""), r = I(e, "buttons", 19, () => ["cancel", "ok"]);
  function o(h, g) {
    const _ = { ev: h, button: g };
    g === "cancel" ? e.oncancel && e.oncancel(_) : e.onconfirm && e.onconfirm(_);
  }
  let s;
  be(() => {
    s.focus();
  });
  var a = Zl();
  a.__keydown = [Yl, e];
  var u = P(a), l = P(u);
  B(
    l,
    () => e.header,
    (h) => {
      var g = Q(), _ = U(g);
      ue(_, () => e.header), m(h, g);
    },
    (h) => {
      var g = Q(), _ = U(g);
      B(
        _,
        i,
        (v) => {
          var k = Wl(), x = P(k);
          q(() => le(x, i())), m(v, k);
        },
        null,
        !0
      ), m(h, g);
    }
  );
  var c = K(l, 2), d = P(c);
  ue(d, () => e.children);
  var f = K(c, 2);
  B(
    f,
    () => e.footer,
    (h) => {
      var g = Q(), _ = U(g);
      ue(_, () => e.footer), m(h, g);
    },
    (h) => {
      var g = Xl();
      Me(g, 21, r, Ct, (_, v) => {
        var k = Jl(), x = P(k), A = /* @__PURE__ */ j(() => `block ${(p(v) === "ok" ? "primary" : "secondary") ?? ""}`);
        yo(x, {
          get type() {
            return p(A);
          },
          onclick: (E) => o(E, p(v)),
          children: (E, w) => {
            var S = ct();
            q(() => le(S, t(p(v)))), m(E, S);
          },
          $$slots: { default: !0 }
        }), m(_, k);
      }), m(h, g);
    }
  ), oe(a, (h) => s = h, () => s), Vr(3, a, () => bo, () => ({ duration: 100 })), m(n, a), Z();
}
V(["keydown"]);
var $l = /* @__PURE__ */ L("<!> <!> <!>", 1);
function ec(n, e) {
  X(e, !0);
  let t = z(null);
  function i(c) {
    return T(t, M({ ...c })), new Promise((d, f) => {
      p(t).resolve = (h) => {
        T(t, null), d(h);
      }, p(t).reject = (h) => {
        T(t, null), f(h);
      };
    });
  }
  let r = z(M([]));
  function o(c) {
    c = { ...c }, c.id = c.id || yi(), c.remove = () => T(r, M(p(r).filter((d) => d.id !== c.id))), c.expire != -1 && setTimeout(c.remove, c.expire || 5100), T(r, M([...p(r), c]));
  }
  Lt("wx-helpers", { showNotice: o, showModal: i });
  var s = $l(), a = U(s);
  ue(a, () => e.children ?? se);
  var u = K(a, 2);
  B(u, () => p(t), (c) => {
    Ql(c, {
      get title() {
        return p(t).title;
      },
      get buttons() {
        return p(t).buttons;
      },
      get onconfirm() {
        return p(t).resolve;
      },
      get oncancel() {
        return p(t).reject;
      },
      children: (d, f) => {
        var h = ct();
        q(() => le(h, p(t).message)), m(d, h);
      },
      $$slots: { default: !0 }
    });
  });
  var l = K(u, 2);
  Vl(l, {
    get data() {
      return p(r);
    }
  }), m(n, s), Z();
}
V(["click"]);
var tc = /* @__PURE__ */ L('<div class="wx-portal svelte-1dixdmq"><div><!></div></div>');
function wi(n, e) {
  X(e, !0);
  let t = null, i = I(e, "theme", 15, ""), r = [];
  const o = (c) => {
    r && r.push(c);
  };
  i() === "" && i(fe("wx-theme"));
  function s(c) {
    for (; c !== document.body && !c.getAttribute("data-wx-portal-root"); )
      c = c.parentNode;
    return c;
  }
  be(() => {
    (e.target || s(t)).appendChild(t), r && r.forEach((d) => d());
  }), oa(() => {
    t && t.parentNode && t.parentNode.removeChild(t);
  });
  var a = tc(), u = P(a), l = P(u);
  return ue(l, () => e.children ?? se, () => ({ mount: o })), oe(u, (c) => t = c, () => t), q(() => he(u, `wx-${i() ?? ""}-theme svelte-1dixdmq`)), m(n, a), Z({ mount: o });
}
function nc(n) {
  var e = Q(), t = U(e);
  Ks(
    t,
    () => `<style>
@font-face {
font-family: 'Roboto';
font-style: normal;
font-weight: 400;
src: local(''),
    url('https://cdn.svar.dev/fonts/roboto/regular.woff2') format('woff2'),
    url('https://cdn.svar.dev/fonts/roboto/regular.woff') format('woff');
}
@font-face {
font-family: 'Roboto';
font-style: normal;
font-weight: 500;
src: local(''),
    url('https://cdn.svar.dev/fonts/roboto/500.woff2') format('woff2'),
    url('https://cdn.svar.dev/fonts/roboto/500.woff') format('woff');
}
</style>`
  ), m(n, e);
}
var ic = /* @__PURE__ */ L('<link rel="preconnect" href="https://cdn.svar.dev" crossorigin=""> <!> <link rel="stylesheet" href="https://cdn.svar.dev/fonts/wxi/wx-icons.css">', 1), rc = /* @__PURE__ */ L('<div class="wx-material-theme" style="height:100%"><!></div>');
function or(n, e) {
  X(e, !0);
  let t = I(e, "fonts", 3, !0);
  Lt("wx-theme", "material");
  var i = Q();
  ri((o) => {
    var s = Q(), a = U(s);
    B(a, t, (u) => {
      var l = ic(), c = K(U(l), 2);
      nc(c), m(u, l);
    }), m(o, s);
  });
  var r = U(i);
  B(r, () => e.children, (o) => {
    var s = rc(), a = P(s);
    ue(a, () => e.children), m(o, s);
  }), m(n, i), Z();
}
const oc = "en-US", sc = {
  monthFull: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  monthShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  dayFull: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  dayShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  hours: "Hours",
  minutes: "Minutes",
  done: "Done",
  clear: "Clear",
  today: "Today",
  am: ["am", "AM"],
  pm: ["pm", "PM"],
  weekStart: 7,
  clockFormat: 24
}, ac = {
  ok: "OK",
  cancel: "Cancel",
  select: "Select",
  "No data": "No data"
}, lc = {
  timeFormat: "%H:%i",
  dateFormat: "%m/%d/%Y",
  monthYearFormat: "%F %Y",
  yearFormat: "%Y"
}, ki = {
  core: ac,
  calendar: sc,
  formats: lc,
  lang: oc
}, cc = "zh-CN", uc = {
  monthFull: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ],
  monthShort: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ],
  dayFull: [
    "星期日",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六"
  ],
  dayShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  hours: "小时",
  minutes: "分钟",
  done: "完成",
  clear: "清除",
  today: "今天",
  am: ["", ""],
  pm: ["", ""],
  weekStart: 7,
  clockFormat: 24
}, dc = {
  ok: "确定",
  cancel: "取消",
  select: "选择",
  "No data": "没有数据"
}, fc = {
  timeFormat: "%H:%i",
  dateFormat: "%Y-%m-%d",
  monthYearFormat: "%F %Y",
  yearFormat: "%Y"
}, hc = {
  core: dc,
  calendar: uc,
  formats: fc,
  lang: cc
}, pc = "de-DE", gc = {
  monthFull: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ],
  monthShort: [
    "Jan",
    "Feb",
    "Mrz",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  dayFull: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ],
  dayShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  hours: "Stunden",
  minutes: "Minuten",
  done: "Fertig",
  clear: "Entfernen",
  today: "Heute",
  weekStart: 1,
  clockFormat: 24
}, _c = {
  ok: "OK",
  cancel: "Abbrechen",
  select: "Auswählen",
  "No data": "Keine Daten"
}, vc = {
  timeFormat: "%H:%i",
  dateFormat: "%d.%m.%Y",
  monthYearFormat: "%F %Y",
  yearFormat: "%Y"
}, xc = {
  core: _c,
  calendar: gc,
  formats: vc,
  lang: pc
};
function yc(n, e) {
  X(e, !0);
  let t = I(e, "words", 3, null), i = I(e, "optional", 3, !1), r = fe("wx-i18n");
  r || (r = mi(ki)), r = r.extend(t(), i()), Lt("wx-i18n", r);
  var o = Q(), s = U(o);
  ue(s, () => e.children ?? se), m(n, o), Z();
}
var mc = Array.isArray, bc = Object.defineProperty;
function wc(n) {
  for (var e = 0; e < n.length; e++)
    n[e]();
}
let qn = !1, Kn = [];
function kc() {
  qn = !1;
  const n = Kn.slice();
  Kn = [], wc(n);
}
function Cc(n) {
  qn || (qn = !0, queueMicrotask(kc)), Kn.push(n);
}
function Sc(n) {
  try {
    return n();
  } finally {
  }
}
function Ec(n, e, t, i) {
  function r(o) {
    if (i.capture || Ac.call(e, o), !o.cancelBubble)
      return Sc(() => t.call(this, o));
  }
  return n.startsWith("pointer") || n.startsWith("touch") || n === "wheel" ? Cc(() => {
    e.addEventListener(n, r, i);
  }) : e.addEventListener(n, r, i), r;
}
function Tc(n, e, t, i = {}) {
  var r = Ec(e, n, t, i);
  return () => {
    n.removeEventListener(e, r, i);
  };
}
function Ac(n) {
  var e = this, t = (
    /** @type {Node} */
    e.ownerDocument
  ), i = n.type, r = n.composedPath?.() || [], o = (
    /** @type {null | Element} */
    r[0] || n.target
  ), s = 0, a = n.__root;
  if (a) {
    var u = r.indexOf(a);
    if (u !== -1 && (e === document || e === /** @type {any} */
    window)) {
      n.__root = e;
      return;
    }
    var l = r.indexOf(e);
    if (l === -1)
      return;
    u <= l && (s = u);
  }
  if (o = /** @type {Element} */
  r[s] || n.target, o !== e) {
    bc(n, "currentTarget", {
      configurable: !0,
      get() {
        return o || t;
      }
    });
    try {
      for (var c, d = []; o !== null; ) {
        var f = o.assignedSlot || o.parentNode || /** @type {any} */
        o.host || null;
        try {
          var h = o["__" + i];
          if (h !== void 0 && !/** @type {any} */
          o.disabled)
            if (mc(h)) {
              var [g, ..._] = h;
              g.apply(o, [n, ..._]);
            } else
              h.call(o, n);
        } catch (v) {
          c ? d.push(v) : c = v;
        }
        if (n.cancelBubble || f === e || f === null)
          break;
        o = f;
      }
      if (c) {
        for (let v of d)
          queueMicrotask(() => {
            throw v;
          });
        throw c;
      }
    } finally {
      n.__root = e, delete n.currentTarget;
    }
  }
}
(/* @__PURE__ */ new Date()).valueOf();
const Ic = {
  addEvent: Tc
};
pl(Ic);
const wo = {
  richtext: {
    // buttons/actions
    Undo: "Undo",
    Redo: "Redo",
    Style: "Style",
    "Font family": "Font family",
    "Font size": "Font size",
    Bold: "Bold",
    Italic: "Italic",
    Underline: "Underline",
    Strikethrough: "Strikethrough",
    Subscript: "Subscript",
    Superscript: "Superscript",
    "Text color": "Text color",
    "Background color": "Background color",
    "Left align": "Left align",
    "Center align": "Center align",
    "Right align": "Right align",
    Justify: "Justify",
    "Line height": "Line height",
    Outdent: "Outdent",
    Indent: "Indent",
    "Insert link": "Insert link",
    "Insert image": "Insert image",
    "Insert horizontal line": "Insert horizontal line",
    "Clear formatting": "Clear formatting",
    Print: "Print",
    "Fullscreen mode": "Fullscreen mode",
    "Layout mode": "Layout mode",
    "Classic mode": "Classic mode",
    "Document mode": "Document mode",
    // menubar exclusive options
    File: "File",
    Import: "Import",
    Export: "Export",
    Edit: "Edit",
    Cut: "Cut",
    Copy: "Copy",
    Paste: "Paste",
    View: "View",
    Insert: "Insert",
    Format: "Format",
    Help: "Help",
    New: "New",
    Link: "Link",
    Image: "Image",
    "Horizontal line": "Horizontal line",
    Text: "Text",
    "Heading 1": "Heading 1",
    "Heading 2": "Heading 2",
    "Heading 3": "Heading 3",
    "Heading 4": "Heading 4",
    "Heading 5": "Heading 5",
    "Heading 6": "Heading 6",
    Align: "Align",
    Left: "Left",
    Center: "Center",
    Right: "Right",
    Justified: "Justified",
    "Keyboard shortcuts": "Keyboard shortcuts",
    // clipboard
    "Operation failed. Please check your browser's clipboard permissions.": "Operation failed. Please check your browser's clipboard permissions.",
    // block style dropdown
    Heading: "Heading",
    Quote: "Quote",
    Paragraph: "Paragraph",
    "Text style": "Text style",
    Lists: "Lists",
    normal: "normal",
    default: "default",
    // lists
    "Bulleted list": "Bulleted list",
    "Numbered list": "Numbered list",
    // links
    "Enter text to display": "Enter text to display",
    "Paste link": "Paste link",
    "Link copied to clipboard": "Link copied to clipboard",
    // shortcut groups
    "Text formatting": "Text formatting",
    Editing: "Editing",
    "Special actions": "Special actions",
    // colors
    Black: "Black",
    Gray: "Gray",
    White: "White",
    Red: "Red",
    Orange: "Orange",
    Yellow: "Yellow",
    Lime: "Lime",
    Green: "Green",
    Teal: "Teal",
    Cyan: "Cyan",
    Blue: "Blue",
    Indigo: "Indigo",
    Magenta: "Magenta",
    // shades
    "Light gray": "Light gray",
    "Medium gray": "Medium gray",
    "Dark gray": "Dark gray",
    "Light red": "Light red",
    "Medium red": "Medium red",
    "Dark red": "Dark red",
    "Light orange": "Light orange",
    "Medium orange": "Medium orange",
    "Dark orange": "Dark orange",
    "Light yellow": "Light yellow",
    "Medium yellow": "Medium yellow",
    "Dark yellow": "Dark yellow",
    "Light lime": "Light lime",
    "Medium lime": "Medium lime",
    "Dark lime": "Dark lime",
    "Light green": "Light green",
    "Medium green": "Medium green",
    "Dark green": "Dark green",
    "Light teal": "Light teal",
    "Medium teal": "Medium teal",
    "Dark teal": "Dark teal",
    "Light cyan": "Light cyan",
    "Medium cyan": "Medium cyan",
    "Dark cyan": "Dark cyan",
    "Light blue": "Light blue",
    "Medium blue": "Medium blue",
    "Dark blue": "Dark blue",
    "Light indigo": "Light indigo",
    "Medium indigo": "Medium indigo",
    "Dark indigo": "Dark indigo",
    "Light magenta": "Light magenta",
    "Medium magenta": "Medium magenta",
    "Dark magenta": "Dark magenta"
  }
}, Dc = {
  richtext: {
    // buttons/actions,
    Undo: "撤销",
    Redo: "重做",
    Style: "样式",
    "Font family": "字体",
    "Font size": "字体大小",
    Bold: "粗体",
    Italic: "斜体",
    Underline: "下划线",
    Strikethrough: "删除线",
    Subscript: "下标",
    Superscript: "上标",
    "Text color": "文本颜色",
    "Background color": "背景颜色",
    "Left align": "左对齐",
    "Center align": "居中对齐",
    "Right align": "右对齐",
    Justify: "两端对齐",
    "Line height": "行高",
    Outdent: "减少缩进",
    Indent: "增加缩进",
    "Insert link": "插入链接",
    "Insert image": "插入图片",
    "Insert horizontal line": "插入水平线",
    "Clear formatting": "清除格式",
    Print: "打印",
    "Fullscreen mode": "全屏模式",
    "Layout mode": "布局模式",
    "Classic mode": "经典模式",
    "Document mode": "文档模式",
    // menubar exclusive options
    File: "文件",
    Import: "导入",
    Export: "导出",
    Edit: "编辑",
    Cut: "剪切",
    Copy: "复制",
    Paste: "粘贴",
    View: "视图",
    Insert: "插入",
    Format: "格式",
    Help: "帮助",
    New: "新建",
    Link: "链接",
    Image: "图片",
    "Horizontal line": "水平线",
    Text: "文本",
    "Heading 1": "标题 1",
    "Heading 2": "标题 2",
    "Heading 3": "标题 3",
    "Heading 4": "标题 4",
    "Heading 5": "标题 5",
    "Heading 6": "标题 6",
    Align: "对齐",
    Left: "左",
    Center: "居中",
    Right: "右",
    Justified: "两端对齐",
    "Keyboard shortcuts": "键盘快捷键",
    // clipboard
    "Operation failed. Please check your browser's clipboard permissions.": "操作失败。请检查浏览器的剪贴板权限。",
    // block style dropdown
    Heading: "标题",
    Quote: "引用",
    Paragraph: "段落",
    "Text style": "文本样式",
    Lists: "列表",
    normal: "普通的",
    default: "默认",
    // lists
    "Bulleted list": "项目符号列表",
    "Numbered list": "编号列表",
    // links
    "Enter text to display": "输入要显示的文本",
    "Paste link": "粘贴链接",
    "Link copied to clipboard": "链接已复制到剪贴板",
    // shortcut groups
    "Text formatting": "文本格式化",
    Editing: "编辑",
    "Special actions": "特殊操作",
    // colors
    Black: "黑色",
    Gray: "灰色",
    White: "白色",
    Red: "红色",
    Orange: "橙色",
    Yellow: "黄色",
    Lime: "酸橙色",
    Green: "绿色",
    Teal: "水鸭色",
    Cyan: "青色",
    Blue: "蓝色",
    Indigo: "靛蓝色",
    Magenta: "洋红色",
    // shades
    "Light gray": "浅灰色",
    "Medium gray": "中灰色",
    "Dark gray": "深灰色",
    "Light red": "浅红色",
    "Medium red": "中红色",
    "Dark red": "深红色",
    "Light orange": "浅橙色",
    "Medium orange": "中橙色",
    "Dark orange": "深橙色",
    "Light yellow": "浅黄色",
    "Medium yellow": "中黄色",
    "Dark yellow": "深黄色",
    "Light lime": "浅酸橙色",
    "Medium lime": "中酸橙色",
    "Dark lime": "深酸橙色",
    "Light green": "浅绿色",
    "Medium green": "中绿色",
    "Dark green": "深绿色",
    "Light teal": "浅水鸭色",
    "Medium teal": "中水鸭色",
    "Dark teal": "深水鸭色",
    "Light cyan": "浅青色",
    "Medium cyan": "中青色",
    "Dark cyan": "深青色",
    "Light blue": "浅蓝色",
    "Medium blue": "中蓝色",
    "Dark blue": "深蓝色",
    "Light indigo": "浅靛蓝色",
    "Medium indigo": "中靛蓝色",
    "Dark indigo": "深靛蓝色",
    "Light magenta": "浅洋红色",
    "Medium magenta": "中洋红色",
    "Dark magenta": "深洋红色"
  }
}, Lc = {
  richtext: {
    // buttons/actions
    Undo: "Rückgängig",
    Redo: "Wiederholen",
    Style: "Stil",
    "Font family": "Schriftart",
    "Font size": "Schriftgröße",
    Bold: "Fett",
    Italic: "Kursiv",
    Underline: "Unterstrichen",
    Strikethrough: "Durchgestrichen",
    Subscript: "Tiefgestellt",
    Superscript: "Hochgestellt",
    "Text color": "Textfarbe",
    "Background color": "Hintergrundfarbe",
    "Left align": "Linksbündig",
    "Center align": "Zentriert",
    "Right align": "Rechtsbündig",
    Justify: "Blocksatz",
    "Line height": "Zeilenhöhe",
    Outdent: "Einzug verringern",
    Indent: "Einzug erhöhen",
    "Insert link": "Link einfügen",
    "Insert image": "Bild einfügen",
    "Insert horizontal line": "Horizontale Linie einfügen",
    "Clear formatting": "Formatierung löschen",
    Print: "Drucken",
    "Fullscreen mode": "Vollbildmodus",
    "Layout mode": "Layout-Modus",
    "Classic mode": "Klassischer Modus",
    "Document mode": "Dokumentenmodus",
    // menubar exclusive options
    File: "Datei",
    Import: "Importieren",
    Export: "Exportieren",
    Edit: "Bearbeiten",
    Cut: "Ausschneiden",
    Copy: "Kopieren",
    Paste: "Einfügen",
    View: "Ansicht",
    Insert: "Einfügen",
    Format: "Format",
    Help: "Hilfe",
    New: "Neu",
    Link: "Link",
    Image: "Bild",
    "Horizontal line": "Horizontale Linie",
    Text: "Text",
    "Heading 1": "Überschrift 1",
    "Heading 2": "Überschrift 2",
    "Heading 3": "Überschrift 3",
    "Heading 4": "Überschrift 4",
    "Heading 5": "Überschrift 5",
    "Heading 6": "Überschrift 6",
    Align: "Ausrichten",
    Left: "Links",
    Center: "Zentriert",
    Right: "Rechts",
    Justified: "Blocksatz",
    "Keyboard shortcuts": "Tastenkürzel",
    // clipboard
    "Operation failed. Please check your browser's clipboard permissions.": "Operation fehlgeschlagen. Bitte überprüfen Sie die Berechtigungen für die Zwischenablage Ihres Browsers.",
    // block style dropdown
    Heading: "Überschrift",
    Quote: "Zitat",
    Paragraph: "Absatz",
    "Text style": "Textstil",
    Lists: "Listen",
    normal: "normal",
    default: "standard",
    // lists
    "Bulleted list": "Liste mit Aufzählungszeichen",
    "Numbered list": "Nummerierte Liste",
    // links
    "Enter text to display": "Text zum Anzeigen eingeben",
    "Paste link": "Link einfügen",
    "Link copied to clipboard": "Link in die Zwischenablage kopiert",
    // shortcut groups
    "Text formatting": "Textformatierung",
    Editing: "Bearbeitung",
    "Special actions": "Spezielle Aktionen",
    // colors
    Black: "Schwarz",
    Gray: "Grau",
    White: "Weiß",
    Red: "Rot",
    Orange: "Orange",
    Yellow: "Gelb",
    Lime: "Limette",
    Green: "Grün",
    Teal: "Türkis",
    Cyan: "Cyan",
    Blue: "Blau",
    Indigo: "Indigo",
    Magenta: "Magenta",
    // shades
    "Light gray": "Hellgrau",
    "Medium gray": "Mittelgrau",
    "Dark gray": "Dunkelgrau",
    "Light red": "Hellrot",
    "Medium red": "Mittelrot",
    "Dark red": "Dunkelrot",
    "Light orange": "Hellorange",
    "Medium orange": "Mittelorange",
    "Dark orange": "Dunkelorange",
    "Light yellow": "Hellgelb",
    "Medium yellow": "Mittleres Gelb",
    "Dark yellow": "Dunkelgelb",
    "Light lime": "Hellgrün",
    "Medium lime": "Mittleres Grün",
    "Dark lime": "Dunkelgrün",
    "Light green": "Hellgrün",
    "Medium green": "Mittleres Grün",
    "Dark green": "Dunkelgrün",
    "Light teal": "Hellblau",
    "Medium teal": "Mittelblau",
    "Dark teal": "Dunkelblau",
    "Light cyan": "Hellcyan",
    "Medium cyan": "Mittleres Cyan",
    "Dark cyan": "Dunkelcyan",
    "Light blue": "Hellblau",
    "Medium blue": "Mittelblau",
    "Dark blue": "Dunkelblau",
    "Light indigo": "Hellindigo",
    "Medium indigo": "Mittelindigo",
    "Dark indigo": "Dunkelindigo",
    "Light magenta": "Hellmagenta",
    "Medium magenta": "Mittleres Magenta",
    "Dark magenta": "Dunkelmagenta"
  }
};
(/* @__PURE__ */ new Date()).valueOf();
class Nc {
  constructor(e) {
    this._nextHandler = null, this._dispatch = e, this.exec = this.exec.bind(this);
  }
  async exec(e, t) {
    return this._dispatch(e, t), this._nextHandler && await this._nextHandler.exec(e, t), t;
  }
  setNext(e) {
    return this._nextHandler = e;
  }
}
(/* @__PURE__ */ new Date()).valueOf();
const ko = 2;
class Fc {
  constructor(e) {
    e && (this._writable = e.writable, this._async = e.async), this._values = {}, this._state = {};
  }
  setState(e, t = 0) {
    const i = {};
    return this._wrapProperties(
      e,
      this._state,
      this._values,
      "",
      i,
      t
    ), i;
  }
  getState() {
    return this._values;
  }
  getReactive() {
    return this._state;
  }
  _wrapProperties(e, t, i, r, o, s) {
    for (const a in e) {
      const u = t[a], l = i[a], c = e[a];
      if (u && (l === c && typeof c != "object" || c instanceof Date && l instanceof Date && l.getTime() === c.getTime()))
        continue;
      const d = r + (r ? "." : "") + a;
      u ? (u.__parse(c, d, o, s) && (i[a] = c), s & ko ? o[d] = u.__trigger : u.__trigger()) : (c && c.__reactive ? t[a] = this._wrapNested(c, c, d, o) : t[a] = this._wrapWritable(c), i[a] = c), o[d] = o[d] || null;
    }
  }
  _wrapNested(e, t, i, r) {
    const o = this._wrapWritable(e);
    return this._wrapProperties(e, o, t, i, r, 0), o.__parse = (s, a, u, l) => (this._wrapProperties(s, o, t, a, u, l), !1), o;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _wrapWritable(e) {
    const t = [], i = function() {
      for (let a = 0; a < t.length; a++)
        t[a](e);
    };
    return {
      subscribe: (a) => (t.push(a), this._async ? setTimeout(a, 1, e) : a(e), () => {
        const u = t.indexOf(a);
        u >= 0 && t.splice(u, 1);
      }),
      __trigger: () => {
        t.length && (this._async ? setTimeout(i, 1) : i());
      },
      __parse: function(a) {
        return e = a, !0;
      }
    };
  }
}
class Pc {
  constructor(e, t, i, r) {
    typeof e == "function" ? this._setter = e : this._setter = e.setState.bind(e), this._routes = t, this._parsers = i, this._prev = {}, this._triggers = /* @__PURE__ */ new Map(), this._sources = /* @__PURE__ */ new Map(), this._routes.forEach((o) => {
      o.in.forEach((s) => {
        const a = this._triggers.get(s) || [];
        a.push(o), this._triggers.set(s, a);
      }), o.out.forEach((s) => {
        const a = this._sources.get(s) || {};
        o.in.forEach((u) => a[u] = !0), this._sources.set(s, a);
      });
    }), this._routes.forEach((o) => {
      o.length = Math.max(
        ...o.in.map((s) => Co(s, this._sources, 1))
      );
    }), this._bus = r;
  }
  init(e) {
    const t = {};
    for (const i in e)
      if (this._prev[i] !== e[i]) {
        const r = this._parsers[i];
        t[i] = r ? r(e[i]) : e[i];
      }
    this._prev = this._prev ? { ...this._prev, ...e } : { ...e }, this.setState(t), this._bus && this._bus.exec("init-state", t);
  }
  setStateAsync(e) {
    const t = this._setter(e, ko);
    return this._async ? Object.assign(this._async.signals, t) : this._async = {
      signals: t,
      timer: setTimeout(this._applyState.bind(this), 1)
    }, t;
  }
  _applyState() {
    const e = this._async;
    if (e) {
      this._async = null, this._triggerUpdates(e.signals, []);
      for (const t in e.signals) {
        const i = e.signals[t];
        i && i();
      }
    }
  }
  setState(e, t = []) {
    const i = this._setter(e);
    return this._triggerUpdates(i, t), i;
  }
  _triggerUpdates(e, t) {
    const i = Object.keys(e), r = !t.length;
    t = t || [];
    for (let o = 0; o < i.length; o++) {
      const s = i[o], a = this._triggers.get(s);
      a && a.forEach((u) => {
        t.indexOf(u) == -1 && t.push(u);
      });
    }
    r && this._execNext(t);
  }
  _execNext(e) {
    for (; e.length; ) {
      e.sort((i, r) => i.length < r.length ? 1 : -1);
      const t = e[e.length - 1];
      e.splice(e.length - 1), t.exec(e);
    }
  }
}
function Co(n, e, t) {
  const i = e.get(n);
  if (!i) return t;
  const r = Object.keys(i).map((o) => Co(o, e, t + 1));
  return Math.max(...r);
}
class Oc {
  constructor() {
    this._nextHandler = null, this._handlers = {}, this._tag = /* @__PURE__ */ new WeakMap(), this.exec = this.exec.bind(this);
  }
  on(e, t, i) {
    let r = this._handlers[e];
    r ? i && i.intercept ? r.unshift(t) : r.push(t) : r = this._handlers[e] = [t], i && i.tag && this._tag.set(t, i.tag);
  }
  intercept(e, t, i) {
    this.on(e, t, { ...i, intercept: !0 });
  }
  detach(e) {
    for (const t in this._handlers) {
      const i = this._handlers[t];
      for (let r = i.length - 1; r >= 0; r--)
        this._tag.get(i[r]) === e && i.splice(r, 1);
    }
  }
  async exec(e, t) {
    const i = this._handlers[e];
    if (i)
      for (let r = 0; r < i.length; r++) {
        const o = i[r](t);
        if (o === !1 || o && o.then && await o === !1)
          return;
      }
    return this._nextHandler && await this._nextHandler.exec(e, t), t;
  }
  setNext(e) {
    return this._nextHandler = e;
  }
}
const Mc = () => {
  const n = {
    "*": {
      "font-family": "Arial"
    },
    p: {
      "font-size": "14px"
    },
    blockquote: {
      "font-size": "14px"
    },
    h1: {
      "font-size": "32px"
    },
    h2: {
      "font-size": "24px"
    },
    h3: {
      "font-size": "18px"
    },
    h4: {
      "font-size": "16px"
    },
    h5: {
      "font-size": "14px"
    },
    h6: {
      "font-size": "12px"
    }
  };
  for (const e in n)
    n[e] = {
      ...n["*"],
      ...n[e]
    };
  return n;
};
function $t(n, e) {
  const t = n.getUploader(), i = e === "image" ? "insert-image" : "import";
  return { handler: () => t.openDialog(e, (s) => n.exec(i, s)), context: {
    uploaded: (s) => n.exec(i, s)
  } };
}
function Rc(n, e) {
  const t = document.createElement("a");
  t.href = URL.createObjectURL(n), t.download = e, document.body.appendChild(t), t.click(), document.body.removeChild(t), URL.revokeObjectURL(t.href);
}
const Bc = /* @__PURE__ */ new Map([
  [24584, [24586]],
  [24585, [24586]]
]), Hc = /* @__PURE__ */ new Map([
  [24586, [24585, 24584]],
  [24585, [24585, 24584]],
  [24584, [24585, 24584]]
]), zc = /* @__PURE__ */ new Map([
  [40966, /* @__PURE__ */ new Set([40966])],
  [40974, /* @__PURE__ */ new Set([40973, 40974])],
  [40973, /* @__PURE__ */ new Set([40973, 40974])]
]), Uc = 8388608, qc = 1, Kc = 2, So = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  OTHER: 0,
  INLINE: 32768,
  TEXT: 32771,
  FORMAT: 40964,
  PARAGRAPH: 24578,
  IMAGE: 32773,
  RULER: 16396,
  LINK: 40966,
  SUBSCRIPT: 40973,
  SUPERSCRIPT: 40974,
  NEWLINE: 32775,
  END: 8191,
  SPAN: 40968,
  OL: 24585,
  UL: 24584,
  LI: 24586,
  BREAK: 16395,
  BLOCK: 16384,
  CONTAINS: 8192,
  CHUNK_END_CURSOR: Uc,
  blockKids: Bc,
  blockParents: Hc,
  nestingLogic: zc,
  BLOCK_STYLES: qc,
  INLINE_STYLES: Kc
}, Symbol.toStringTag, { value: "Module" })), Gc = 1, jc = 2, Vc = 3, Yc = 6, Wc = 7, Jc = 8, Xc = 10, Zc = 11, Qc = 12, $c = 13, eu = 14, tu = 15;
let nu = 1e3;
function Ci() {
  return nu++;
}
const iu = 1001, ru = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addAction: Ci,
  ACTION_TYPE: Gc,
  ACTION_BACKSPACE: jc,
  ACTION_DELETE: Vc,
  ACTION_INSERT: Yc,
  ACTION_WRAP: Wc,
  FOCUS_MOVE: iu,
  ACTION_RESET: Jc,
  ACTION_SET_PROPERTY: Xc,
  ACTION_PATCH: Zc,
  ACTION_UNWRAP: Qc,
  ACTION_COPY: $c,
  ACTION_CUT: eu,
  ACTION_PASTE: tu
}, Symbol.toStringTag, { value: "Module" })), ou = 0, su = 1, au = 2, lu = 0, cu = 1, uu = 2, du = 1, fu = 2, hu = 4, Eo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PROPS_TEXT: lu,
  PROPS_BLOCK: cu,
  PROPS_UPDATE: ou,
  PROPS_REPLACE: au,
  PROPS_TOGGLE: su,
  PROPS_CHUNK: uu,
  ENSURE_TEXT_NODE: du,
  FOCUS_NEW_CHUNK: fu,
  FOCUS_CHUNK_END: hu
}, Symbol.toStringTag, { value: "Module" }));
typeof navigator < "u" && navigator.platform.indexOf("Mac") > -1;
const pu = Ci(), gu = Ci(), To = {
  ...ru,
  ACTION_UNDO: pu,
  ACTION_REDO: gu
}, { TEXT: en, PARAGRAPH: _u, LINK: vu, END: xu } = So, {
  ACTION_SET_PROPERTY: Ft,
  ACTION_INSERT: Si,
  ACTION_WRAP: Ao,
  ACTION_UNWRAP: yu,
  ACTION_TYPE: mu,
  ACTION_PATCH: bu
} = To, { PROPS_TOGGLE: Gn, PROPS_BLOCK: wu, PROPS_REPLACE: ku, PROPS_UPDATE: Io, PROPS_CHUNK: Cu } = Eo;
function Su(n, e) {
  n.getCursor()[1] ? n.exec(Ft, { mode: Gn, props: e }) : n.exec(Si, { mode: Gn, props: e, tag: en });
}
function kn(n, e) {
  n.exec(Ft, { mode: Io, props: e });
}
function Eu(n, e, t) {
  n.exec(Ft, {
    mode: Io,
    target: Cu,
    cursor: t,
    props: e
  });
}
function pt(n, e) {
  n.exec(Ft, { target: wu, props: e });
}
function Cn(n, e) {
  const [, t] = n.getCursor();
  n.exec(t ? Ao : Si, e);
}
function Tu(n, e) {
  n.exec(Ao, e);
}
function yt(n, e) {
  n.exec(yu, e);
}
function sr(n, e) {
  n.exec(bu, e);
}
function Kt(n, e) {
  n.getCursor()[0] || n.resetCursor(), n.exec(Si, e);
}
function Au(n, e) {
  n.exec(mu, e);
}
function jn(n, e) {
  const [t, i] = e;
  n.paint({ id: t.start || t.id, pos: t.pos }, i);
}
function Do(n, e, t) {
  e = e || en;
  const [i] = n.getCursor(), r = n.getTape();
  let o = r.nextIndex(i.id), s = r.getChunkAt(o);
  for (; s && s.type !== e; )
    t && t(s), o = r.nextIndex(s.id), s = r.getChunkAt(o);
  return s;
}
function Iu(n) {
  const [e, t] = n.getCursor(), i = n.getTape(), r = i.getChunk(e.id);
  Do(n, en, (o) => {
    const s = i.getParent(
      { id: o.id, pos: 0 },
      (a) => a.type === vu
    );
    (o.type === _u || o.type === xu || s) && (t && t.pos === (r.text && r.text.length) || !t) && (n.setCursor(t || e), Kt(n, { tag: en, mode: Gn }), n.setCursor(e, t));
  });
}
function Du(n, e) {
  const t = Do(n, e);
  t && n.setCursor({ id: t.id, pos: 0 });
}
function Lu(n) {
  n.exec(Ft, { mode: ku, props: {} });
}
const { ACTION_UNDO: Nu, ACTION_REDO: Fu } = To, { IMAGE: ar, LINK: lr, UL: Pu, OL: Ou, RULER: Mu, SUBSCRIPT: Sn, SUPERSCRIPT: En } = So, { FOCUS_CHUNK_END: Ru } = Eo, Bu = {
  bulleted: Pu,
  numbered: Ou
}, Hu = 20;
class zu extends Fc {
  in;
  _router;
  constructor(e) {
    super({ writable: e, async: !1 }), this._router = new Pc(
      super.setState.bind(this),
      // data recalculation dependencies
      [],
      // data initializers
      {}
    );
    const t = this.in = new Oc();
    t.on(
      "create-new",
      ({ reset: i }) => {
        const { _history: r } = this.getState();
        this.setValue(""), i && r.reset();
      }
    ), t.on("undo", () => {
      const { document: i } = this.getState();
      i.exec(Nu);
    }), t.on("redo", () => {
      const { document: i } = this.getState();
      i.exec(Fu);
    }), t.on("cut", () => {
      this.setState({ _clipboard: "cut" }), this.setStateAsync({ _clipboard: null });
    }), t.on("copy", () => {
      this.setState({ _clipboard: "copy" }), this.setStateAsync({ _clipboard: null });
    }), t.on("paste", () => {
      this.setState({ _clipboard: "paste" }), this.setStateAsync({ _clipboard: null });
    }), t.on(
      "set-text-format",
      (i) => {
        const { document: r } = this.getState();
        Su(r, i);
      }
    ), t.on(
      "set-text-style",
      ({ tag: i }) => {
        const { document: r, cursorState: o } = this.getState();
        o.tag === "blockquote" && (i = "p"), pt(r, { tag: i });
      }
    ), t.on(
      "set-font-family",
      ({ fontFamily: i }) => {
        const { document: r } = this.getState();
        kn(r, { fontFamily: i });
      }
    ), t.on(
      "set-font-size",
      ({ fontSize: i }) => {
        const { document: r } = this.getState();
        kn(r, { fontSize: i });
      }
    ), t.on(
      "set-text-color",
      (i) => {
        const { document: r } = this.getState();
        kn(r, i);
      }
    ), t.on("align", ({ align: i }) => {
      const { document: r } = this.getState();
      pt(r, { align: i });
    }), t.on(
      "set-line-height",
      ({ lineHeight: i }) => {
        const { document: r } = this.getState();
        pt(r, { lineHeight: i });
      }
    ), t.on("indent", ({ step: i }) => {
      const { document: r, cursorState: o } = this.getState(), s = o.indent || 0, a = Math.max(0, s + (i || Hu));
      pt(r, { indent: a });
    }), t.on("outdent", ({ step: i }) => {
      const { document: r, cursorState: o } = this.getState(), s = o.indent || 0, a = Math.max(0, s + (-i || -20));
      pt(r, { indent: a });
    }), t.on("subscript", () => {
      const { document: i } = this.getState(), [r] = i.getCursor();
      if (i.getTape().getParent(r, (s) => s.type === Sn)) {
        yt(i, { tag: Sn });
        return;
      }
      Cn(i, {
        tag: Sn
      });
    }), t.on("superscript", () => {
      const { document: i } = this.getState(), [r] = i.getCursor();
      if (i.getTape().getParent(r, (s) => s.type === En)) {
        yt(i, { tag: En });
        return;
      }
      Cn(i, {
        tag: En
      });
    }), t.on(
      "insert-list",
      ({ type: i }) => {
        const { document: r } = this.getState();
        Kt(r, { tag: Bu[i] });
      }
    ), t.on(
      "insert-link",
      ({ url: i }) => {
        const { document: r } = this.getState();
        Cn(r, {
          tag: lr,
          props: { url: i || "" },
          mode: Ru
        });
      }
    ), t.on(
      "update-link",
      ({ id: i, url: r }) => {
        const { document: o } = this.getState();
        sr(o, { id: i, props: { url: r } });
      }
    ), t.on("delete-link", () => {
      const { document: i } = this.getState();
      yt(i, { tag: lr });
    }), t.on("insert-image", (i) => {
      const { document: r } = this.getState(), [o, s] = r.getCursor(), a = r.getTape().getChunk(o.id).type === ar, u = {
        uid: i.id,
        url: i.value,
        width: i.width,
        height: i.height
      };
      o.id === s?.id && a ? sr(r, {
        id: o.id,
        props: u
      }) : Kt(r, {
        tag: ar,
        props: u
      });
    }), t.on(
      "resize-image",
      ({ id: i, width: r, height: o }) => {
        const { document: s } = this.getState();
        Eu(s, { width: r, height: o }, { id: i, pos: 0 });
      }
    ), t.on("insert-line", () => {
      const { document: i } = this.getState();
      Kt(i, { tag: Mu });
    }), t.on("clear-text-format", () => {
      const { document: i } = this.getState();
      Lu(i);
    }), t.on(
      "toggle-fullscreen-mode",
      ({ mode: i }) => {
        const { fullscreenMode: r } = this.getState();
        this.setState({
          fullscreenMode: typeof i == "boolean" ? i : !r
        });
      }
    ), t.on(
      "toggle-layout-mode",
      ({ mode: i }) => {
        if (!i) {
          const { layoutMode: r } = this.getState();
          i = r === "classic" ? "document" : "classic";
        }
        this.setState({ layoutMode: i });
      }
    ), t.on("print", () => {
      this.setState({ _print: !0 }), this.setStateAsync({ _print: !1 });
    }), t.on("import", (i) => {
      i.html && this.setValue(i.html);
    }), t.on("export", (i) => new Promise((r, o) => {
      const s = i.options || {}, a = s.format || "docx";
      if (a !== "docx" && a !== "pdf") {
        o(new Error(`Unsupported export format: ${a}`));
        return;
      }
      const l = `${s.url || "https://export.dhtmlx.com/richtext"}/export/${a}`, c = `${s.fileName || "data"}.${a}`;
      fetch(l, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          html: this.getValue()
        })
      }).then((d) => d.blob()).then((d) => {
        s.download !== !1 ? Rc(d, c) : i.result = d, r(!0);
      }).catch((d) => {
        console.error("Export failed:", d), o(d);
      });
    })), t.on("show-popup", (i) => {
      const { type: r } = i;
      if (r === null) {
        this.setState({ popup: null });
        return;
      }
      const { document: o, selection: s } = this.getState(), [a] = o.getCursor(), u = s.getBox(a.id);
      this.setState({ popup: { pos: u, ...i } });
    }), t.on(
      "toggle-shortcut-info",
      ({ mode: i }) => {
        const { _shortcuts: r } = this.getState();
        this.setState({
          _shortcuts: typeof i == "boolean" ? i : !r
        });
      }
    );
  }
  _mergeStyles(e = {}) {
    const t = Mc(), i = {};
    for (const r in t)
      i[r] = {
        ...t[r],
        ...e["*"],
        ...e[r]
      };
    return i;
  }
  init(e) {
    e.defaultStyles = this._mergeStyles(e.defaultStyles), this._router.init({
      document: null,
      selection: null,
      history: null,
      popup: null,
      cursorState: {},
      _clipboard: null,
      _history: null,
      _print: !1,
      _shortcuts: !1,
      ...e
    });
  }
  setState(e, t) {
    return this._router.setState(e, t);
  }
  setStateAsync(e) {
    this._router.setStateAsync(e);
  }
  getValue(e) {
    const { document: t } = this.getState();
    return t.getValue(e);
  }
  setValue(e, t) {
    const { document: i } = this.getState();
    i.setValue(e, t);
  }
  preInit(e, t) {
    this.setState({ document: e, _history: t });
  }
  postInit(e) {
    this.setState({ selection: e });
  }
  updateHistory(e) {
    this.setState({ history: e });
  }
  skipAction(e) {
    const { _history: t } = this.getState();
    t.skip(e);
  }
  // needs types
  setCursor(e, t, i) {
    const { document: r } = this.getState();
    r.setCursor(e, t);
    const o = r.getTape().getProps(e, t, i);
    this.setState({ cursorState: o });
  }
}
const Tn = {
  undo: {
    id: "undo",
    type: "button",
    tooltip: "Undo",
    hotkey: "Ctrl+Z",
    icon: "wxo-undo"
  },
  redo: {
    id: "redo",
    type: "button",
    tooltip: "Redo",
    hotkey: "Ctrl+Y",
    icon: "wxo-redo"
  },
  style: {
    id: "style",
    type: "richselect",
    tooltip: "Style",
    options: [
      { id: "p", label: "Paragraph" },
      { id: "h1", label: "Heading 1" },
      { id: "h2", label: "Heading 2" },
      { id: "h3", label: "Heading 3" },
      { id: "h4", label: "Heading 4" },
      { id: "h5", label: "Heading 5" },
      { id: "h6", label: "Heading 6" }
    ]
  },
  "font-family": {
    id: "font-family",
    type: "richselect",
    tooltip: "Font family",
    options: [
      { id: "Roboto", label: "Roboto" },
      { id: "Arial", label: "Arial" },
      { id: "Georgia", label: "Georgia" },
      { id: "Tahoma", label: "Tahoma" },
      { id: "Times New Roman", label: "Times New Roman" },
      { id: "Verdana", label: "Verdana" }
    ]
  },
  "font-size": {
    id: "font-size",
    type: "richselect",
    tooltip: "Font size",
    options: [
      { id: "12px", label: "12" },
      { id: "14px", label: "14" },
      { id: "16px", label: "16" },
      { id: "18px", label: "18" },
      { id: "20px", label: "20" },
      { id: "24px", label: "24" },
      { id: "28px", label: "28" },
      { id: "32px", label: "32" },
      { id: "36px", label: "36" }
    ]
  },
  bold: {
    id: "bold",
    type: "button",
    tooltip: "Bold",
    hotkey: "Ctrl+B",
    icon: "wxo-bold"
  },
  italic: {
    id: "italic",
    type: "button",
    tooltip: "Italic",
    hotkey: "Ctrl+I",
    icon: "wxo-italic"
  },
  underline: {
    id: "underline",
    type: "button",
    tooltip: "Underline",
    hotkey: "Ctrl+U",
    icon: "wxo-underline"
  },
  strike: {
    id: "strike",
    type: "button",
    tooltip: "Strikethrough",
    hotkey: "Ctrl+Shift+X",
    icon: "wxo-strike"
  },
  subscript: {
    id: "subscript",
    type: "button",
    tooltip: "Subscript",
    icon: "wxo-subscript"
  },
  superscript: {
    id: "superscript",
    type: "button",
    tooltip: "Superscript",
    icon: "wxo-superscript"
  },
  "text-color": {
    id: "text-color",
    type: "colorpicker",
    tooltip: "Text color",
    icon: "wxo-text-color"
  },
  "background-color": {
    id: "background-color",
    type: "colorpicker",
    tooltip: "Background color",
    icon: "wxo-background-color"
  },
  align: {
    id: "align",
    type: "richselect",
    tooltip: "Align",
    icon: "wxo-align-left",
    options: [
      { id: "left", label: "Left", icon: "wxo-align-left" },
      { id: "center", label: "Center", icon: "wxo-align-center" },
      { id: "right", label: "Right", icon: "wxo-align-right" },
      { id: "justify", label: "Justify", icon: "wxo-align-justify" }
    ]
  },
  indent: {
    id: "indent",
    type: "button",
    tooltip: "Indent",
    icon: "wxo-indent"
  },
  outdent: {
    id: "outdent",
    type: "button",
    tooltip: "Outdent",
    icon: "wxo-unindent"
  },
  "line-height": {
    id: "line-height",
    type: "richselect",
    tooltip: "Line height",
    icon: "wxo-line-height",
    options: [
      { id: "1", label: "1.0" },
      { id: "1.25", label: "1.25" },
      { id: "1.5", label: "1.5" },
      { id: "2", label: "2.0" },
      { id: "3", label: "3.0" }
    ]
  },
  quote: {
    id: "quote",
    type: "button",
    tooltip: "Quote",
    icon: "wxo-quote"
  },
  "bulleted-list": {
    id: "bulleted-list",
    type: "button",
    tooltip: "Bulleted list",
    icon: "wxo-list-bulleted"
  },
  "numbered-list": {
    id: "numbered-list",
    type: "button",
    tooltip: "Numbered list",
    icon: "wxo-list-numbered"
  },
  link: {
    id: "link",
    type: "button",
    tooltip: "Insert link",
    hotkey: "Ctrl+K",
    icon: "wxo-link"
  },
  image: {
    id: "image",
    type: "button",
    tooltip: "Insert image",
    icon: "wxo-image"
  },
  line: {
    id: "line",
    type: "button",
    tooltip: "Insert horizontal line",
    icon: "wxo-hr"
  },
  clear: {
    id: "clear",
    type: "button",
    tooltip: "Clear formatting",
    icon: "wxo-format-clear"
  },
  print: {
    id: "print",
    type: "button",
    tooltip: "Print",
    hotkey: "Ctrl+P",
    icon: "wxo-print"
  },
  fullscreen: {
    id: "fullscreen",
    type: "button",
    tooltip: "Fullscreen mode",
    icon: "wxo-fullscreen"
  },
  mode: {
    id: "mode",
    type: "richselect",
    tooltip: "Layout mode",
    icon: "wxo-fit-width",
    options: [
      { id: "classic", label: "Classic mode", icon: "wxo-fit-width" },
      {
        id: "document",
        label: "Document mode",
        icon: "wxo-fit-document"
      }
    ]
  },
  shortcuts: {
    id: "shortcuts",
    type: "button",
    tooltip: "Keyboard shortcuts",
    // TODO: replace with appropriate icon (e.g., wxo-keyboard)
    icon: "wxo-help"
  }
}, Uu = [
  "undo",
  "redo",
  "separator",
  "style",
  "separator",
  "font-family",
  "font-size",
  "separator",
  "bold",
  "italic",
  "underline",
  "strike",
  "separator",
  "text-color",
  "background-color",
  "separator",
  "align",
  "line-height",
  "outdent",
  "indent",
  "separator",
  "bulleted-list",
  "numbered-list",
  "quote",
  "separator",
  "link",
  "image",
  "separator",
  "clear",
  "separator",
  "fullscreen",
  "mode"
];
function Vn(n, e, t) {
  return n === "style" ? "p" : n === "line-height" ? "1" : n === "font-family" ? t[e.tag]?.["font-family"] || t.p["font-family"] : n === "font-size" ? t[e.tag]?.["font-size"] || t.p["font-size"] : n === "text-color" ? t[e.tag]?.color || "var(--wx-color-font)" : n === "background-color" ? t[e.tag]?.background || "var(--wx-background)" : null;
}
const qu = [
  // row 1 (grayscale, aligned to theme colors)
  { id: "#000000", label: "Black" },
  { id: "#212121", label: "Dark gray 3" },
  { id: "#363636", label: "Dark gray 2" },
  { id: "#4D4D4D", label: "Dark gray 1" },
  { id: "#666666", label: "Gray" },
  { id: "#7F7F7F", label: "Medium gray" },
  { id: "#999999", label: "Light gray 3" },
  { id: "#B3B3B3", label: "Light gray 2" },
  { id: "#D9D9D9", label: "Light gray 1" },
  { id: "#FFFFFF", label: "White" },
  // row 2
  { id: "#FFE6E6", label: "Light red 3" },
  { id: "#FFF0E6", label: "Light orange 3" },
  { id: "#FFFBE6", label: "Light yellow 3" },
  { id: "#F1FFE6", label: "Light lime 3" },
  { id: "#E6FFE6", label: "Light green 3" },
  { id: "#E6FFF9", label: "Light teal 3" },
  { id: "#E6FFFF", label: "Light cyan 3" },
  { id: "#E6F2FF", label: "Light blue 3" },
  { id: "#EBE6FF", label: "Light indigo 3" },
  { id: "#FCE6FF", label: "Light magenta 3" },
  // row 3
  { id: "#FFCCCC", label: "Light red 2" },
  { id: "#FFE0CC", label: "Light orange 2" },
  { id: "#FFF7CC", label: "Light yellow 2" },
  { id: "#E3FFCC", label: "Light lime 2" },
  { id: "#CCFFCC", label: "Light green 2" },
  { id: "#CCFFF4", label: "Light teal 2" },
  { id: "#CCFFFF", label: "Light cyan 2" },
  { id: "#CCE6FF", label: "Light blue 2" },
  { id: "#D6CCFF", label: "Light indigo 2" },
  { id: "#F9CCFF", label: "Light magenta 2" },
  // row 4
  { id: "#FF9999", label: "Light red 1" },
  { id: "#FFC299", label: "Light orange 1" },
  { id: "#FFF099", label: "Light yellow 1" },
  { id: "#C7FF99", label: "Light lime 1" },
  { id: "#99FF99", label: "Light green 1" },
  { id: "#99FFE9", label: "Light teal 1" },
  { id: "#99FFFF", label: "Light cyan 1" },
  { id: "#99CCFF", label: "Light blue 1" },
  { id: "#AD99FF", label: "Light indigo 1" },
  { id: "#F399FF", label: "Light magenta 1" },
  // row 5
  { id: "#FF6666", label: "Medium red 2" },
  { id: "#FFA366", label: "Medium orange 2" },
  { id: "#FFE866", label: "Medium yellow 2" },
  { id: "#ABFF66", label: "Medium lime 2" },
  { id: "#66FF66", label: "Medium green 2" },
  { id: "#66FFDD", label: "Medium teal 2" },
  { id: "#66FFFF", label: "Medium cyan 2" },
  { id: "#66B3FF", label: "Medium blue 2" },
  { id: "#8566FF", label: "Medium indigo 2" },
  { id: "#ED66FF", label: "Medium magenta 2" },
  // row 6
  { id: "#FF3333", label: "Medium red 1" },
  { id: "#FF8533", label: "Medium orange 1" },
  { id: "#FFE133", label: "Medium yellow 1" },
  { id: "#8FFF33", label: "Medium lime 1" },
  { id: "#33FF33", label: "Medium green 1" },
  { id: "#33FFD2", label: "Medium teal 1" },
  { id: "#33FFFF", label: "Medium cyan 1" },
  { id: "#3399FF", label: "Medium blue 1" },
  { id: "#5C33FF", label: "Medium indigo 1" },
  { id: "#E733FF", label: "Medium magenta 1" },
  // row 7
  { id: "#FF0000", label: "Red" },
  { id: "#FF6600", label: "Orange" },
  { id: "#FFDA00", label: "Yellow" },
  { id: "#73FF00", label: "Lime" },
  { id: "#00FF00", label: "Green" },
  { id: "#00FFC7", label: "Teal" },
  { id: "#00FFFF", label: "Cyan" },
  { id: "#0080FF", label: "Blue" },
  { id: "#3300FF", label: "Indigo" },
  { id: "#E200FF", label: "Magenta" },
  // row 8
  { id: "#CC0000", label: "Dark red" },
  { id: "#CC5200", label: "Dark orange" },
  { id: "#CCA000", label: "Dark yellow" },
  { id: "#59CC00", label: "Dark lime" },
  { id: "#00CC00", label: "Dark green" },
  { id: "#00CC9F", label: "Dark teal" },
  { id: "#00CCCC", label: "Dark cyan" },
  { id: "#0066CC", label: "Dark blue" },
  { id: "#2900CC", label: "Dark indigo" },
  { id: "#B400CC", label: "Dark magenta" }
], Ku = 20, Gu = [
  {
    id: "file",
    text: "File",
    data: [
      {
        id: "new",
        text: "New",
        icon: "wxo-document",
        action: "create-new"
      },
      {
        id: "import",
        text: "Import",
        icon: "wxo-import"
      },
      {
        id: "export",
        text: "Export",
        icon: "wxo-export",
        data: [
          {
            id: "docx",
            text: "DOCX"
          },
          {
            id: "pdf",
            text: "PDF"
          }
        ],
        action: "export"
      },
      {
        id: "print",
        text: "Print",
        icon: "wxo-print",
        subtext: "Ctrl+P"
      }
    ]
  },
  {
    id: "edit",
    text: "Edit",
    data: [
      {
        id: "undo",
        text: "Undo",
        icon: "wxo-undo",
        subtext: "Ctrl+Z"
      },
      {
        id: "redo",
        text: "Redo",
        icon: "wxo-redo",
        subtext: "Ctrl+Y"
      },
      {
        type: "separator"
      },
      {
        id: "cut",
        text: "Cut",
        icon: "wxo-content-cut",
        subtext: "Ctrl+X"
      },
      {
        id: "copy",
        text: "Copy",
        icon: "wxo-content-copy",
        subtext: "Ctrl+C"
      },
      {
        id: "paste",
        text: "Paste",
        icon: "wxo-content-paste",
        subtext: "Ctrl+V"
      }
    ]
  },
  {
    id: "view",
    text: "View",
    data: [
      {
        id: "classic",
        text: "Classic mode",
        icon: "wxo-fit-width",
        action: "toggle-layout-mode"
      },
      {
        id: "document",
        text: "Document mode",
        icon: "wxo-fit-document",
        action: "toggle-layout-mode"
      },
      {
        type: "separator"
      },
      {
        id: "fullscreen",
        text: "Fullscreen mode",
        icon: "wxo-fullscreen",
        action: "toggle-fullscreen-mode"
      }
    ]
  },
  {
    id: "insert",
    text: "Insert",
    data: [
      {
        id: "link",
        text: "Link",
        icon: "wxo-link",
        action: "show-popup",
        subtext: "Ctrl+K"
      },
      {
        id: "image",
        text: "Image",
        icon: "wxo-image",
        action: "insert-image"
      },
      {
        id: "line",
        text: "Horizontal line",
        icon: "wxo-hr",
        action: "insert-line"
      }
    ]
  },
  {
    id: "format",
    text: "Format",
    data: [
      {
        id: "text",
        text: "Text",
        icon: "wxo-bold",
        data: [
          {
            id: "bold",
            text: "Bold",
            icon: "wxo-bold",
            action: "set-text-format",
            subtext: "Ctrl+B"
          },
          {
            id: "italic",
            text: "Italic",
            icon: "wxo-italic",
            action: "set-text-format",
            subtext: "Ctrl+I"
          },
          {
            id: "underline",
            text: "Underline",
            icon: "wxo-underline",
            action: "set-text-format",
            subtext: "Ctrl+U"
          },
          {
            id: "strike",
            text: "Strikethrough",
            icon: "wxo-strike",
            action: "set-text-format",
            subtext: "Ctrl+Shift+X"
          },
          {
            id: "subscript",
            text: "Subscript",
            icon: "wxo-subscript"
          },
          {
            id: "superscript",
            text: "Superscript",
            icon: "wxo-superscript"
          },
          {
            type: "separator"
          },
          {
            id: "text-style",
            text: "Style",
            icon: "wxo-paragraph",
            data: [
              { id: "p", text: "Paragraph" },
              { id: "h1", text: "Heading 1" },
              { id: "h2", text: "Heading 2" },
              { id: "h3", text: "Heading 3" },
              { id: "h4", text: "Heading 4" },
              { id: "h5", text: "Heading 5" },
              { id: "h6", text: "Heading 6" }
            ],
            action: "set-text-style"
          },
          {
            type: "separator"
          },
          {
            id: "font-family",
            text: "Font family",
            icon: "wxo-empty",
            data: [
              { id: "Roboto", text: "Roboto" },
              { id: "Arial", text: "Arial" },
              { id: "Georgia", text: "Georgia" },
              { id: "Tahoma", text: "Tahoma" },
              { id: "Times New Roman", text: "Times New Roman" },
              { id: "Verdana", text: "Verdana" }
            ],
            action: "set-font-family"
          },
          {
            id: "font-size",
            text: "Font size",
            icon: "wxo-empty",
            data: [
              { id: "12px", text: "12" },
              { id: "14px", text: "14" },
              { id: "16px", text: "16" },
              { id: "18px", text: "18" },
              { id: "20px", text: "20" },
              { id: "24px", text: "24" },
              { id: "28px", text: "28" },
              { id: "32px", text: "32" },
              { id: "36px", text: "36" }
            ],
            action: "set-font-size"
          }
        ]
      },
      {
        id: "align",
        text: "Align",
        icon: "wxo-align-center",
        data: [
          {
            id: "left",
            text: "Left",
            icon: "wxo-align-left"
          },
          {
            id: "center",
            text: "Center",
            icon: "wxo-align-center"
          },
          {
            id: "right",
            text: "Right",
            icon: "wxo-align-right"
          },
          {
            id: "justify",
            text: "Justified",
            icon: "wxo-align-justify"
          }
        ],
        action: "align"
      },
      {
        id: "line-height",
        text: "Line height",
        icon: "wxo-line-height",
        data: [
          { id: "1", text: "1.0" },
          { id: "1.25", text: "1.25" },
          { id: "1.5", text: "1.5" },
          { id: "2", text: "2.0" },
          { id: "3", text: "3.0" }
        ],
        action: "set-line-height"
      },
      {
        id: "indent",
        icon: "wxo-indent",
        text: "Indent"
      },
      {
        id: "outdent",
        icon: "wxo-unindent",
        text: "Outdent"
      },
      {
        type: "separator"
      },
      {
        id: "lists",
        text: "Lists",
        icon: "wxo-list-bulleted",
        data: [
          {
            id: "bulleted",
            text: "Bulleted list",
            icon: "wxo-list-bulleted"
          },
          {
            id: "numbered",
            text: "Numbered list",
            icon: "wxo-list-numbered"
          }
        ],
        action: "insert-list"
      },
      {
        id: "blockquote",
        text: "Quote",
        icon: "wxo-quote",
        action: "set-text-style"
      },
      {
        type: "separator"
      },
      {
        id: "clear",
        text: "Clear formatting",
        icon: "wxo-format-clear",
        action: "clear-text-format"
      }
    ]
  },
  {
    id: "help",
    text: "Help",
    data: [
      {
        id: "shortcuts",
        text: "Keyboard shortcuts",
        // TODO: replace with appropriate icon (e.g., wxo-keyboard)
        icon: "wxo-help",
        action: "toggle-shortcut-info"
      }
    ]
  }
], cr = {
  align: "align",
  "set-text-style": "tag",
  "set-font-family": "fontFamily",
  "set-font-size": "fontSize",
  "set-line-height": "lineHeight",
  "insert-list": "type",
  "show-popup": "type",
  "toggle-layout-mode": "mode",
  "toggle-shortcut-info": "mode"
};
function Lo(n, e) {
  if (!n || !n.length || !e) return null;
  for (const t of n)
    if (t.data && Array.isArray(t.data)) {
      if (t.data.some(
        (o) => o.id === e.id
      )) return t;
      const r = Lo(t.data, e);
      if (r) return r;
    }
  return null;
}
function ju(n, e) {
  const t = e.action, i = e.context || [], r = t.id;
  let o = t.action;
  if (t.action || (o = Lo(i.data, t)?.action || r), o === "insert-image") {
    $t(n, "image").handler();
    return;
  }
  if (o === "import") {
    $t(n, "docx").handler();
    return;
  }
  const s = {};
  o === "set-text-format" ? s[r] = !0 : o === "indent" || o === "outdent" ? s.step = Ku : o === "export" ? s.options = { format: r } : cr[o] && (s[cr[o]] = o === "toggle-shortcut-info" ? !0 : r), n.exec(o, s);
}
function No(n, e) {
  return e.map(
    (t) => t.data && t.data.length > 0 ? {
      ...t,
      data: No(n, t.data || [])
    } : {
      ...t,
      handler: t.handler || (({ action: i, context: r }) => ju(n, { action: i, context: r }))
    }
  );
}
function Vu(n) {
  return No(n, Gu);
}
const { CTRL: gt, SHIFT: Yu, K: Wu, P: Ju, Y: Xu, Z: ur } = Ha, { ACTION_UNDO: Zu, ACTION_REDO: dr } = ul;
function Qu(n, e) {
  const t = new za(e);
  return t.add(gt + ur, (i) => i.exec(Zu)), t.add(gt + Yu + ur, (i) => i.exec(dr)), t.add(gt + Xu, (i) => i.exec(dr)), t.add(gt + Wu, (i, r) => {
    r.preventDefault(), n.exec("show-popup", { type: "link" });
  }), t.add(gt + Ju, () => n.exec("print")), t;
}
function $u(n, e, t) {
  const i = new ClipboardEvent("copy", {
    clipboardData: new DataTransfer()
  });
  _i(n, e ? "cut" : "copy", i), navigator.clipboard.write([
    new window.ClipboardItem({
      "text/plain": i.clipboardData.getData("text/plain"),
      "text/html": i.clipboardData.getData("text/html")
    })
  ]).catch((r) => t(r));
}
function ed(n, e) {
  navigator.clipboard.readText().then((t) => {
    const i = new ClipboardEvent("copy", {
      clipboardData: new DataTransfer()
    });
    i.clipboardData.setData("text/plain", t), _i(n, "paste", i);
  }).catch((t) => e(t));
}
function td(n, e) {
  const t = new ResizeObserver((i) => {
    requestAnimationFrame(() => e(i[0].contentRect));
  });
  return t.observe(n), {
    destroy() {
      t.disconnect();
    }
  };
}
function Fo(n, e) {
  return n.map((t) => {
    const i = e(t);
    return t.data && t.data.length && (i.data = Fo(t.data, e)), i;
  });
}
function Po(n, e) {
  const t = [];
  return n.forEach((i) => {
    if (i.data) {
      const r = Po(i.data, e);
      r.length && t.push({ ...i, data: r });
    } else
      e(i) && t.push(i);
  }), t;
}
let nd = 1;
function Oo(n) {
  return Fo(n, (e) => ({ ...e, id: e.id || nd++ }));
}
const id = {};
function rd(n) {
  return id[n];
}
var od = /* @__PURE__ */ L("<i></i>"), sd = /* @__PURE__ */ L('<span class="wx-value svelte-xfznf6"> </span>'), ad = /* @__PURE__ */ L('<span class="wx-subtext svelte-xfznf6"> </span>'), ld = /* @__PURE__ */ L('<i class="wx-sub-icon wxi-angle-right svelte-xfznf6"></i>'), cd = /* @__PURE__ */ L("<div><!> <!> <!> <!></div>");
function ud(n, e) {
  X(e, !0);
  let t = I(e, "showSub", 15, !1), i = I(e, "activeItem", 15, null);
  function r() {
    t(e.item.data ? e.item.id : !1), i(this);
  }
  var o = cd();
  o.__click = function(...c) {
    e.onclick?.apply(this, c);
  };
  var s = P(o);
  B(s, () => e.item.icon, (c) => {
    var d = od();
    q(() => he(d, `wx-icon ${e.item.icon ?? ""} svelte-xfznf6`)), m(c, d);
  });
  var a = K(s, 2);
  B(
    a,
    () => e.item.type,
    (c) => {
      var d = Q();
      const f = /* @__PURE__ */ j(() => rd(e.item.type));
      var h = U(d);
      Gs(h, () => p(f), (g, _) => {
        _(g, {
          get item() {
            return e.item;
          }
        });
      }), m(c, d);
    },
    (c) => {
      var d = sd(), f = P(d);
      q(() => le(f, e.item.text)), m(c, d);
    }
  );
  var u = K(a, 2);
  B(u, () => e.item.subtext, (c) => {
    var d = ad(), f = P(d);
    q(() => le(f, e.item.subtext)), m(c, d);
  });
  var l = K(u, 2);
  B(l, () => e.item.data, (c) => {
    var d = ld();
    m(c, d);
  }), q(() => {
    he(o, `wx-item ${(e.item.css || "") ?? ""} svelte-xfznf6`), te(o, "data-id", e.item.id);
  }), Ge("mouseenter", o, r), m(n, o), Z();
}
V(["click"]);
var dd = /* @__PURE__ */ L('<div class="wx-separator svelte-1tqohog"></div>'), fd = /* @__PURE__ */ L("<!> <!>", 1), hd = /* @__PURE__ */ L('<div data-wx-menu="true"></div>');
function Mo(n, e) {
  X(e, !0);
  let t = I(e, "left", 3, 0), i = I(e, "top", 3, 0), r = I(e, "at", 3, "bottom"), o = I(e, "parent", 3, null), s = I(e, "mount", 3, null), a = I(e, "context", 3, null), u = I(e, "css", 3, ""), l = z(-1e4), c = z(-1e4), d = z(20), f = z(void 0), h = z(void 0), g = z(!1), _ = z(null);
  function v() {
    const w = xo(p(h), o(), r(), t(), i());
    w && (T(l, M(w.x)), T(c, M(w.y)), T(d, M(w.z)), T(f, M(w.width)));
  }
  s() && s()(v), be(v);
  function k() {
    T(g, !1);
  }
  function x() {
    e.onclick && e.onclick({ action: null });
  }
  const A = /* @__PURE__ */ j(() => Oo(e.options));
  Ie(() => {
    v(o());
  });
  var E = hd();
  Me(E, 21, () => p(A), (w) => w.id, (w, S) => {
    var O = fd(), D = U(O);
    B(
      D,
      () => p(S).type === "separator",
      (H) => {
        var b = dd();
        m(H, b);
      },
      (H) => {
        ud(H, {
          get item() {
            return p(S);
          },
          get showSub() {
            return p(g);
          },
          set showSub(b) {
            T(g, M(b));
          },
          get activeItem() {
            return p(_);
          },
          set activeItem(b) {
            T(_, M(b));
          },
          onclick: (b) => {
            if (!p(S).data && !b.defaultPrevented) {
              const y = {
                context: a(),
                action: p(S),
                event: b
              };
              p(S).handler && p(S).handler(y), e.onclick && e.onclick(y), b.stopPropagation();
            }
          }
        });
      }
    );
    var N = K(D, 2);
    B(N, () => p(S).data && p(g) === p(S).id, (H) => {
      Mo(H, {
        get css() {
          return u();
        },
        get options() {
          return p(S).data;
        },
        at: "right-overlap",
        get parent() {
          return p(_);
        },
        get context() {
          return a();
        },
        get onclick() {
          return e.onclick;
        }
      });
    }), m(w, O);
  }), Re(E, (w, S) => Nt(w, S), () => ({ callback: x, modal: !0 })), oe(E, (w) => T(h, w), () => p(h)), q(() => {
    he(E, `wx-menu ${u() ?? ""} svelte-1tqohog`), te(E, "style", `position:absolute;top:${p(c) ?? ""}px;left:${p(l) ?? ""}px;width:${p(f) ?? ""};z-index:${p(d) ?? ""}`);
  }), Ge("mouseleave", E, k), m(n, E), Z();
}
var pd = /* @__PURE__ */ L('<span data-menu-ignore="true"><!></span>'), gd = /* @__PURE__ */ L("<!> <!>", 1);
function _d(n, e) {
  X(e, !0);
  let t = I(e, "at", 3, "bottom"), i = I(e, "resolver", 3, null), r = I(e, "dataKey", 3, "contextId"), o = I(e, "filter", 3, null), s = I(e, "css", 3, "");
  var a = /* @__PURE__ */ j(() => Ne(u) !== null && o() ? Po(e.options, (x) => o()(x, Ne(u))) : e.options), u = z(null), l = z(null);
  let c = z(0), d = z(0);
  function f(x) {
    T(l, null), e.onclick && e.onclick(x);
  }
  function h(x, A) {
    let E = null;
    for (; x && x.dataset && !E; )
      E = x.dataset[A], x = x.parentNode;
    return E ? _o(E) : null;
  }
  function g(x, A) {
    if (!x) {
      T(l, null);
      return;
    }
    if (x.defaultPrevented) return;
    const E = x.target;
    E && E.dataset && E.dataset.menuIgnore || (T(c, x.clientX + 1), T(d, x.clientY + 1), T(u, M(typeof A < "u" ? A : h(E, r()))), !(i() && (T(u, M(i()(Ne(u), x))), !Ne(u))) && (T(l, M(E)), x.preventDefault()));
  }
  var _ = gd(), v = U(_);
  B(v, () => e.children, (x) => {
    var A = pd();
    A.__click = g;
    var E = P(A);
    ue(E, () => e.children ?? se), m(x, A);
  });
  var k = K(v, 2);
  return B(k, () => Ne(l), (x) => {
    wi(x, { children: (E, w) => {
      let S = () => w?.().mount;
      var O = Q(), D = U(O);
      Gr(D, () => Ne(l), (N) => {
        Mo(N, {
          get css() {
            return s();
          },
          get at() {
            return t();
          },
          get top() {
            return p(d);
          },
          get left() {
            return p(c);
          },
          get mount() {
            return S();
          },
          get parent() {
            return Ne(l);
          },
          get context() {
            return Ne(u);
          },
          onclick: f,
          get options() {
            return Ne(a);
          }
        });
      }), m(E, O);
    }, $$slots: { default: !0 } });
  }), m(n, _), Z({ show: g });
}
V(["click"]);
var vd = (n, e, t) => e(n, p(t), !0), xd = /* @__PURE__ */ L("<button> </button>"), yd = /* @__PURE__ */ L("<div></div> <!>", 1);
function md(n, e) {
  X(e, !0);
  let t, i = I(e, "css", 3, ""), r = I(e, "menuCss", 3, "");
  const o = /* @__PURE__ */ j(() => Oo(e.options));
  let s = z(void 0), a = z(M([]));
  function u(g) {
    T(s, null), e.onclick && e.onclick(g);
  }
  function l(g, _, v) {
    _.data && _.data.length ? p(s) && v ? T(s, null) : (T(a, M(_.data)), T(s, M(_.id)), t.show(g, _)) : (t.show(null), v ? (e.onclick && e.onclick({ action: _ }), T(s, null)) : T(s, -1));
  }
  function c(g, _) {
    p(s) && l(g, _);
  }
  var d = yd(), f = U(d);
  Me(f, 21, () => p(o), (g) => g.id, (g, _) => {
    var v = xd();
    v.__click = [vd, l, _];
    var k = P(v);
    q(() => {
      he(v, `wx-item ${(p(s) === p(_).id ? "wx-active" : "") ?? ""} svelte-1siwlw5`), le(k, p(_).text);
    }), Ge("mouseenter", v, (x) => c(x, p(_))), m(g, v);
  });
  var h = K(f, 2);
  oe(
    _d(h, {
      get css() {
        return r();
      },
      onclick: u,
      get options() {
        return p(a);
      }
    }),
    (g) => t = g,
    () => t
  ), q(() => he(f, `wx-menubar ${i() ?? ""} svelte-1siwlw5`)), m(n, d), Z();
}
V(["click"]);
V(["click"]);
V(["contextmenu"]);
function bd(n) {
  const e = n.cloneNode(!0);
  e && (e.classList.add("wx-printed-area"), document.body.appendChild(e), window.print(), document.body.removeChild(e));
}
function Ro(n, e = []) {
  const t = [
    "wx-richtext-toolbar",
    "wx-richtext-menubar",
    "wx-link-form",
    "wx-link-light-form"
  ];
  e.length > 0 && t.push(...e);
  let i = n;
  for (; i; ) {
    if (i.classList) {
      for (const r of t)
        if (i.classList.contains(r))
          return !0;
    }
    i = i.parentElement;
  }
  return !1;
}
const Ei = typeof navigator < "u" && (navigator.platform && navigator.platform.indexOf("Mac") > -1 || navigator.userAgentData && navigator.userAgentData.platform === "macOS");
function Ti(n) {
  const e = [
    ["Ctrl+", "⌘"],
    ["Alt+", "⌥"],
    ["Shift+", "⇧"]
  ];
  let t = n;
  for (const [i, r] of e)
    t = t.replaceAll(i, r);
  return t;
}
var wd = /* @__PURE__ */ L('<div class="wx-richtext-menubar svelte-1cvd7a9"><!></div>');
function kd(n, e) {
  X(e, !0);
  const t = fe("wx-i18n").getGroup("richtext"), i = /* @__PURE__ */ j(() => r(Vu(e.api)));
  function r(a) {
    return a.map((u) => {
      const l = { ...u };
      return l.text && (l.text = t(l.text)), l.data && Array.isArray(l.data) && (l.data = r(l.data)), Ei && l.subtext && (l.subtext = Ti(l.subtext)), l;
    });
  }
  var o = wd(), s = P(o);
  md(s, {
    menuCss: "wx-richtext-menu",
    get options() {
      return p(i);
    }
  }), m(n, o), Z();
}
const Cd = 400, Sd = 200;
let Ze = null, Ai = null;
function fr({ getTooltip: n, setTooltip: e }, t, i, r = !1) {
  if (clearTimeout(Ai), r) {
    clearTimeout(Ze), e(null);
    return;
  }
  let o = n();
  if (o && o.target !== t) {
    clearTimeout(Ze), e({ target: t, label: i });
    return;
  }
  Ze = setTimeout(() => {
    e({ target: t, label: i });
  }, Cd);
}
function Bo(n) {
  clearTimeout(Ze), Ai = setTimeout(() => {
    n(null);
  }, Sd);
}
function Ed() {
  clearTimeout(Ze), clearTimeout(Ai);
}
function Td(n, e) {
  const { label: t, setTooltip: i, getTooltip: r } = e, o = (c) => c.querySelector(".wx-dropdown") !== null || c.nextElementSibling?.classList.contains("wx-portal");
  function s(c) {
    fr(
      { getTooltip: r, setTooltip: i },
      c,
      t,
      o(c)
    );
  }
  function a(c) {
    !r() && !o(c) && (clearTimeout(Ze), fr({ getTooltip: r, setTooltip: i }, c, t));
  }
  function u() {
    Bo(i);
  }
  function l() {
    clearTimeout(Ze), i(null);
  }
  return Array.from(n.children).forEach((c) => {
    const d = () => s(c), f = () => a(c);
    c.addEventListener("mouseenter", d), c.addEventListener("mousemove", f), c.addEventListener("mouseleave", u), c.addEventListener("click", l);
  }), {
    destroy() {
      Ed();
    }
  };
}
var Ad = /* @__PURE__ */ L('<div class="wx-toolbar-element svelte-u697x8"><!></div>');
function Ii(n, e) {
  X(e, !0);
  const t = fe("wx-i18n").getGroup("richtext"), i = /* @__PURE__ */ j(() => t(e.button.tooltip || e.button.label) || ""), r = /* @__PURE__ */ j(() => e.button.hotkey ? ` (${Ei ? Ti(e.button.hotkey) : e.button.hotkey})` : ""), o = /* @__PURE__ */ j(() => `${p(i)}${p(r)}`);
  var s = Ad(), a = P(s);
  ue(a, () => e.children ?? se), Re(s, (u, l) => Td(u, l), () => ({ label: p(o), ...e.tooltip })), m(n, s), Z();
}
function Id(n, e) {
  X(e, !0);
  const t = et(), i = () => ae(f, "$fullscreenMode", t), r = () => ae(c, "$cursorState", t), o = () => ae(h, "$document", t), s = () => ae(d, "$history", t), a = 20, { SUBSCRIPT: u, SUPERSCRIPT: l } = si, {
    cursorState: c,
    history: d,
    fullscreenMode: f,
    document: h
  } = e.api.getReactiveState(), g = /* @__PURE__ */ j(() => e.button.id === "fullscreen" ? `wxo-fullscreen${i() ? "-exit" : ""}` : e.button.icon || ""), _ = /* @__PURE__ */ j(() => e.button.css || ""), v = /* @__PURE__ */ j(() => {
    let A;
    if ((e.button.id === "bold" || e.button.id === "italic" || e.button.id === "underline" || e.button.id === "strike") && (A = r()[e.button.id]), e.button.id === "quote" && (A = r().tag === "blockquote"), e.button.id === "fullscreen" && (A = i()), (e.button.id === "subscript" || e.button.id === "superscript") && r()) {
      const [E] = o().getCursor();
      A = o().getTape().getParent(E, (w) => w.type === (e.button.id === "subscript" ? u : l));
    }
    return A ? "active" : "";
  }), k = /* @__PURE__ */ j(() => e.button.id === "undo" ? s() ? !s()[0] : !0 : e.button.id === "redo" ? s() ? !s()[1] : !0 : e.button.id === "outdent" ? !r().indent : !1);
  function x() {
    switch (e.button.id) {
      case "undo":
        e.api.exec("undo", {});
        break;
      case "redo":
        e.api.exec("redo", {});
        break;
      case "bold":
      case "italic":
      case "underline":
      case "strike":
        e.api.exec("set-text-format", { [e.button.id]: !0 });
        break;
      case "subscript":
        e.api.exec("subscript", {});
        break;
      case "superscript":
        e.api.exec("superscript", {});
        break;
      case "indent":
        e.api.exec("indent", { step: a });
        break;
      case "outdent":
        e.api.exec("outdent", { step: a });
        break;
      case "bulleted-list":
        e.api.exec("insert-list", { type: "bulleted" });
        break;
      case "numbered-list":
        e.api.exec("insert-list", { type: "numbered" });
        break;
      case "link":
        e.api.exec("show-popup", { type: "link" });
        break;
      case "image":
        $t(e.api, "image").handler();
        break;
      case "line":
        e.api.exec("insert-line", {});
        break;
      case "clear":
        e.api.exec("clear-text-format", {});
        break;
      case "quote":
        e.api.exec("set-text-style", { tag: "blockquote" });
        break;
      case "fullscreen":
        e.api.exec("toggle-fullscreen-mode", {});
        break;
      case "print":
        e.api.exec("print", {});
        break;
      case "shortcuts":
        e.api.exec("toggle-shortcut-info", {});
        break;
      default:
        e.button.handler && e.button.handler();
        break;
    }
  }
  Ii(n, {
    get button() {
      return e.button;
    },
    get tooltip() {
      return e.tooltip;
    },
    children: (A, E) => {
      yo(A, {
        get text() {
          return e.button.label;
        },
        get css() {
          return p(_);
        },
        get icon() {
          return p(g);
        },
        onclick: x,
        get type() {
          return p(v);
        },
        get disabled() {
          return p(k);
        }
      });
    },
    $$slots: { default: !0 }
  }), Z();
}
function Dd(n) {
  if (!n || n === "-" || !n.startsWith("#")) return !1;
  n = n.replace("#", ""), n.length === 3 && (n = n[0] + n[0] + n[1] + n[1] + n[2] + n[2]);
  const e = parseInt(n.substr(0, 2), 16) || 0, t = parseInt(n.substr(2, 2), 16) || 0, i = parseInt(n.substr(4, 2), 16) || 0;
  return (e * 299 + t * 587 + i * 114) / 1e3 > 120;
}
function Ld(n, e) {
  if (!n) return "";
  const t = n.split(" ");
  if (t.length < 3) return e(n);
  const i = t.slice(0, 2).join(" "), r = t.slice(2).join(" ");
  return `${e(i)} ${r}`;
}
var Nd = /* @__PURE__ */ L('<div class="wx-colorpicker-cell svelte-cmm3m1"></div>'), Fd = /* @__PURE__ */ L('<div class="wx-colorpicker svelte-cmm3m1" tabindex="0"><div class="wx-colorpicker-preview svelte-cmm3m1"><i></i> <div class="wx-colorpicker-swatch svelte-cmm3m1"></div></div> <i class="wx-colorpicker-dropdown-icon wxi-menu-down svelte-cmm3m1"></i> <!></div>');
function Pd(n, e) {
  X(e, !0);
  const t = fe("wx-i18n").getGroup("richtext");
  let i = I(e, "disabled", 3, !1), r = I(e, "value", 7, ""), o = I(e, "defaultColor", 3, ""), s = I(e, "options", 3, qu), a = z(!1), u = z(null), l, c, d, f;
  function h(w) {
    d = w.navigate, f = w.keydown, l = w.navigate = (S, O) => (T(a, S !== null), p(a) && p(u).querySelector(".wx-dropdown") && T(a, !1), d?.(S, O)), c = w.keydown = (S, O) => {
      switch (S.code) {
        case "Enter":
          T(a, !0);
          break;
        case "Escape":
        case "Tab":
          T(a, !1);
          break;
      }
      return f?.(S, O);
    };
  }
  function g({ id: w }) {
    (w || w === 0) && (r(w), l(null), e.onchange && e.onchange({ value: r() }));
  }
  const _ = () => s().findIndex((w) => w.id === r());
  var v = Fd();
  v.__click = () => l?.(_()), v.__keydown = (w) => c?.(w, _());
  var k = P(v), x = P(k), A = K(x, 2), E = K(k, 4);
  B(E, () => !i(), (w) => {
    mo(w, {
      get items() {
        return s();
      },
      onready: h,
      onselect: g,
      children: (O, D) => {
        let N = () => D?.().option;
        var H = Nd();
        q(() => te(H, "title", Ld(N().label, t) || N().id));
        const b = /* @__PURE__ */ j(() => Dd(N().id));
        q(() => {
          te(H, "style", `background-color: ${N().id ?? ""}`), te(H, "data-id", N().id), de(H, "wx-selected", N().id === r()), de(H, "wx-light-color", p(b));
        }), m(O, H);
      },
      $$slots: { default: !0 }
    });
  }), Re(v, (w, S) => Nt(w, S), () => () => T(a, !1)), oe(v, (w) => T(u, w), () => p(u)), q(() => {
    de(v, "wx-disabled", i()), de(v, "wx-active", p(a)), he(x, `wx-colorpicker-icon ${e.icon ?? ""} svelte-cmm3m1`), te(A, "style", `background-color: ${(r() || o()) ?? ""}`);
  }), m(n, v), Z();
}
V(["click", "keydown"]);
var Od = /* @__PURE__ */ L('<div class="wx-colorpicker-wrapper svelte-1kacsbh"><!></div>');
function Md(n, e) {
  X(e, !0);
  const t = et(), i = () => ae(o, "$cursorState", t), r = () => ae(s, "$defaultStyles", t), { cursorState: o, defaultStyles: s } = e.api.getReactiveState(), a = {
    "text-color": "color",
    "background-color": "background"
  }, u = /* @__PURE__ */ j(() => e.button.id === "text-color" ? "wxo-color-text" : "wxo-color-background"), l = /* @__PURE__ */ j(() => i()[a[e.button.id]] || Vn(e.button.id, i(), r()));
  function c(d) {
    const { value: f } = d;
    if (!f) return;
    const h = a[e.button.id];
    e.api.exec("set-text-color", { [h]: f });
  }
  Ii(n, {
    get button() {
      return e.button;
    },
    get tooltip() {
      return e.tooltip;
    },
    children: (d, f) => {
      var h = Od(), g = P(h), _ = /* @__PURE__ */ j(() => Vn(e.button.id, i(), r()));
      Pd(g, {
        get icon() {
          return p(u);
        },
        get value() {
          return p(l);
        },
        get defaultColor() {
          return p(_);
        },
        onchange: c
      }), m(d, h);
    },
    $$slots: { default: !0 }
  }), Z();
}
function Rd(n, e, t) {
  n.stopPropagation(), e(""), t.onchange && t.onchange({ value: e() });
}
var Bd = /* @__PURE__ */ L("<i></i>"), Hd = /* @__PURE__ */ L('<span class="svelte-1ha4d5g"> </span>'), zd = /* @__PURE__ */ L('<span class="wx-placeholder svelte-1ha4d5g"> </span>'), Ud = /* @__PURE__ */ L('<i class="wx-icon wxi-close svelte-1ha4d5g"></i>'), qd = /* @__PURE__ */ L('<i class="wx-icon wxi-menu-down svelte-1ha4d5g"></i>'), Kd = /* @__PURE__ */ L('<div class="wx-richselect svelte-1ha4d5g" tabindex="0"><div class="wx-label svelte-1ha4d5g"><!></div> <!> <!></div>');
function hr(n, e) {
  X(e, !0);
  let t = I(e, "value", 15, ""), i = I(e, "options", 19, () => []), r = I(e, "textOptions", 3, null), o = I(e, "placeholder", 3, ""), s = I(e, "icon", 3, ""), a = I(e, "disabled", 3, !1), u = I(e, "error", 3, !1), l = I(e, "title", 3, ""), c = I(e, "textField", 3, "label"), d = I(e, "clear", 3, !1), f = z(!1), h = z(null), g, _, v, k;
  function x(b) {
    v = b.navigate, k = b.keydown, g = b.navigate = (y, C) => (T(f, y !== null), p(f) && p(h).querySelector(".wx-dropdown") && T(f, !1), v?.(y, C)), _ = b.keydown = (y, C) => {
      switch (y.code) {
        case "Enter":
          T(f, !0);
          break;
        case "Escape":
        case "Tab":
          T(f, !1);
          break;
      }
      return k?.(y, C);
    };
  }
  let A = /* @__PURE__ */ j(() => t() || t() === 0 ? (r() || i()).find((b) => b.id === t()) : null);
  function E({ id: b }) {
    (b || b === 0) && (t(b), g(null), e.onchange && e.onchange({ value: t() }));
  }
  const w = () => i().findIndex((b) => b.id === t());
  var S = Kd();
  S.__click = () => g?.(w()), S.__keydown = (b) => _?.(b, w());
  var O = P(S), D = P(O);
  B(
    D,
    s,
    (b) => {
      var y = Bd();
      q(() => he(y, `wx-label-icon ${s() ?? ""} svelte-1ha4d5g`)), m(b, y);
    },
    (b) => {
      var y = Q(), C = U(y);
      B(
        C,
        () => p(A),
        (F) => {
          var R = Q(), J = U(R);
          B(
            J,
            () => e.children,
            (W) => {
              var G = Q(), ie = U(G);
              ue(ie, () => e.children, () => p(A)), m(W, G);
            },
            (W) => {
              var G = Hd(), ie = P(G);
              q(() => le(ie, p(A)[c()])), m(W, G);
            }
          ), m(F, R);
        },
        (F) => {
          var R = Q(), J = U(R);
          B(
            J,
            o,
            (W) => {
              var G = zd(), ie = P(G);
              q(() => le(ie, o())), m(W, G);
            },
            (W) => {
              var G = ct(" ");
              m(W, G);
            },
            !0
          ), m(F, R);
        },
        !0
      ), m(b, y);
    }
  );
  var N = K(O, 2);
  B(
    N,
    () => d() && !a() && t(),
    (b) => {
      var y = Ud();
      y.__click = [Rd, t, e], m(b, y);
    },
    (b) => {
      var y = qd();
      m(b, y);
    }
  );
  var H = K(N, 2);
  B(H, () => !a(), (b) => {
    mo(b, {
      get items() {
        return i();
      },
      onready: x,
      onselect: E,
      children: (C, F) => {
        let R = () => F?.().option;
        var J = Q(), W = U(J);
        B(
          W,
          () => e.children,
          (G) => {
            var ie = Q(), Le = U(ie);
            ue(Le, () => e.children, R), m(G, ie);
          },
          (G) => {
            var ie = ct();
            q(() => le(ie, R()[c()])), m(G, ie);
          }
        ), m(C, J);
      },
      $$slots: { default: !0 }
    });
  }), Re(S, (b, y) => Nt(b, y), () => () => T(f, !1)), oe(S, (b) => T(h, b), () => p(h)), q(() => {
    te(S, "title", l()), de(S, "wx-error", u()), de(S, "wx-disabled", a()), de(S, "wx-nowrap", !e.children), de(S, "wx-active", p(f));
  }), m(n, S), Z();
}
V(["click", "keydown"]);
var Gd = /* @__PURE__ */ L('<div class="wx-mode-label svelte-y6lk4b"><i></i> <div class="wx-label-text"> </div></div>'), jd = /* @__PURE__ */ L("<div><!></div>");
function Vd(n, e) {
  X(e, !0);
  const t = et(), i = () => ae(a, "$cursorState", t), r = () => ae(u, "$defaultStyles", t), o = () => ae(l, "$layoutMode", t), s = fe("wx-i18n").getGroup("richtext"), { cursorState: a, defaultStyles: u, layoutMode: l } = e.api.getReactiveState(), c = {
    style: "tag",
    "font-family": "fontFamily",
    "font-size": "fontSize",
    "line-height": "lineHeight"
  }, d = /* @__PURE__ */ j(() => e.button.options.map((x) => ({ ...x, label: s(x.label) })) || []), f = /* @__PURE__ */ j(() => {
    const x = c[e.button.id], A = i()[x];
    return A && A !== "blockquote" ? A : Vn(e.button.id, i(), r());
  }), h = /* @__PURE__ */ j(() => o() === "classic" ? "wxo-fit-width" : "wxo-fit-document"), g = /* @__PURE__ */ j(() => i().align ? `wxo-align-${i().align}` : "wxo-align-left"), _ = /* @__PURE__ */ j(() => e.button.id === "mode" ? p(h) : e.button.id === "align" ? p(g) : e.button.icon || ""), v = /* @__PURE__ */ j(() => e.button.id === "mode" || e.button.id === "align");
  function k(x) {
    const { value: A } = x;
    if (A)
      switch (e.button.id) {
        case "line-height":
          e.api.exec("set-line-height", { lineHeight: A });
          break;
        case "font-family":
          e.api.exec("set-font-family", { fontFamily: A });
          break;
        case "font-size":
          e.api.exec("set-font-size", { fontSize: A });
          break;
        case "style":
          e.api.exec("set-text-style", { tag: A });
          break;
        case "mode":
          e.api.exec("toggle-layout-mode", { mode: A });
          break;
        case "align":
          e.api.exec("align", { align: A });
          break;
      }
  }
  Ii(n, {
    get button() {
      return e.button;
    },
    get tooltip() {
      return e.tooltip;
    },
    children: (x, A) => {
      var E = jd(), w = P(E);
      B(
        w,
        () => p(v),
        (S) => {
          hr(S, {
            get options() {
              return p(d);
            },
            get value() {
              return p(f);
            },
            get icon() {
              return p(_);
            },
            onchange: k,
            children: (D, N = se) => {
              var H = Gd(), b = P(H), y = K(b, 2), C = P(y);
              q(() => {
                he(b, `wx-icon ${N().icon ?? ""} svelte-y6lk4b`), le(C, N().label);
              }), m(D, H);
            },
            $$slots: { default: !0 }
          });
        },
        (S) => {
          hr(S, {
            get options() {
              return p(d);
            },
            get value() {
              return p(f);
            },
            get icon() {
              return p(_);
            },
            onchange: k
          });
        }
      ), q(() => {
        he(E, `wx-richselect-wrapper wx-${e.button.id ?? ""}-wrapper svelte-y6lk4b`), de(E, "wx-richselect-wide", e.button.id === "font-family" || e.button.id === "style");
      }), m(x, E);
    },
    $$slots: { default: !0 }
  }), Z();
}
var Yd = /* @__PURE__ */ L('<div class="wx-separator svelte-1sg3tzl"></div>');
function Wd(n) {
  var e = Yd();
  m(n, e);
}
var Jd = /* @__PURE__ */ L('<div class="wx-tooltip svelte-1asv8n8"> </div>'), Xd = /* @__PURE__ */ L('<div class="wx-tooltip-wrapper svelte-1asv8n8"><!></div>');
function Zd(n, e) {
  X(e, !0);
  let t = z(null), i = z(!1), r = z(M({ top: 0, left: 0 }));
  function o(l) {
    !p(t) || !e.target || !e.label || (l ? setTimeout(
      () => {
        T(r, M(s())), T(i, !0);
      },
      1
    ) : T(r, M(s())));
  }
  function s() {
    const l = e.target.getBoundingClientRect(), c = p(t).getBoundingClientRect(), d = window.innerWidth;
    let f = l.left;
    return l.width > c.width ? f += (l.width - c.width) / 2 : f += l.width / 2 - c.width / 2, f = Math.max(0, f), f = Math.min(f, d - c.width), { top: l.bottom + 2, left: f };
  }
  be(() => o(!0)), Ie(() => o());
  var a = Q(), u = U(a);
  B(u, () => e.target && e.label, (l) => {
    var c = Xd(), d = P(c);
    bi(d, {
      get top() {
        return p(r).top;
      },
      get left() {
        return p(r).left;
      },
      children: (f, h) => {
        var g = Jd(), _ = P(g);
        oe(g, (v) => T(t, v), () => p(t)), q(() => le(_, e.label)), m(f, g);
      },
      $$slots: { default: !0 }
    }), q(() => de(c, "wx-visible", p(i))), m(l, c);
  }), m(n, a), Z();
}
const Qd = (n) => n.preventDefault();
var $d = /* @__PURE__ */ L('<div class="wx-richtext-toolbar svelte-1lilox1"><!></div> <!>', 1);
function ef(n, e) {
  X(e, !0);
  let t = z(null);
  const i = {
    getTooltip: () => p(t),
    setTooltip: (d) => T(t, M(d))
  };
  function r(d) {
    return d.map((f) => f === "separator" ? { type: "separator" } : Tn[f]);
  }
  function o(d) {
    if (!d || !Array.isArray(d)) return r(Uu);
    const f = [];
    function h() {
      return f.length > 0 && f[f.length - 1].type === "separator";
    }
    function g(_) {
      _ && f.push(_);
    }
    for (let _ = 0; _ < d.length; (_ += 1) - 1) {
      const v = d[_];
      if (typeof v == "string") {
        if (v === "separator")
          h() || g({ type: "separator" });
        else {
          const k = Tn[v];
          k && g(k);
        }
        continue;
      }
      if (v.type === "button" || v.type === "richselect" || v.type === "colorpicker") {
        const k = Tn[v.id];
        if (k && k.type !== v.type) continue;
        g(k || (v.type === "button" ? v : null));
        continue;
      }
      v.type === "separator" && !h() && g({ type: "separator" });
    }
    return f;
  }
  const s = /* @__PURE__ */ j(() => o(e.items));
  var a = $d(), u = U(a);
  u.__mousedown = [Qd];
  var l = P(u);
  B(l, () => e.api, (d) => {
    var f = Q(), h = U(f);
    Me(h, 17, () => p(s), Ct, (g, _) => {
      var v = Q(), k = U(v);
      B(
        k,
        () => p(_).type === "separator",
        (x) => {
          Wd(x);
        },
        (x) => {
          var A = Q(), E = U(A);
          Gr(E, () => p(_), (w) => {
            var S = Q(), O = U(S);
            B(
              O,
              () => p(_).type === "colorpicker",
              (D) => {
                Md(D, {
                  get api() {
                    return e.api;
                  },
                  get button() {
                    return p(_);
                  },
                  tooltip: i
                });
              },
              (D) => {
                var N = Q(), H = U(N);
                B(
                  H,
                  () => p(_).type === "richselect",
                  (b) => {
                    Vd(b, {
                      get api() {
                        return e.api;
                      },
                      get button() {
                        return p(_);
                      },
                      tooltip: i
                    });
                  },
                  (b) => {
                    Id(b, {
                      get api() {
                        return e.api;
                      },
                      get button() {
                        return p(_);
                      },
                      tooltip: i
                    });
                  },
                  !0
                ), m(D, N);
              }
            ), m(w, S);
          }), m(x, A);
        }
      ), m(g, v);
    }), m(d, f);
  });
  var c = K(u, 2);
  B(c, () => p(t), (d) => {
    wi(d, {
      children: (f, h) => {
        Zd(f, ra(() => p(t)));
      },
      $$slots: { default: !0 }
    });
  }), Ge("mouseleave", u, () => Bo((d) => T(t, M(d)))), m(n, a), Z();
}
V(["mousedown"]);
var tf = /* @__PURE__ */ L('<div class="wx-resize-handler svelte-13nr9l6"></div>'), nf = /* @__PURE__ */ L('<div class="wx-resizer svelte-13nr9l6"></div>');
function rf(n, e) {
  X(e, !0);
  let t = z(void 0), i = z(void 0), r = z(void 0), o = z(void 0), s, a, u = z(void 0), l = z(void 0);
  const c = 10, d = 10, f = {
    "top-left": { x: -1, y: -1, c: "nwse" },
    top: { x: 0, y: -1, c: "ns" },
    "top-right": { x: 1, y: -1, c: "nesw" },
    right: { x: 1, y: 0, c: "ew" },
    "bottom-right": { x: 1, y: 1, c: "nwse" },
    bottom: { x: 0, y: 1, c: "ns" },
    "bottom-left": { x: -1, y: 1, c: "nesw" },
    left: { x: -1, y: 0, c: "ew" }
  }, h = Object.entries(f), g = h.map((y) => {
    const C = y[1], F = [`cursor:${C.c}-resize;`];
    return C.x < 0 ? F.push(_("left", 0)) : C.x > 0 ? F.push(_("right", 0)) : F.push(_("left", "50%")), C.y < 0 ? F.push(_("top", 0)) : C.y > 0 ? F.push(_("bottom", 0)) : F.push(_("top", "50%")), F.join(";");
  });
  function _(y, C) {
    return `${y}:${C === 0 ? "var(--wx-image-resizer-marker-offset)" : `calc(${C} - var(--wx-image-resizer-marker-size)/2)`}`;
  }
  const v = (y) => {
    y.addEventListener("click", (C) => {
      const F = C.target;
      F.tagName === "IMG" && (p(u) !== F && (p(u) && N(), T(u, M(F)), p(u).classList.add("wx-image-active")), x(), k());
    });
  };
  function k() {
    T(r, M(p(u).offsetLeft)), T(o, M(p(u).offsetTop));
  }
  function x() {
    T(t, M(p(u).offsetWidth)), T(i, M(p(u).offsetHeight)), s = p(t) / p(i);
  }
  function A(y, C, F, R, J, W) {
    return y < 0 && (y = 0), C < 0 && (C = 0), R * J && (y = C * F, y < a.width + R * W && (y = a.width + R * W, C = y / F)), y = Math.round(y), C = Math.round(C), { width: y, height: C };
  }
  function E() {
    p(u).style.width = p(t) + "px", p(u).style.height = p(i) + "px", k();
  }
  function w(y) {
    a = {
      dir: this.getAttribute("data-dir"),
      width: p(t),
      height: p(i),
      left: p(r),
      top: p(o),
      x: y.clientX,
      y: y.clientY
    }, y.preventDefault();
  }
  function S(y) {
    if (a && a.dir) {
      const C = y.clientX - a.x, F = y.clientY - a.y, R = f[a.dir];
      let J = a.width + R.x * C, W = a.height + R.y * F;
      const G = A(J, W, s, R.x, R.y, C);
      T(t, M(Math.max(G.width, c))), T(i, M(Math.max(G.height, d))), R.x < 0 && p(t) && T(r, a.left - p(t) + a.width), R.y < 0 && p(i) && T(o, a.top - p(i) + a.height);
    }
  }
  function O(y) {
    a ? (a = !1, E(), s = p(t) / p(i), e.onresize && e.onresize({
      width: p(t),
      height: p(i),
      id: p(u).getAttribute("data-id") * 1
    })) : y.target !== p(l) && !Ro(y.target) && N();
  }
  function D() {
    p(u) && !a && (x(), k());
  }
  const N = (y) => {
    p(u) && (y != p(u).dataset.id ? (p(u).classList.remove("wx-image-active"), T(u, null)) : (x(), k()));
  };
  var H = Q();
  Ge("mousemove", at, S), Ge("mouseup", at, O), Ge("resize", at, D);
  var b = U(H);
  return B(b, () => p(u), (y) => {
    var C = nf();
    Me(C, 21, () => h, Ct, (F, R, J) => {
      var W = tf();
      W.__mousedown = w, q(() => {
        te(W, "data-dir", p(R)[0]), te(W, "style", g[J]);
      }), m(F, W);
    }), oe(C, (F) => T(l, F), () => p(l)), q(() => te(C, "style", `left:${p(r) ?? ""}px;top:${p(o) ?? ""}px;width:${p(t) ?? ""}px;height:${p(i) ?? ""}px;`)), m(y, C);
  }), m(n, H), Z({ initArea: v, resize: D, resetArea: N });
}
V(["mousedown"]);
function of(n, e) {
  if (n.key === "Escape") {
    e(), n.stopPropagation(), n.preventDefault();
    return;
  }
}
var sf = /* @__PURE__ */ L('<div class="wx-shortcut-row svelte-gzsc8q"><span class="wx-shortcut-action"> </span> <span class="wx-shortcut-key svelte-gzsc8q"> </span></div>'), af = /* @__PURE__ */ L('<div class="wx-shortcut-group svelte-gzsc8q"><div class="wx-shortcut-group-title svelte-gzsc8q"> </div> <div class="wx-shortcut-list svelte-gzsc8q"></div></div>'), lf = /* @__PURE__ */ L('<div class="wx-shortcut-container svelte-gzsc8q" tabindex="0"><div class="wx-shortcut-header svelte-gzsc8q"><div class="wx-shortcut-title svelte-gzsc8q"> </div> <i class="wxi-close wx-icon svelte-gzsc8q"></i></div> <div class="wx-shortcut-content svelte-gzsc8q"></div></div>'), cf = /* @__PURE__ */ L('<div class="wx-shortcut-popup svelte-gzsc8q"><!></div>');
function uf(n, e) {
  X(e, !0);
  const t = et(), i = () => ae(a, "$selection", t), r = () => ae(s, "$document", t), o = fe("richtext-store"), { document: s, selection: a } = o.getReactiveState(), u = fe("wx-i18n").getGroup("richtext");
  let l = z(null);
  const c = [
    {
      group: "Text formatting",
      items: [
        { action: "Bold", hotkey: "Ctrl+B" },
        { action: "Italic", hotkey: "Ctrl+I" },
        { action: "Underline", hotkey: "Ctrl+U" },
        {
          action: "Strikethrough",
          hotkey: "Ctrl+Shift+X"
        }
      ]
    },
    {
      group: "Editing",
      items: [
        { action: "Undo", hotkey: "Ctrl+Z" },
        {
          action: "Redo",
          hotkey: "Ctrl+Y / Ctrl+Shift+Z"
        },
        { action: "Cut", hotkey: "Ctrl+X" },
        { action: "Copy", hotkey: "Ctrl+C" },
        { action: "Paste", hotkey: "Ctrl+V" }
      ]
    },
    {
      group: "Special actions",
      items: [
        { action: "Insert link", hotkey: "Ctrl+K" },
        { action: "Print", hotkey: "Ctrl+P" }
      ]
    }
  ];
  function d(_) {
    return Ei ? Ti(_) : _;
  }
  function f() {
    o.exec("toggle-shortcut-info", { mode: !1 });
  }
  be(() => (p(l)?.focus(), () => jn(i(), r().getCursor())));
  var h = cf(), g = P(h);
  bi(g, {
    oncancel: f,
    children: (_, v) => {
      var k = lf();
      k.__keydown = [of, f];
      var x = P(k), A = P(x), E = P(A);
      q(() => le(E, u("Keyboard shortcuts")));
      var w = K(A, 2);
      w.__click = f;
      var S = K(x, 2);
      Me(S, 21, () => c, Ct, (O, D) => {
        var N = af(), H = P(N), b = P(H);
        q(() => le(b, u(p(D).group)));
        var y = K(H, 2);
        Me(y, 21, () => p(D).items, Ct, (C, F) => {
          var R = sf(), J = P(R), W = P(J);
          q(() => le(W, u(p(F).action)));
          var G = K(J, 2), ie = P(G);
          q(() => le(ie, d(p(F).hotkey))), m(C, R);
        }), m(O, N);
      }), oe(k, (O) => T(l, O), () => p(l)), m(_, k);
    },
    $$slots: { default: !0 }
  }), m(n, h), Z();
}
V(["keydown", "click"]);
async function df(n, e, t, i) {
  await navigator.clipboard.writeText(e.url), t({
    expire: 2e3,
    text: i("Link copied to clipboard")
  });
}
function ff(n, e) {
  if (n.key === "Escape") {
    e(n, "cancel"), n.stopPropagation(), n.preventDefault();
    return;
  }
  if (n.key === "Enter") {
    e(n, "save"), n.preventDefault();
    return;
  }
}
var hf = (n, e) => e(n, "save"), pf = (n, e) => e(n, "cancel"), gf = /* @__PURE__ */ L('<div class="wx-link-form-field svelte-1symo4z"><!></div> <i class="wx-link-icon wxi-check svelte-1symo4z"></i> <i class="wx-link-icon wxi-close svelte-1symo4z"></i>', 1), _f = (n, e) => e(n, "edit"), vf = (n, e) => e(n, "unlink"), xf = /* @__PURE__ */ L('<div class="wx-link-url svelte-1symo4z"><a target="blank"> </a></div> <i class="wx-link-icon wxo-edit svelte-1symo4z"></i> <i class="wx-link-icon wxo-content-copy svelte-1symo4z"></i> <i class="wx-link-icon wxo-unlink svelte-1symo4z"></i>', 1), yf = /* @__PURE__ */ L('<div class="wx-link-light-form svelte-1symo4z"><!></div>');
function mf(n, e) {
  X(e, !0);
  let t = I(e, "edit", 7);
  const i = fe("wx-i18n").getGroup("richtext"), { showNotice: r } = fe("wx-helpers");
  function o(l, c) {
    l.stopPropagation(), c === "edit" ? t(!0) : (c === "save" || c === "cancel") && t(!1), e.onaction && e.onaction({ type: c });
  }
  function s({ value: l }) {
    e.onchange && e.onchange({ value: l, type: "url" });
  }
  var a = yf();
  a.__keydown = [ff, o];
  var u = P(a);
  B(
    u,
    t,
    (l) => {
      var c = gf(), d = U(c), f = P(d);
      Un(f, {
        onchange: s,
        get value() {
          return e.url;
        },
        focus: !0
      });
      var h = K(d, 2);
      h.__click = [hf, o];
      var g = K(h, 2);
      g.__click = [pf, o], m(l, c);
    },
    (l) => {
      var c = xf(), d = U(c), f = P(d), h = P(f), g = K(d, 2);
      g.__click = [_f, o];
      var _ = K(g, 2);
      _.__click = [df, e, r, i];
      var v = K(_, 2);
      v.__click = [vf, o], q(() => {
        te(f, "href", e.url), te(f, "title", e.url), le(h, e.url);
      }), m(l, c);
    }
  ), m(n, a), Z();
}
V(["keydown", "click"]);
function bf(n, e) {
  if (n.key === "Escape") {
    e(n, "cancel"), n.stopPropagation(), n.preventDefault();
    return;
  }
  if (n.key === "Enter") {
    e(n, "save"), n.preventDefault();
    return;
  }
}
var wf = (n, e) => e(n, "save"), kf = (n, e) => e(n, "cancel"), Cf = /* @__PURE__ */ L('<div class="wx-link-form svelte-1lwwwdc"><div class="wx-link-form-header svelte-1lwwwdc"><i class="wx-link-icon wxi-check svelte-1lwwwdc"></i> <i class="wx-link-icon wxi-close svelte-1lwwwdc"></i></div> <div class="wx-link-form-field svelte-1lwwwdc"><!></div> <div class="wx-link-form-field svelte-1lwwwdc"><!></div></div>');
function Sf(n, e) {
  X(e, !0);
  const t = fe("wx-i18n").getGroup("richtext");
  function i(_, v) {
    _.stopPropagation(), e.onaction && e.onaction({ type: v });
  }
  function r({ value: _ }, v) {
    e.onchange && e.onchange({ value: _, type: v });
  }
  var o = Cf();
  o.__keydown = [bf, i];
  var s = P(o), a = P(s);
  a.__click = [wf, i];
  var u = K(a, 2);
  u.__click = [kf, i];
  var l = K(s, 2), c = P(l), d = /* @__PURE__ */ j(() => t("Enter text to display"));
  Un(c, {
    get value() {
      return e.text;
    },
    onchange: (_) => r(_, "text"),
    get placeholder() {
      return p(d);
    }
  });
  var f = K(l, 2), h = P(f), g = /* @__PURE__ */ j(() => t("Paste link"));
  Un(h, {
    get value() {
      return e.url;
    },
    onchange: (_) => r(_, "url"),
    get placeholder() {
      return p(g);
    },
    focus: !0
  }), m(n, o), Z();
}
V(["keydown", "click"]);
function Ef(n, e) {
  X(e, !0);
  const t = et(), i = () => ae(a, "$document", t), r = () => ae(u, "$selection", t), o = 6, s = fe("richtext-store"), { document: a, selection: u } = s.getReactiveState(), { LINK: l, TEXT: c, SPAN: d } = si;
  let f = z(""), h = z(""), g = z(null), _ = z(null);
  const v = /* @__PURE__ */ j(() => e.ctx?.chunk), k = /* @__PURE__ */ j(() => !!e.ctx?.image), x = /* @__PURE__ */ j(() => ({ ...A(p(v)) }));
  function A(C) {
    const F = C?.type !== l, [R, J] = p(_) || i().getCursor(), W = R && J && F;
    return {
      chunk: C,
      create: F,
      text: p(f) || "",
      url: p(h) || C?.props?.url || "",
      showLight: W || !F,
      edit: W ? !0 : F
    };
  }
  function E(C) {
    !p(x).create && !Ro(C.target, ["wx-editor"]) && e.hide(), O();
  }
  function w() {
    p(k) || !p(g) || (p(g).removeAttribute("class"), s.skipAction(() => {
      yt(i(), { tag: d });
    }), T(g, null));
  }
  function S() {
    const { url: C, create: F, text: R, showLight: J } = p(x), W = p(v)?.props?.url || "";
    w(), F && C && (p(k) || s.skipAction(() => Iu(i())), s.exec("insert-link", { url: C }), !J && !p(k) && Au(i(), R || C), Du(i(), c), H()), !F && C && C !== W && s.exec("update-link", { id: p(v).id, url: C }), !C && !F && s.exec("delete-link", {}), b();
  }
  function O() {
    w(), p(x).showLight && T(h, M(p(v)?.props?.url || "")), p(x).create && (e.hide(), H()), b();
  }
  function D(C) {
    const { type: F } = C;
    switch (F) {
      case "unlink":
        s.exec("delete-link", {});
        break;
      case "save":
        S();
        break;
      case "cancel":
        O();
        break;
    }
  }
  function N({ value: C, type: F }) {
    F === "text" && T(f, M(C)), F === "url" && T(h, M(C));
  }
  function H() {
    const C = i().getCursor();
    jn(r(), C);
  }
  function b() {
    T(f, ""), T(h, "");
  }
  be(() => {
    const [C, F] = i().getCursor();
    if (!(p(k) || !F)) {
      if (p(x).create) {
        if (C.id !== F.id) return;
        if (s.skipAction(() => Tu(i(), { tag: d, props: { link: !0 } })), !p(g)) {
          const J = window.getSelection().getRangeAt(0);
          T(g, M(J.startContainer.parentNode)), p(g).className = "wx-link-selection";
        }
      }
      return p(_) || T(_, M(i().getCursor())), () => {
        if (p(k) || !p(g)) return;
        const R = i().getCursor();
        s.skipAction(() => {
          i().setCursor(...p(_)), yt(i(), { tag: d }), i().setCursor(R), jn(r(), R);
        });
      };
    }
  });
  var y = /* @__PURE__ */ j(() => e.pos.y + e.pos.height + (p(k) ? o : 0));
  bi(n, {
    get top() {
      return p(y);
    },
    get left() {
      return e.pos.x;
    },
    oncancel: E,
    children: (C, F) => {
      var R = Q(), J = U(R);
      B(
        J,
        () => p(x).showLight,
        (W) => {
          var G = /* @__PURE__ */ j(() => !!p(x).edit);
          mf(W, {
            get url() {
              return p(x).url;
            },
            get edit() {
              return p(G);
            },
            onaction: D,
            onchange: N
          });
        },
        (W) => {
          Sf(W, {
            get text() {
              return p(x).text;
            },
            get url() {
              return p(x).url;
            },
            onaction: D,
            onchange: N
          });
        }
      ), m(C, R);
    },
    $$slots: { default: !0 }
  }), Z();
}
function Tf(n, e) {
  const t = /* @__PURE__ */ j(() => e.popup.type), i = /* @__PURE__ */ j(() => e.popup.pos);
  var r = Q(), o = U(r);
  B(o, () => p(t) === "link", (s) => {
    Ef(s, {
      get pos() {
        return p(i);
      },
      get ctx() {
        return e.ctx;
      },
      get hide() {
        return e.hide;
      }
    });
  }), m(n, r);
}
var Af = /* @__PURE__ */ L(`<style>@media print {
			body > * {
				display: none;
				padding: 0;
				margin: 0;
			}

			body .wx-printed-area {
				display: block !important;
				min-width: 100%;
				border: none !important;
				padding-right: 10px;
				box-sizing: border-box;
			}
		}</style>`);
function If(n, e) {
  X(e, !0), be(() => {
    bd(e.target);
  }), ri((t) => {
    var i = Af();
    m(t, i);
  }), Z();
}
function Df(n, e, t) {
  const i = p(e)?.chunk;
  (n.ctrlKey || n.metaKey) && i?.type === t && i.props.url && window.open(i.props.url, "_blank");
}
var Lf = /* @__PURE__ */ L('<!>  <div class="wx-richtext svelte-86fkhc"><!> <!> <div class="wx-editor-area svelte-86fkhc"><div class="wx-editor-wrapper svelte-86fkhc"><div class="wx-editor svelte-86fkhc"><div class="wx-editor-content svelte-86fkhc"></div> <!> <!></div></div></div> <!></div>', 1);
function Nf(n, e) {
  X(e, !0);
  const t = et(), i = () => ae(x, "$layoutMode", t), r = () => ae(k, "$document", t), o = () => ae(w, "$_history", t), s = () => ae(E, "$_clipboard", t), a = () => ae(S, "$_print", t), u = () => ae(A, "$popup", t), l = () => ae(O, "$_shortcuts", t), { LINK: c, IMAGE: d, SPAN: f, OTHER: h } = si, g = fe("wx-i18n").getGroup("richtext"), { showNotice: _ } = fe("wx-helpers"), v = fe("richtext-store"), {
    document: k,
    layoutMode: x,
    popup: A,
    _clipboard: E,
    _history: w,
    _print: S,
    _shortcuts: O
  } = v.getReactiveState();
  let D = z(void 0), N = z(void 0), H = z(void 0), b = z(void 0), y = z(void 0);
  const C = /* @__PURE__ */ j(() => i() === "document"), { droparea: F } = v.getUploader().api, R = $t(v, "image").context, J = {
    [c]: (ee, ce) => {
      const [ge] = r().getCursor();
      if (ge.target.nextSibling && ge.target.nextSibling.nodeName === "IMG" || ge.target.previousSibling && ge.target.previousSibling.nodeName === "IMG") {
        ie();
        return;
      }
      T(y, M({ chunk: ce })), G({ type: "link" }), p(b).resetArea();
    },
    [f]: (ee, ce) => {
      ce.props.link || (T(y, M({ chunk: null })), ie());
    },
    [d]: (ee) => {
      if (p(b).resetArea(ee.id), ee.target && ee.target.parentNode.nodeName === "A") {
        const ce = r().getTape(), ge = ce.getParent(ee, (qo) => qo.type === c), _n = ce.getChunk(ge.id);
        T(y, M({ chunk: _n, image: !0 })), G({ type: "link", image: !0 });
        return;
      }
      T(y, M({ chunk: null, image: !0 })), ie();
    },
    [h]: () => {
      p(b).resetArea(), T(y, M({ chunk: null })), ie();
    }
  };
  function W(ee) {
    const [ce, ge] = r().getCursor();
    p(N).render(p(D), r().getTape()), v.updateHistory(o().getState()), p(H).paint(ce, ge), ee && v.exec("change", {});
  }
  function G(ee) {
    v.exec("show-popup", ee);
  }
  function ie() {
    v.exec("show-popup", { type: null });
  }
  function Le(ee) {
    const { id: ce, width: ge, height: _n } = ee;
    v.exec("resize-image", { id: ce, width: ge, height: _n });
  }
  function Pt(ee) {
    ee.name === "NotAllowedError" && _({
      expire: 4e3,
      text: g("Operation failed. Please check your browser's clipboard permissions.")
    });
  }
  function dn() {
    p(b).resize();
  }
  be(() => {
    T(N, M(new sl(al, ll))), T(H, M(new va(p(D), (ce, ge) => {
      v.setCursor(ce, ge, J);
    }))), p(D).innerHTML = "", p(D).setAttribute("role", "textbox"), p(D).setAttribute("contenteditable", "true"), ["cut", "copy", "paste"].forEach((ce) => p(D).addEventListener(ce, (ge) => _i(r(), ce, ge))), r().plugins.change.add(W), r().plugins.action.add(o().call.bind(o()));
    const ee = Qu(v, r());
    p(D).onkeydown = ee.handler.bind(ee), v.postInit(p(H)), r().getValue() !== "<p></p>" && W(), p(b).initArea(p(D));
  }), Ie(() => {
    s() && (s() === "cut" || s() === "copy" ? $u(r(), s() === "cut", Pt) : s() === "paste" && ed(r(), Pt));
  });
  var Ot = Lf(), fn = U(Ot);
  B(fn, a, (ee) => {
    If(ee, {
      get target() {
        return p(D);
      }
    });
  });
  var hn = K(fn, 2), pn = P(hn);
  B(pn, () => e.menubar, (ee) => {
    kd(ee, { api: v });
  });
  var Di = K(pn, 2);
  B(Di, () => e.toolbar, (ee) => {
    ef(ee, {
      api: v,
      get items() {
        return e.toolbar;
      }
    });
  });
  var Li = K(Di, 2), Ho = P(Li), gn = P(Ho), Mt = P(gn);
  Mt.__click = [Df, y, c], Re(Mt, (ee, ce) => td(ee, ce), () => dn), oe(Mt, (ee) => T(D, ee), () => p(D));
  var Ni = K(Mt, 2);
  oe(rf(Ni, { onresize: Le }), (ee) => T(b, M(ee)), () => p(b));
  var zo = K(Ni, 2);
  B(zo, u, (ee) => {
    Tf(ee, {
      get popup() {
        return u();
      },
      get ctx() {
        return p(y);
      },
      hide: ie
    });
  }), Re(gn, (ee, ce) => F(ee, ce), () => R);
  var Uo = K(Li, 2);
  B(Uo, l, (ee) => {
    uf(ee, {});
  }), q(() => de(gn, "wx-document-mode", p(C))), m(n, Ot), Z();
}
V(["click"]);
var Ff = /* @__PURE__ */ L('<div class="wx-fullscreen-mode-wrapper svelte-1p9eybs"></div>'), Pf = /* @__PURE__ */ L('<div class="wx-content-container svelte-1p9eybs"></div>'), Of = /* @__PURE__ */ L('<!> <div class="wx-content-container svelte-1p9eybs"><!></div>', 1);
function Mf(n, e) {
  X(e, !0);
  const t = et(), i = () => ae(o, "$fullscreenMode", t), r = fe("richtext-store"), { fullscreenMode: o } = r.getReactiveState();
  let s = z(null), a = z(null);
  function u(h) {
    h.code === "Escape" && i() && r.exec("toggle-fullscreen-mode", { mode: !1 });
  }
  Ie(() => {
    p(s) && p(a) && p(s).appendChild(p(a));
  });
  var l = Of();
  Ge("keydown", at, u);
  var c = U(l);
  B(
    c,
    i,
    (h) => {
      wi(h, {
        target: document.body,
        children: (g, _) => {
          var v = Ff();
          oe(v, (k) => T(s, k), () => p(s)), m(g, v);
        },
        $$slots: { default: !0 }
      });
    },
    (h) => {
      var g = Pf();
      oe(g, (_) => T(s, _), () => p(s)), m(h, g);
    }
  );
  var d = K(c, 2), f = P(d);
  ue(f, () => e.children ?? se), oe(d, (h) => T(a, h), () => p(a)), m(n, l), Z();
}
const Rf = "wx-uploader-api";
function pr(n, e) {
  Array.from(n.target.files).forEach((i) => e(i));
}
var Bf = /* @__PURE__ */ L('<input type="file" class="input svelte-15jokro"> <!>', 1), Hf = /* @__PURE__ */ L('<div class="dropzone svelte-15jokro"><span>Drop files here or  <span class="action svelte-15jokro">select files</span></span></div>'), zf = /* @__PURE__ */ L('<div class="label svelte-15jokro"><input type="file" class="input svelte-15jokro"> <!></div>');
function Uf(n, e) {
  X(e, !0);
  let t = I(e, "data", 31, () => M([])), i = I(e, "ready", 31, () => M(new Promise(() => ({})))), r = I(e, "accept", 3, ""), o = I(e, "multiple", 3, !0), s = I(e, "folder", 3, !1), a = I(e, "uploadURL", 3, ""), u = I(e, "apiOnly", 3, !1), l = I(e, "disabled", 3, !1), c = z(void 0), d = z(void 0), f = 0, h = {};
  const g = (b, y) => {
    l() || (y = y || {}, b.addEventListener("dragenter", () => {
      y.dragEnter && y.dragEnter(), S();
    }), b.addEventListener("dragleave", () => {
      y.dragEnter && y.dragLeave(), O();
    }), b.addEventListener("dragover", (C) => C.preventDefault(), !0), b.addEventListener(
      "drop",
      (C) => {
        C.preventDefault(), h = y, _(C), y.dragEnter && y.dragLeave();
      },
      !0
    ));
  };
  be(() => {
    p(c).webkitdirectory = s();
  });
  function _(b) {
    Array.from(b.dataTransfer.items).forEach((C) => {
      const F = C.webkitGetAsEntry();
      F && v(F);
    }), T(d, !1), f = 0;
  }
  function v(b, y) {
    y = y || "", b.isFile ? b.file((C) => {
      k(C);
    }) : b.isDirectory && b.createReader().readEntries((F) => {
      F.forEach((R) => {
        v(R, y + R.name + "/");
      });
    });
  }
  function k(b) {
    const y = {
      ...h,
      id: yi(),
      status: "client",
      name: b.name,
      file: b
    };
    y.selected && y.selected(y), e.onchange && e.onchange(y), o() ? t([...t(), y]) : t([y]), A(y), p(c).value = "";
  }
  function x(b) {
    const y = new FormData();
    y.append("upload", b.file);
    const C = { method: "POST", body: y };
    return fetch(a(), C).then((F) => F.json()).then((F) => ({ id: b.id, ...F }), () => ({ id: b.id, status: "error" })).catch((F) => console.log(F));
  }
  function A(b) {
    if (!b) return;
    const y = typeof a() == "function" ? a()(b) : x(b);
    i(y.then((C) => {
      C.status = C.status || "server", w(b.id, C);
    }).catch((C) => {
      w(b.id, { status: "error", error: C });
    }));
  }
  function E() {
    let b = "server";
    for (let y = 0; y < t().length; (y += 1) - 1) {
      if (t()[y].status === "client") return "client";
      t()[y].status === "error" && (b = "error");
    }
    return b;
  }
  function w(b, y) {
    const C = t().findIndex((J) => J.id == b), F = t(t()[C] = { ...t()[C], ...y }, !0), R = { ...F, status: E() };
    F && F.uploaded && F.uploaded(R), e.onupload && e.onupload(R), F.temp && t(t().filter((J) => J.id != b));
  }
  function S() {
    f === 0 && T(d, !0), f += 1;
  }
  function O() {
    f -= 1, f === 0 && T(d, !1);
  }
  function D(b) {
    h = b || {}, p(c).click();
  }
  Lt(Rf, { open: D, getState: E, droparea: g });
  var N = Q(), H = U(N);
  return B(
    H,
    u,
    (b) => {
      var y = Bf(), C = U(y);
      C.__change = [pr, k], oe(C, (R) => T(c, R), () => p(c));
      var F = K(C, 2);
      ue(F, () => e.children ?? se), q(() => {
        te(C, "accept", r()), C.multiple = o(), C.disabled = l();
      }), m(b, y);
    },
    (b) => {
      var y = zf(), C = P(y);
      C.__change = [pr, k], oe(C, (R) => T(c, R), () => p(c));
      var F = K(C, 2);
      B(
        F,
        () => e.children,
        (R) => {
          var J = Q(), W = U(J);
          ue(W, () => e.children, () => ({ open: D })), m(R, J);
        },
        (R) => {
          var J = Hf(), W = P(J), G = K(P(W));
          G.__click = D, m(R, J);
        }
      ), Re(y, (R) => g(R)), q(() => {
        de(y, "active", p(d)), de(y, "wx-disabled", l()), te(C, "accept", r()), C.multiple = o(), C.disabled = l();
      }), m(b, y);
    }
  ), m(n, N), Z({ droparea: g, getState: E, open: D });
}
V(["change", "click"]);
V(["click"]);
function qf(n, e) {
  X(e, !0);
  let t = I(e, "imageUploadUrl", 3, ""), i = I(e, "uploaderCtx", 15);
  const r = "https://export.dhtmlx.com/richtext/import/docx", o = {
    image: { accept: "image/*", fieldName: "upload" },
    docx: {
      accept: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      fieldName: "document"
    }
  };
  let s = z("image"), a = z(null), u = M({ image: null, docx: null });
  const l = /* @__PURE__ */ j(() => o[p(s)].accept || "");
  function c(g) {
    return g === "docx" || g === "doc" ? "docx" : "image";
  }
  function d(g) {
    return g.type === o.docx.accept ? "docx" : "image";
  }
  function f(g) {
    const _ = c(g);
    return u[_] || (_ === "docx" ? r : t());
  }
  function h(g) {
    const _ = d(g.file), v = o[_].fieldName, k = f(_), x = new FormData();
    return x.append(v, g.file), fetch(k, { method: "POST", body: x }).then((A) => A.json()).then((A) => ({ id: g.id, ...A }), () => ({ id: g.id, status: "error" })).catch((A) => console.log(A));
  }
  Ie(() => {
    i({
      api: p(a),
      getUploadUrl: f,
      setUploadUrl(g, _) {
        const v = c(g);
        u[v] = _;
      },
      resetUploadUrl(g) {
        if (!g) {
          u.image = null, u.docx = null;
          return;
        }
        const _ = c(g);
        u[_] = null;
      },
      openDialog(g, _) {
        p(a) && (T(s, M(c(g))), setTimeout(
          () => {
            p(a).open({
              uploaded: (v) => {
                _ && _(v);
              }
            });
          },
          0
        ));
      }
    });
  }), oe(
    Uf(n, {
      apiOnly: !0,
      uploadURL: h,
      get accept() {
        return p(l);
      },
      multiple: "false"
    }),
    (g) => T(a, M(g)),
    () => p(a)
  ), Z();
}
var Kf = /* @__PURE__ */ L("<!> <!>", 1);
function Gf(n, e) {
  X(e, !0);
  let t = I(e, "imageUploadUrl", 3, ""), i = I(e, "value", 3, ""), r = I(e, "toolbar", 3, !0), o = I(e, "menubar", 3, !1), s = I(e, "defaultStyles", 19, () => ({})), a = I(e, "fullscreenMode", 3, !1), u = I(e, "layoutMode", 3, "classic"), l = I(e, "init", 3, null), c = /* @__PURE__ */ na(e, [
    "$$slots",
    "$$events",
    "$$legacy",
    "imageUploadUrl",
    "value",
    "toolbar",
    "menubar",
    "defaultStyles",
    "fullscreenMode",
    "layoutMode",
    "init"
  ]), d = z(void 0);
  const f = new zu(la);
  let h = f.in;
  const g = /-/g;
  let _ = new Nc((G, ie) => {
    const Le = "on" + G.replace(g, "");
    c[Le] && c[Le](ie);
  });
  h.setNext(_);
  const v = f.getState.bind(f), k = f.getReactive.bind(f), x = () => ({ data: f }), A = h.exec, E = (G) => _ = _.setNext(G), w = h.intercept.bind(h), S = h.on.bind(h), O = h.detach.bind(h), D = (G) => f.getValue(G), N = (G, ie) => f.setValue(G, ie), H = (G) => G ? new Promise((ie) => setTimeout(() => ie(p(d)), 1)) : p(d), b = {
    exec: A,
    setNext: E,
    intercept: w,
    on: S,
    detach: O,
    getState: v,
    getReactiveState: k,
    getStores: x,
    getValue: D,
    setValue: N,
    getUploader: H
  };
  Lt("richtext-store", {
    getState: f.getState.bind(f),
    getReactiveState: f.getReactive.bind(f),
    exec: h.exec.bind(h),
    postInit: f.postInit.bind(f),
    setCursor: f.setCursor.bind(f),
    updateHistory: f.updateHistory.bind(f),
    skipAction: f.skipAction.bind(f),
    getUploader: () => p(d)
  });
  let y = !0;
  const C = () => {
    f.init({
      defaultStyles: s(),
      layoutMode: u(),
      fullscreenMode: a()
    }), y && (F(), l() && l()(b), y = !1);
  };
  C(), Ie(C);
  function F() {
    const G = new el();
    f.preInit(G, new cl()), G.setValue(i());
  }
  var R = Kf(), J = U(R);
  qf(J, {
    get imageUploadUrl() {
      return t();
    },
    get uploaderCtx() {
      return p(d);
    },
    set uploaderCtx(G) {
      T(d, M(G));
    }
  });
  var W = K(J, 2);
  return yc(W, {
    words: { ...ki, ...wo },
    optional: !0,
    children: (G, ie) => {
      var Le = Q(), Pt = U(Le);
      B(Pt, () => p(d), (dn) => {
        Mf(dn, {
          children: (Ot, fn) => {
            ec(Ot, {
              children: (hn, pn) => {
                Nf(hn, {
                  api: b,
                  get toolbar() {
                    return r();
                  },
                  get menubar() {
                    return o();
                  },
                  get defaultStyles() {
                    return s();
                  }
                });
              },
              $$slots: { default: !0 }
            });
          },
          $$slots: { default: !0 }
        });
      }), m(G, Le);
    },
    $$slots: { default: !0 }
  }), m(n, R), Z({
    getState: v,
    getReactiveState: k,
    getStores: x,
    exec: A,
    setNext: E,
    intercept: w,
    on: S,
    detach: O,
    getValue: D,
    setValue: N,
    getUploader: H
  });
}
var jf = /* @__PURE__ */ L('<link rel="stylesheet" href="https://cdn.dhtmlx.com/fonts/wxo/wxo-icons.css">');
function Vf(n, e) {
  X(e, !0);
  let t = I(e, "fonts", 3, !0);
  var i = Q();
  ri((o) => {
    var s = Q(), a = U(s);
    B(a, t, (u) => {
      var l = jf();
      m(u, l);
    }), m(o, s);
  });
  var r = U(i);
  B(
    r,
    () => e.children,
    (o) => {
      or(o, {
        get fonts() {
          return t();
        },
        children: (s, a) => {
          var u = Q(), l = U(u);
          ue(l, () => e.children), m(s, u);
        },
        $$slots: { default: !0 }
      });
    },
    (o) => {
      or(o, {
        get fonts() {
          return t();
        }
      });
    }
  ), m(n, i), Z();
}
function Yf(n, e, t) {
  const i = document.createElement("DIV");
  i.className = "wx-theme", n.appendChild(i);
  let r = window.getComputedStyle(i).getPropertyValue("--wx-theme-name");
  return n.removeChild(i), (e && e !== r || !e && !r && t) && (r && n.classList.remove(`wx-${r}-theme`), r = e || t, n.classList.add(`wx-${r}-theme`)), r;
}
const gr = {
  material: Vf
};
class Wf {
  api;
  config;
  container;
  _richtext;
  constructor(e, t) {
    this.container = typeof e == "string" ? document.querySelector(e) : e, this.config = t, this._init();
  }
  destructor() {
    Bs(this._richtext), this._richtext = this.api = null;
  }
  getValue(e) {
    return this.api.getValue(e);
  }
  setValue(e, t) {
    this.api.setValue(e, t);
  }
  setConfig(e) {
    this.config = { ...this.config, ...e }, this._init();
  }
  setLocale(e) {
    this.setConfig({ locale: e });
  }
  _init() {
    this._richtext && this.destructor();
    const e = Yf(
      this.container,
      this.config.theme?.name,
      "material"
    ), t = /* @__PURE__ */ new Map([
      ["wx-i18n", mi(this.config.locale)],
      ["wx-theme", e]
    ]);
    gr[e] && Mi(gr[e], {
      target: this.container,
      props: { fonts: this.config.theme?.fonts }
    }), this._richtext = Mi(Gf, {
      target: this.container,
      props: this.config,
      context: t,
      intro: !1
    }), this.api = this._richtext;
  }
}
const Jf = {
  fromHTML: co,
  toHTML: ao
}, Xf = {
  fromText: il,
  toText: nl
};
const Zf = {
  en: { ...ki, ...wo },
  de: { ...xc, ...Lc },
  cn: { ...hc, ...Dc }
};
export {
  Wf as Richtext,
  Uu as defaultToolbarButtons,
  Jf as html,
  Zf as locales,
  Xf as text
};
